import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint sonarjs/no-duplicate-string: 0 */


import { extendTheme } from "native-base";
import baseTheme from "./base.theme";
import Platform from "react-native-web/dist/cjs/exports/Platform"; // Define the config

var config = {
  colors: {
    primary: {
      100: "#73994A",
      200: "#73994A",
      300: "#DF4505",
      // TODO: replace this placeholder with appropriate color (this is for the focusring and hover to work)
      400: "#73994A",
      500: "#73994A",
      600: "#73994A"
    },
    secondary: {
      100: "#D7BA8A",
      200: "#D38232",
      300: "#73994A"
    },
    background: {
      100: "#F9F7F0",
      200: "#EBE9E9",
      300: "#DAD4D5",
      400: "#F9F7F0"
    },
    indicatorBannerColors: {
      indicatorBannerColor_NI: "#C6653B",
      indicatorBannerColor_LT: "#a8b341",
      indicatorBannerColor_CSK_B: "#b3292d",
      indicatorBannerColor_Default: "#C6653B"
    },
    outletLocationRestText: "#73994A",
    orderOnlineHomeButton: "#73994A",
    errorModalHeaderBg: "#F9F7F0",
    circularAddBtn: "#73994A",
    locationListBtn: "#73994A",
    startBgColor: "#F9F7F0",
    secondary200Mobile: "#73994A",
    confirmationModalOptionBg: "#F9F7F0",
    asapOptionBg: "#F9F7F0",
    asapTextColor: "#989182",
    emptyCartHeaderBgColor: "#F2EFEA",
    menuItemCardBg: "#F9F7F0",
    menuButtonBackgroundColor: "#73994A",
    orderSettingsTextColor: "#73994A",
    categoriesText: "#73994A",
    modalCategoriesText: "#73994A",
    inActiveCategoriesText: "#989182",
    inActiveModalCategoriesText: "#606060",
    menuItemAddButtonColor: "#73994A",
    menuDetailsMobileHeaderText: "#73994A",
    menuItemNameColor: "#73994A",
    cartHeaderOrderType: "#282C25",
    cartHeaderLocationName: "#73994A",
    configOptionsAccordionBackground: "#72994C",
    hStackArrowsColor: "#72994C",
    menuDetailsModifiersBorderColor: "#73994A",
    menuDetailsBackToMenu: "#73994A",
    infoLinkColor: "#73994A",
    legalDisclaimerText: "#70695c",
    headerBackground: "white",
    headerBackgroundTop: "white",
    sliderItemColor: "#72994C",
    btnHoverColor: "#5A783A",
    timeDropDownBg: "#FFFFFF",
    reservationsCardBg: "#fff",
    modalLightBg: "#FFFFFF",
    modalDarkBg: "#FFFFFF",
    itemAddToCartPopupBackground: "#73994A",
    confirmPickupDetailsText: "#72994C",
    defaultMenuTextColor: "#020001",
    orderConfirmationTextColor: "#72994C",
    previousOrderItemStatus: "#73994A",
    defaultMenuBannerBg: "#F9F7F0",
    selectedOptionBorderColor: "#73994A",
    scrollToTopColor: "#73994A",
    menuItemCardBorder: "transparent",
    menuItemPriceColor: "#73994A",
    menuItemCalorieColor: "#73994A",
    refreshIconColor: "#73994A",
    accordionDescription: "white",
    searchResultsName: "#303030",
    tempSilderText: "#BA685C",
    selectTemperatureAccordian: "transparent",
    categoryNavBgColor: "#F9F7F0",
    plusIconColor: "#73994A",
    specialInstArrowColor: "black",
    itemIsFor: "#606060",
    downArrowColor: "#020001",
    mobileBg: "#FFFFFF",
    itemIsForName: "#282C25",
    cartPhoneNumber: "#73994A",
    cartItemActionBtn: "#73994A",
    cartItemPrice: "#73994A",
    cartNoOfItemsText: "#B31900",
    selectedMenuCategoryBorder: "#73994A",
    orderSettingsDesktop: "#989182",
    orderSettingsMobile: "#989182",
    cartItemTitle: "#989182",
    specialInstructions: "#282C25",
    cartItemOption: "#989182",
    menuDetailsSliderItemBackground: "#F9F7F0",
    menuDetailItemNameColor: "#70695c",
    menuDetailsItemPriceColor: "#70695c",
    ninjaIconColor: "#73994A",
    menuDetailsItemDescriptionColor: "#282C25",
    menuDetailsItemCaloriesCaolor: "#73994a",
    menuDetailsSliderHoverColor: "#73994A",
    loginModalTextColor: "#73994A",
    hStackArrowsBg: "#FDFDFDD9",
    requiredTextColor: "#73994A",
    menuDetailAccordionTextColor: "#989182",
    menuDetailModifyOrRemoveColor: "#464838",
    locationConfirmationHeadings: "#73994A",
    locationListingItemHeading: "#989182",
    locationListingItemHeadingMobile: "#73994A",
    locationListingItemText: "#989182",
    reorderInfoTextColor: "#282C25",
    menuDetailAccordionDownArrowColor: "#73994A",
    recommendationaInfoTextColor: "#282C25",
    reOrderAddBtnBorder: "#73994A",
    recommendationHeadingColor: "#020001",
    sliderWithButtonsBackground: "#FFFFFFE5",
    orderSettingsDateTimeChoiceColor: "#2D2926",
    themeDisableButton: "#E5E5E5",
    orderConfirmationDivider: "#E5E5E5",
    menuDetailsAccordionDetailsBackground: "#F4F4F3",
    menuDetailsAccordionDetailsBackgroundNotDefaultExpanded: "#F4F4F3",
    locationsNear: "#2A2C25",
    categoryBoxDivider: "#D6D6D6",
    firstCategoryBoxDivider: "#D6D6D6",
    remoteCheckinWaitTimeHeaderText: "rgba(115, 153, 74, 1)",
    remoteCheckinWaitTimeText: "rgba(115, 153, 74, 1)",
    remoteCheckinWaitTime: "rgba(96, 96, 96, 1)",
    remoteCheckinRefreshBtnColor: "#73994A",
    remoteCheckinRefreshBtnBg: "#FFFFFF",
    categoryBoxTop: "#D6D6D6",
    categoryBoxBottom: "#D6D6D6",
    quantityArrowColor: "#73994A",
    textCTAColor: "#73994A",
    orderSettingsDivider: "#D6D6D6",
    orderSettingsDividerMobile: "#D6D6D6",
    orderSettingsBorder: "#D6D6D6",
    modalTextColor: "#020001",
    selectedCarouselItemWithoutImage: "#F9F7F0",
    unselectedCarouselItemWithoutImage: "#ffff",
    checkoutButtonBackgroundColor: "#73994A",
    selectedListItem: "#F9F7F0",
    // NEED
    menuListTooltipBg: "#73994A",
    menuListTooltipColor: "#FFFFFF",
    menuDetailTooltipBg: "#54301A",
    menuDetailTooltipColor: "#FFFFFF",
    themeErrorTextColor: "#AF272F",
    themeErrorColor: "#C03838",
    youMightLikeBannerColor: "#73994A",
    newIndicatorBannerColor: "#C6653B",
    skuUnavaliableTextColor: "#A2402A",
    menuDetailTemparatureSliderLabelColor: "#303030",
    globalBannerBg: "#f9f7f0",
    deliveryModalHeadingColor: "#2A2C25",
    deliveryModalBrandColor: "#54301A",
    bannerDropShadow: "#5F2C2D",
    deliveryModalNameColor: "#A2402A",
    addressTextColor: "#989182",
    notSelectedOptionBorderColor: "#D7D7D7",
    // OLD COLORS
    themeTextFieldBoundary: "#DEDEDE",
    themeSectionSeparator: "#D6D6D6",
    themeSectionSeparatorDark: "#979797",
    listItemDivider: "#D6D6D6",
    cartNumberText: "#ffff",
    themeSectionTextDark: "#8A8A8A",
    backLinkColor: "#73994A",
    themeTextColor: "#989182",
    legalDesclaimerText: "#989182",
    themeGrey: "#606060",
    popoverBg: "#F2EFEA",
    separatorLineColor: "#2A2C25",
    categoryHeaderSeparator: "#EAEAEA",
    legalTextContainerBg: "#EFEFEF",
    menuLinksColor: "#989182",
    themeDarkGrey: "#2E2A26",
    orderInfoBg: "#ffff",
    specialInstInputBg: "#ffff",
    locationListItemBorder: "transparent",
    allLocationsSelectBgMobile: "#F9F7F0",
    allLocationsSelectBgDesktop: "#ffffff",
    locationCardBg: "#ffff",
    locationDropdownBg: "#ffff",
    allLocationsSelectBorderColorMobile: "#DEDEDE",
    allLocationsSelectBorderColorDesktop: "#DEDEDE",
    allLocationsItemBoxBorderColor: "#DEDEDE",
    allLocationsBodyBgMobile: "#ffffff",
    allLocationsBodyBgDesktop: "#F9F7F0",
    allLocationsSelectBorderColor: "#D6D6D6",
    confirmPickupDetailsChangeBtnBorder: "#73994A",
    // order tracking page
    orderStatusText: "#4D2C42",
    orderStatusCircleBg: "#4D2C42",
    locaionAndTimeHeaderBg: "#F9F7F0",
    locaionAndTimeHeaderBorder: "#DCDCDC",
    borderColorCallSection: "#DCDCDC",
    payNowButtonBg: "#73994A",
    curbsideCheckInPrimary: "#FFFFFF",
    curbsideCheckInSecondary: "#73994A",
    orderStatusSectionBg: "#F4F4F4",
    refreshButtonColor: "#73994A",
    checkText: "#303030",
    curbsideCheckInAvailable: "#7C7C7C",
    refreshButtonBg: "#FFFFFF",
    orderStatusSectionBorderColor: "#F4F4F4",
    // order tracking page end
    // NOT USED
    nutritionalHTMLColor: "#020001",
    reorderHeadingsText: "#020001",
    checkoutBorderColor: "transparent",
    categoriesHeadingColor: "#73994a",
    categoriesDescriptionColor: "#73994a",
    itemUnavailableCardBg: "#F9F7F0",
    itemCardBg: "#F9F7F0",
    itemCardBgLight: "#F9F7F0",
    orderConfirmationCustomerEmail: "#494949",
    // ORDER CONFIRMATION START
    orderConfirmationBackground: "#F6F6F6",
    confirmationPrimary: "#73994A",
    confirmationSecondary: "#303030",
    confirmationAccent: "#2A2C25",
    confirmationAccentLight: "#666666",
    confirmationAccentDark: "#303030",
    confirmationCheckbox: "#73994A",
    confirmationThemeDark: "#000000",
    confirmationThemeLight: "#EEEEEE",
    confirmationThemeGrey: "#B0B0B0",
    podBackground: "white",
    confirmationSpecialInstructionsBg: "#EEEEEE",
    // ORDER CONFIRMATION END
    categoriesPopupInactive: "#606060",
    categoriesPopupBg: "white",
    bodyBg: "transparent",
    quickAddModalBg: "white",
    cardColor: "#F9F7F0",
    menuInfoBackgroundMobile: "#FFFFFF",
    menuInfoBackgroundDesktop: "#F9F7F0",
    selectedSKUItem: "#F9F7F0",
    nonSelectedSkuItem: "white",
    configOptionBg: "white",
    nonSelectedListItem: "white",
    selectedListItemWithImage: "white",
    nonExpandedAccordionBackground: "#F9F7F0",
    selectedDescriptionText: "#020001",
    remoteCheckinWaitTimeBg: "#F9F7F0",
    remoteCheckinWaitTimeBorderTwo: "rgba(115,153, 74, 0.1)",
    remoteCheckinWaitTimeBorderOne: "rgba(115,153, 74, 0.2)",
    remoteCheckinWaitTimeInnerBorder: "rgba(115,153, 74, 1)",
    remoteCheckinWaitTimeCircleBg: "#FFFFFF",
    remoteCheckinPartySizeText: "#282C25",
    carouselBorderColor: "#D6D6D6",
    signInTextColor: "#989182",
    registerTextColor: "#989182",
    recommendationsHeadingColor: "#989182",
    capacityInfoText: "#989182",
    selectedStateColor: "#2A2C25",
    pickupDateTimeText: "#989182",
    quantityColor: "#000000",
    timeDropdownColor: "#989182",
    searchKeywordHighlightColor: "#73994A",
    waitlistBannerBg: "#73994A",
    waitlistTableHeaderBg: "#F8F8F8",
    selectedWaitlistRow: "#F9F7F0",
    waitlistFooterBorderTop: "#B0B0B0",
    waitlistBottomBackground: "#F9F7F0",
    waitlistDisclaimer: "#282C25",
    //Menu search
    searchModalCategoryListBg: "#F6F6F6",
    searchIconContainerBgColor: "#DF4505",
    mobilePayUserLoginBackground: "#FFFFFF",
    mobilePayUserLoginButtonTextColor: "#FFFFFF",
    mobilePayBodyTextColor: "#606060",
    // new
    profileHeaderBackground: "#73994A",
    locationTopTabColor: "#73994A",
    grey300: "#303030",
    reoderInfoTextColor: "#404040",
    mobilePayNotYourCheckTextColor: "#606060",
    mobilePayReachOutSubTextColor: "#782434",
    onboardingButtonTextColor: "#FFFFFF",
    mobileAppAuthBg: "white",
    smartRecommendationCardbg: "white",
    myReservationsBoxBg: "white",
    mobileAuthOrDividerBorderColor: "#CDCFD5",
    mobileAuthOrTextColor: "#737373",
    mobileAuthFooterPassiveText: "#808080",
    mobileAuthFooterActiveText: "#73994A",
    mobileAuthTransparentBg: "rgba(0, 0, 0, 0.7)",
    mobileCriticalModeHeding: "#606060",
    mobileCriticalModeText: "#959595",
    mobileCreateAccountDetailsSectionBackgroundColor: "#FFFFFF",
    mobileCreateAccountButtonTextColor: "#FFFFFF",
    mobileCreateAccountLegalNoticesColor: "#cb7034",
    mobileCriticalModeBg: "#E5E5E5",
    mobileForgotPasswordHeding: "#606060",
    linearGradientTransparent: "rgba(255,255,255,0)",
    linearGradientWhite: " rgba(255,255,255,1)",
    linearGradientCardDarkShade: "rgba(54, 26, 5, 0.84)",
    linearGradientCardLightShade: "rgba(54, 26, 5, 0.44)",
    linearGradientCardTransparent: "rgba(35,34,30,0)",
    linearGradientHeaderDark: "rgba(68, 59, 53, 0.5)",
    linearGradientHeaderLight: "rgba(105, 86, 76, 0.2)",
    ratingCardTitle: "#2A2C25",
    ratingCardSubheaderText: "#606060",
    ratingCardBodyHeader: "#606060",
    ratingCardTextAreaBorderColor: "F3F4EA",
    ratingCardTextAreaWordCount: "rgba(0, 0, 0, 0.4)",
    ratingCardSubmitButton: "#A2402A",
    ratingCardSubmitButtonText: "#FFFFFF",
    ratingCardDismissButtonText: "#808080",
    mobileForgotPasswordHeading: "#606060",
    mobileResetPasswordText: "#606060",
    mobileCustomBrandModalBg: "#F8F7F6",
    lunchIssueModalBody: "#F8F7F6",
    lunchIssueModalSeparator: "#EBE9E9",
    restaurantDetailsDataText: "#303030",
    mobileHeaderBg: "rgba(255, 255, 255, 0.9)",
    routerNavigationHeaderColor: "rgba(0, 0, 0, 0.7)",
    displayImageFallbackBackground: "#C6C6C6",
    mobileOrderDetailsBanner: "#F5F7E8",
    mobileOrderDetailsDisabledButton: "#C6C6C6",
    mobileOrderDetailsBg: "white",
    locationModalHeadingColor: "#2A2C25",
    locationModalBodyDataColor: "#808080",
    locationModalDividerColor: "#C6C6C6",
    restaurantsTimingDetails: "#606060",
    restaurantLabelColor: "#606060",
    joinWaitlistColor: "#B31900",
    disableJoinWaitlistColor: "#C6C6C6",
    waitlistHeaderAddressHeaderBorder: "#D6D6D6",
    mobileSelectedVehicleTypeBg: "#F4F4F4",
    mobileSliderSeparator: "#BEBEBE",
    locationInfographicModalTextColor: "#606060",
    locationInfographicModalActionButtonTextColor: "#FFFFFF",
    inputPlaceholderTextColor: "#303030",
    restaurantInfoNumberAndDistanceTextColor: "#73994A",
    restaurantDetailsHeaderBackground: "#FFFFFF",
    amenitiesHeadingColor: "#73994A",
    amenitiesDividerColor: "rgba(0,0,0,0.2)",
    amenitiesActionButtonsColor: "#73994A",
    currentStatusAndWaitlistDividerColor: "rgba(0,0,0,0.1)",
    restaurantWaitlistTextColor: "#606060",
    joinWaitlistButtonColor: "#B31900",
    orderFromHereButtonTextColor: "#FFFFFF",
    restaurantAboutSectionHeadingTextColor: "#73994A",
    restaurantAboutSectionBodyTextColor: "#303030",
    restaurantImageBorderColor: "#FFFFFF",
    restaurantNumberAndDistanceDividerColor: "rgba(0,0,0,0.20)",
    restaurantHoursTextColor: "#73994A",
    waitlistRestaurantInfoBoxText: "#54301A",
    restaurantSpecialDayHeadingTextColor: "#303030",
    restaurantSpecialDayBodyTextColor: "#606060",
    restaurantTimingsHeadingTextColor: "#73994A",
    restaurantTimingsDividerColor: "rgba(0,0,0,0.1)",
    restaurantDetailsSeparatorDividerColor: "rgba(0,0,0,0.1)",
    restaurantTimingsTextColor: "#303030",
    locationTabNavigationNotFocusedTabText: "#606060",
    locationInfographicLoginBackgroundColor: "#FFFFFF",
    locationOverlayMyLocationsTitles: "#303030",
    locationOverlayMyLocationsScrollView: "#FFFFFF",
    locationOverlaySelectLocationColor: "#2A2C25",
    noRecentLocationsTextColor: "#606060",
    searchThisAreaText: "#FFFFFF",
    selectedWeekDayColor: "#223E6A",
    notSelectedWeekDayColor: "#FFFFFF",
    weekDayBorderColor: "#DCDCDC",
    currentWeekDayIndicator: "#49909B",
    mobileScrollableMenuTab: "#F8F8F8",
    orderConfirmationThanksSubHeaderColor: "#505050",
    pickupRestaurantTitle: "#737373",
    pickupRestaurantName: "#303030",
    pickupRestaurantAddress: "#606060",
    pickMyOrderCardTitle: "#303030",
    pickUpMyOrderHStackText: "#303030",
    bottomSheetTitleColor: "#303030",
    errorModalBackgroundColor: "rgba(29, 26, 26, 0.88)",
    errorModalTitleColor: "#2A2C25",
    errorModalSubTitleTextColor: "#606060",
    errorModalOKButtonTextColor: "#FFFFFF",
    addCardModalValidWarningTextColor: "#D30000",
    cardExpiredColor: "#D51010",
    saveCardCheckbox: "#737373",
    saveCardAddButtonTextColor: "#FFFFFF",
    enterCVVSubTitle: "#606060",
    enterCVVPlaceholderText: "#606060",
    enterCVVTooltipBgColor: "#e3e3e3",
    enterCVVValidWarningTextColor: "#D30000",
    enterCVVConfirmButtonDisabledColor: "#C6C6C6",
    enterCVVConfirmButtonTextColor: "#FFFFFF",
    mobilePaymentMethodIconBg: "#F6F6F6",
    mobilePaymentsCardTextColor: "white",
    mobileGiftCardGradientFirst: "#AAC191",
    mobileGiftCardGradientSecond: "#73994A",
    mobileMasterCardGradientFirst: "#1D338F",
    mobileMasterCardGradientSecond: "#1D338F",
    mobileMasterCardGradientThird: "#286F97",
    mobileVisaGradientFirst: "#0B765C",
    mobileVisaGradientSecond: "#0B765C",
    mobileVisaGradientThird: "#13770B",
    mobileDiscoverGradientFirst: "#95989F",
    mobileDiscoverGradientSecond: "#D1D5D8",
    mobileDiscoverGradientThird: "#93969B",
    mobileAmericanExpressGradientFirst: "#1B1B1D",
    mobileAmericanExpressGradientSecond: "#5E5E62",
    mobileAmericanExpressGradientThird: "#1E1E20",
    mobileJcbCardGradientFirst: "#001741",
    mobileJcbCardGradientSecond: "#195182",
    mobileJcbCardGradientThird: "#2B3E7F",
    mobilePaymentMethodAssistTextColor: "#808080",
    mobileCouponInputPlaceholderColor: "#C7C0C0",
    mobilePaymentsScreenBg: "white",
    addGiftCardBottomSheetBackdropColor: "rgba(29, 26, 26, 0.88)",
    enterCVVBottomSheetBackdropColor: "rgba(29, 26, 26, 0.88)",
    addCreditDebitCardTooltipBgColor: "#949494",
    yourOrderTitle: "#303030",
    orderDescriptionItem: "#2A2C25",
    orderTotalTitle: "#54301A",
    pickupDetailsTitle: "#303030",
    carSideStackTitle: "#606060",
    cardCreateAnAccountHeading: "#303030",
    takeSurveyText: "#606060",
    joinEClubTitle: "#303030",
    joinEClubTickScheme: "#A8AD00",
    mobileGiftVoucherGiftText: "#E7A227",
    mobileGiftVoucherVoucherIDText: "#C6C6C6",
    mobileGiftVoucherValueFirstGrad: "#F6C551",
    mobileGiftVoucherValueSecondGrad: "#B15801",
    mobileGiftVoucherBoxFirstGrad: "#423F3F",
    mobileGiftVoucherBoxSecondGrad: "#5F5852",
    mobileGiftCardNormalText: "white",
    wailistHomeScreenBannerGradientOne: "#BF7D3F",
    waitlistHomeScreenBannerGradientTwo: "#964631",
    waitlistHomeScreenBannerText: "#FFFFFF",
    waitlistBannerCircleOuterBorder: "rgba(255,255,255,0.2)",
    waitlistBannerFooterText: "#303030",
    waitlistPositionBackground: "#F3F4E7",
    waitlistPositionBorderTwo: "rgba(159, 167, 58, 0.1)",
    waitlistPositionBorderOne: "rgba(159, 167, 58, 0.2)",
    waitlistPositionInnerBorder: "#9FA73A",
    waitlistPositionCircleBackgroundColor: "#FFFFFF",
    waitlistPositionSubTitle: "#606060",
    waitlistPositionButtonBackground: "#FFFFFF",
    waitlistPositionSubTextColor: "#303030",
    waitlistSubCardsVerticalDivider: "#F6F6F6",
    waitlistDetailsSwiperText: "#FFFFFF",
    waitlistSwiperNavigationButtonBorderColor: "#FFFFFF",
    waitlistSwiperNavigationButtonBackgroundColor: "#FFFFFF",
    seasonFavouriteTitleText: "#FFFFFF",
    seasonFavouritesHeadingDivider: "#4D4D4D",
    waitlistMapSectionBorder: "#DCDCDC",
    waitlistMapSectionButtonBackground: "#FFFFFF",
    waitlistDetailsOrderbuttonText: "#FFFFFF",
    waitlistPositionHeadingText: "#2A2C25",
    waitlistDetailsScreenBackground: "#FFFFFF",
    waitlistBannerCircleBackgroundColor: "#FFFFFF",
    mobileCategoryNavigationBg: "#F8F8F8",
    mobileOrderSummaryBackground: "#F6F6F6",
    mobileOrderSummaryHeaderText: "#303030",
    mobileOrderSummaryDishQuantity: "#2A2C25",
    mobileOrderSummaryOtherInstructions: "#606060",
    mobileOrderSummaryOrderTotalDetailsItem: "#989182",
    mobileOrderSummaryOrderTotalDetailsItemCoupon: "#CA7C30",
    mobileOrderSummaryPaidByColor: "#303030",
    ProfilePictureCircleBorderColor: "#FFFFFF",
    mobileOrderSettingsOptionStackBorderColor: "#DEDEDE",
    orderSettingsPickupDetails: "#2A2C25",
    orderSettingsBackdrop: "rgba(0, 0, 0, 0.7)",
    curbsideHomeScreenBannerGradientOne: "#BF7D3F",
    curbsideHomeScreenBannerGradientTwo: "#964631",
    curbsideHomeScreenBannerText: "#523020",
    curbsideDetailsBackground: "#F3F4E7",
    curbsidePickupScreenBackground: "#FFFFFF",
    curbsidePickupScreenDetailsBackground: "#F2F4E6",
    curbsidePickupScreenDetailsDivider: "#DCDCDC",
    curbsidePickupScreenBannerText: "#523020",
    curbsidePickupScreenDetailsSubText: "#303030",
    curbsidePickupScreenDetailsIconsBackground: "#F6F6F6",
    curbsidePickupScreenDetailsEditButtonText: "#993324",
    viewDirectionButtonTextColor: "#FFFFFF",
    restaurantLocationBottomSheetBackdropColor: "rgba(0,0,0,0.6)",
    modalHeaderBackgroundColor: "rgba(0, 0, 0, 0.7)",
    restuarantLocationBottomSheetLocationText: "#606060",
    addGiftCardHeaderTextColor: "#2A2C25",
    mobileOrderHistoryBackgroundColor: "#F6F6F6",
    mobileOrderHistoryItemCardHeaderBackgroundColor: "#F3F4E7",
    orderHistoryItemDividerColor: "#C6C6C6",
    orderHistoryReorder: "#73994A",
    orderHistoryDetailsText: "#303030",
    orderHistoryOrderFrom: "#808080",
    orderHistoryDetailsAddress: "#606060",
    jwcLeaveTheLineModalHeadBg: "#D7D2CB",
    orderHistoryDetailsBGColor: "#F6F6F6",
    searchBarBackground: "#FFFFFF",
    addCardFooterButtonText: "#FFFFFF",
    homeScreenBackgroundColor: "#F6F6F6",
    homeScreenOrderNowButtonTextColor: "#73994A",
    restCallNowCTATextColor: "#FFFFFF",
    homeScreenHeaderIconColors: "#FFFFFF",
    homeScreenLoginBorderColor: "#ffffff",
    homeScreenCardButtonTextColor: "#FFFFFF",
    homeScreenCardButtonBorderColor: "#FFFFFF",
    homeScreenCardTextColor: "#FFFFFF",
    selectPreferredLocationBackgroundColor: "#FFFFFF",
    outletLocationItemIconText: "#FFFFFF",
    outletLocationItemButtonText: "#FFFFFF",
    profileScreenMainModalBackgroundColor: "#FFFFFF",
    showCreditCard_bottomSheet_BackgroundColor: "#FFFFFF",
    addEditCreditCard_scrollView_backgroundColor: "#F6F6F6",
    HomeScreenlinearGradientBackgroundColor: "#F6F6F6",
    homeScreenRecentOrdersListItemSubTextColor: "#606060",
    homeScreenRecentOrdersListItemDividerColor: "#C6C6C6",
    homeScreenRecentOrdersListItembackgroundColor: "#FFFFFF",
    homeScreenRecentOrdersListItemButtonTextColor: "#FFFFFF",
    addCardPlaceholderTextColor: "#606060",
    addCardCheckboxTextColor: "#606060",
    mobileReorderBg: "#F8F8F8",
    editProfileScreensBackgroundColor: "#FFFFFF",
    googleSocialSignInBGColor: "#FFFFFF",
    facebookSocialSignInBGColor: "#1877F2",
    appleSocialSignInBGColor: "#000000",
    socialAuthBorderColor: "#DEDEDE",
    createAccountPreferredLocationBGColor: "#F8F7F6",
    cartScreenBackgroundColor: "#FFFFFF",
    orderLimitReacherModalBackdrop: "rgba(0,0,0,0.7)",
    cartHeaderPressableColor: "#F6F6F6",
    securityQuestionContainer: "#ffffff",
    securityQuestionMenuColor: "#C6c6c6",
    securityQuestionTextColor: "#606060",
    createAccountBackgroundColor: "#FFFFFF",
    createAccountScreenTextColor: "#303030",
    createAccountZipCodeBorderColor: "#DCDCDC",
    createAccountZipCodeLabelColor: "#808080",
    settingScreenBg: "#F8F8F8",
    settingListItemShadow: "rgba(0,0,0,0.5)",
    frequentlyOrderedItemBackground: "#FFFFFF",
    frequentlyOrderedItemSubText: "#505050",
    giftCardBalanceColor: "#606060",
    mobileDividerColor: "rgba(0,0,0,0.5)",
    homescreenPromoBackdrop: "rgba(0, 0, 0, 0.6)",
    fullHomescreenPromoBg: "#F8F7F6",
    paymentScreenImportantTextDescription: "#808080",
    curbsideBannerTagColor: "#FFFFFF",
    guestFavoritesBackgroundColor: "#F6F6F6",
    guestFavouritePopOverBGColor: "#F3F4E7",
    guestPopoverBackdropColor: "rgba(0,0,0,0.7)",
    mobilePayBgColor: "#FFFFFF",
    mobilePayDividerColor: "#C6C6C6",
    mobilePayDividerTextColor: "#808080",
    mobilePayWorksHeaderTextColor: "#404040",
    mobilePayWorksListItemBgColor: "#F6F6F6",
    mobilePayWorksTitleColor: "#303030",
    mobilePayWorksItemTitleColor: "#2A2C25",
    mobilePayGuidlineBgColor: "#F6F6F6",
    mobilePayWhiteTextColor: "#FFFFFF",
    reorderTopTabScreenBackgroundColor: "#F6F6F6",
    errorPopUpContentDividerBackgroundColor: "#F6F6F6",
    menuSliderSelectedCountTextColor: "#808080",
    menuCustomisationButtonColor: "#A2402A",
    menuCustomisationIsSelectedMobileColor: "#F3F4EA",
    menuCustomisationIsSelectedBorderMobileColor: "#A8AD00",
    menuCustomisationNotSelectedBorderMobileColor: "#C6C6C6",
    joinWaitListMapTextColor: "#464838",
    joinWaitlistBackgroundColor: "#F6F6F6",
    selectedNumberOfGuestBorderColor: "#73994A",
    selectedNumberOfGuestBackgroundColor: "#F3F4EA",
    backgroundWhite: "#fff",
    menuCustomisationListIItemActiveColour: "#73994A",
    collapsableDropdownItemBgColor: "#F6F6F6",
    smartRecommendationBackgroundColor: "#E5E5E5",
    smartRecommendationActiveDotColor: "#54301A",
    smartRecommendationInActiveDotColor: "#C6C6C6",
    howMobilePayWorksModalBg: "rgba(0,0,0,0.6)",
    unavailableWaitlistColor: "#BDBDBD",
    mobileReorderScreenTitleColor: "#2A2C25",
    // ORDER CONFIRMATION START
    // ORDER CONFIRMATION END
    checkoutRadioButtonBorderColor: "#D6D6D6",
    pickupMethodBackgroundColor: "#F6F6F6",
    pickupMethodSectionDivider: "#DCDCDC",
    // Menu Search Start
    suggestedSearchTextColor: "#404040",
    noResultFoundMenuSearchBg: "#F6F6F6",
    searchModalBackgroundColor: "white",
    menuSearchModalDivider: "#ABABAB",
    searchCardCategorySlugColor: "grey",
    inputFieldBackgroundColor: "#F6F6F6",
    suggestionsBorderColor: "#C6C6C6",
    clearTextColor: "#993324",
    noResultTextColor: "#B31900",
    backgroundE5E5: "#E5E5E5",
    searchItemCardTextColor: "#505050",
    menuSearchBarContainerBg: "#FFFFFF",
    // Menu Search End
    ///Order Ahead Flow Tokens
    serveAsEntreeSwitch: "#97BC67",
    //mobile Payment Options tokens
    paymentOptionsHeaderColor: "#F6F7F0",
    paymentOptionsBorderColor: "#DCDCDC",
    //mobile app profile
    editProfileInfoLabelColor: "#808080",
    editProfileInfoAsteriskColor: "#73994A",
    profilePictureShadowColor: "#000000",
    mobileOrderInfoBannerBorderColor: "#D6D6D6",
    // order tracking page
    // order tracking page end
    //mobile restaurant details skeleton
    skeletonColorGrey: "#DCDCDC",
    onboardingScreenBGColor: "#FFFFFF",
    onboardingActiveDotColor: "#000000",
    onboardingInactiveDotColor: "rgba(0,0,0, 0.4)",
    onboardingButtonBackgroundColor: "#73994A",
    orderDetailsSkeletonBgColor: "#C4C4C4",
    //tab bar
    backgroundTabBarColor: "white",
    shadowColor: "#2c2c2c",
    //home-screen header avatar
    homeScreenHeaderAvatarBg: "lightgrey",
    //menu-collapsable bg
    menuCollapsableButton: "#F9F7F0",
    //number of guests bg
    numberOfGuestsActiveColor: "#303030",
    // estimated waitTime bg
    estimatedWaitTimeBg: "#54301A",
    // cart item qty color
    cartItemQuantityColor: "#54301A",
    mobileBottomTabBackgroundColor: "#FFFFFF",
    bottomTabTextColor: "#606060",
    checkoutGratuitySliderMinTrackColor: "#73994A",
    checkoutGratuitySliderMaxTrackColor: "#BFBFBF",
    cartQuantityTextColor: "#54301A",
    checkoutRadioBtnColor: "#73994A",
    // waitlistWineWhileYouWait Background color:
    waitlistWineWhileYouWaitBg: "#FFEFC2",
    homescreenWaitlistButtonBorderColor: "#73994A",
    homescreenWaitlistButtonTextColor: "#73994A",
    recentOrderTextColor: "#303030",
    orderConfirmationSeeDetailsShadowStart: "rgba(0, 0, 0, 0.02)",
    orderConfirmationSeeDetailsShadowEnd: "rgba(0, 0, 0, 0.05)",
    recentOrdersListItemPrice: "#73994A",
    menuLinearGradientStartColor: "#F8F8F8",
    menuLinearGradientEndColor: "#F8F8F8",
    paymentOrderTotalTextColor: "#000000",
    keyboardDoneButtonBgColor: "#FBFBFB",
    keyboardDoneButtonColor: "#2c7aff",
    profileHeaderLinearGradientStartColor: "#73994A",
    profileHeaderLinearGradientEndColor: "#73994A",
    profileAddCardButtonText: "#FFFFFF",
    searchBarBorderColor: "#D6D6D6",
    weekDayStartColor: "#223E6A",
    weekDayEndColor: "#223E6A",
    mobilePayConfirmationScreenBlockBG: "#F9F7F0",
    reservationCarouselActiveDotColor: "#DDC274",
    reservationCarouselInactiveDotColor: "#D5D8DA",
    reservationBorderColor: "rgba(0,0,0,0.1)",
    reservationButtonBGDisabled: "#CBD1D6",
    reservationSelectedCTABorderColor: "#73994A",
    reservationUnSelectedCTABorderColor: "transparent",
    reservationSelectedCTABGColor: "#F9F7F0",
    reservationUnSelectedCTABGColor: "#FFF",
    reservationPopupBgColor: "#fff",
    reservationSelectedSeatingOption: "#73994A26",
    reservationCalendarCtaBorderRadius: 0,
    reservationDOBMonthBgColor: "#fff",
    reservationDOBYearBgColor: "#fff",
    reservationDOBNavColor: "primary.100",
    reservationInputErrorColor: "#DF4505",
    locationsTopTabsContainerColor: "#FFFFFF",
    searchItemBreadCrumbSlugcolor: "#666666",
    preferredLocationHeaderBg: "#FFFFFF",
    preferredLocationHeaderTextColor: "#282C25",
    orderTotalTextColor: "#494949",
    orderTotalPriceColor: "#B31900",
    scrollingNavigationFlatlistStartingGradientStartColor: "#f8f8f8",
    scrollingNavigationFlatlistStartingGradientEndColor: "rgba(248, 248, 248, 0)",
    menuSearchModalCloseIconBg: "#F9F7F0",

    /* Restaurant Details */
    restaurantDetailsBGColor: "white",
    restaurantDetailsDividerColor: "rgba(0,0,0,0.2)",
    restaurantDetailsAboutSectionDividerColor: "rgba(0,0,0,0)",
    restaurantDetailsMobilePoliteNoticeDividerBg: "rgba(0,0,0,0.2)",
    restDetailsAmenitiesDividerMobileColor: "rgba(0,0,0,0.2)",
    restDetailsAmenitiesDividerColor: "transparent",
    restaurantDetailsJoinWaitlistButtonTextColor: "#73994A",
    restaurantDetailsJoinWaitlistButtonBorderColor: "#8F278A",
    restaurantDetailsJoinWaitlistButtonLargeTextColor: "white",
    restaurantDetailsDisableJoinWaitlistTextColor: "#C6C6C6",
    restaurantDetailsDisableJoinWaitlistButtonBorderColor: "#C6C6C6",
    restaurantDetailsCurrentStatusAndWaitlistDividerColor: "rgba(0,0,0,0.1)",
    restaurantDetailsRestInfoBoxBackgroundColor: "#F9F7F0",
    restaurantDetailsRestInfoLgDividerBackgroundColor: "#0000004D",
    restaurantDetailsSelectedWeekDayColor: "#73994A",
    restaurantDetailsNotSelectedWeekDayTextColor: "#404040",
    restaurantDetailsNotSelectedWeekDayColor: "#FFFFFF",
    restaurantDetailsCurrentWeekDayIndicator: "#49909B",
    restDetailsRestInfoTitleColor: "#70695C",
    mobilePayHeaderBtnBorder: "#73994A",
    restaurantInfoAddressTextColor: "#B31900",
    restaurantInfoAddToFavouritiesTextColor: "#73994A",
    restaurantTimingWeekDayTextColor: "#73994A",
    restaurantDetailsAmenetiesbgColor: "#FFFFFF",
    waitlistVisibilityAddressBoxArrow: "#54301A",
    howItWorksText: "#C16436",
    imageStackBorderColor: "#FFFFFF",
    calenderTodayBackgroundColor: "#73994A",
    calenderSelectedDayColor: "#73994A",
    calenderSelectedDayTextColor: "#FFF",
    calenderSelectedDayStyleBGColor: "#73994A",
    reserveTableHeaderRightButtonText: "#73994A",
    reserveConfirmationDescriptionHeaderBg: "#485062",
    defaultCardColor: "#rgba(255, 255, 255, 0.3)",
    defaultCardTextColor: "#FFFFFF",
    mobilePayBringYourCardArea: "#E0DED8",
    mobilePayCheckArea: "#F2F2F2",
    mobilePayCallInCheckDivider: "rgba(0, 0, 0, 0.1)",
    mobilePaySkeletonColor: "#DCDCDC",
    mobilePayCheckCloseBackgroundColor: "#F4F4F4",
    mobilePayCheckDividerColor: "rgba(0, 0, 0, 0.4)",
    mobilePayCheckBackground: "#FFFFFF",
    homescreenLocationTagBGColor: "rgba(255, 255, 255, 0.68)",
    homescreenLocationTagBorderColor: "#73994A",
    homescreenLocationTextColor: "#303030",
    homeScreenAlertBackgroundGradientOne: "#BE6336",
    homeScreenAlertBackgroundGradientTwo: "#4E332B",
    // location Search Token
    locationSearchTitle: "#303030",
    locationSearchSubTitle: "#020001",
    locationSearchActiveTab: "#73994A",
    searchThisAreaBg: "#73994A",
    locationSearchInActiveTab: "#606060",
    searchCurrentLocation: "#A2402A",
    registerLsBtn: "#73994A",
    allLocationsLsBg: "#F9F7F0",
    callRestLsText: "#73994A",
    mobilePayICheckError: "#3F3C3C",
    locationSearchTabDivider: "#DEDEDE",
    lsAllLocationsSelectBorder: "#D6D6D6",
    locationSearchTabBgColor: "transparent",
    locationListingItemHeadingInPage: "#73994A",
    allLocationsLSPageBg: "#ffffff",
    locationSearchAddressColor: "#303030",
    locationsSearchPageLocationListItemBgColor: "#ffff",
    lsMyLocationsTabContentDivider: "#0000001a",
    hoursInfoAccordionIcon: "#73994A",
    hoursInfoAccordionTitle: "#73994A",
    joinWaitlistBtnHover: "white",
    joinWaitlistBtnTextHover: "#B31900",
    newLoctionsLinkText: "#ffffff",
    newLocationsBannerBg: "#73994A",
    viewMenuHover: "#73994A",
    loginScreenHeaderBackground: "white",
    loginScreenScrollBg: "white",
    createAccountZipCodeBg: "#FFFFFF",
    createAccountLocationCardBackgroundColor: "#FFFFFF",
    loginErrorMessageBg: "#FECACA",
    loginErrorMessageBorder: "#FCA5A5",
    preferredLocationScrollBg: "#FFFFFF",
    menuListingScrollBackground: "#FFFFFF",
    cartCheckoutButtonLinearGradientStart: "rgba(255,255,255,0.6)",
    cartCheckoutButtonLinearGradientEnd: "#FFF",
    menuListingTopTabsColor: "#FFF",
    cartHeaderTextColor: "#000",
    menuListingTopTabActiveBorderColor: "#73994A",
    dividerBackgroundColor: "#E5E5E5",
    moreHeaderTitleTextColor: "#000000",
    customMobileHeaderBG: "#FFFFFF",
    addCreditCard_headerBackgroundColor: "#FFFFFF",
    editProfileInfoCardBg: "#FFFFFF",
    addCardSecurityBannerBg: "#FFFFFF",
    mobileCreateAccountScrollBackgroundColor: "transparent",
    menuTopTabNotActiveTextColor: "#171717",
    menuTopTabActiveTextColor: "#73994A",
    checkoutTopTabActiveTextColor: "#171717",
    checkoutTopTabTextColor: "#171717",
    checkoutCardsBg: "transparent",
    orderInfoBannerCartSubTotalColor: "#B31900",
    orderSettingsCardsBackgroundColor: "transparent",
    orderSettingsActionSheetBackgroundColor: "#FFF",
    orderSettingsActionSheetAsapScheduledColor: "#73994A",
    menuItemDetailMenuSummaryBackgroundColor: "#FFF",
    menuitemDetailScreenBackgroundColor: "#FFF",
    cartHeaderBGColor: "#F6F6F6",
    nearbyLocationsListViewScrollViewBgColor: "#FFF",
    menuSearchResultsBg: "#fff",
    searchHeaderColor: "#fff",
    menuSearchPlaceHolder: "#606060",
    recentOrderDividerBg: "#E5E5E5",
    restDetailsTitleColor: "#2A2C25",
    restDetailsBg: "#fff",
    restDetailButtonBg: "#fff",
    recentOrderBorder: "#F9F7F0",
    topTabCountInactiveBg: "#DAD4D5",
    tooltipTextColor: "#fff",
    pickupDetailsBorder: "#D6D6D6",
    checkoutVehicleBg: "#fff",
    seeDetailsText: "#606060",
    orderSettingsQuantityBg: "#F9F7F0",
    criticalModeBg: "#fafafa",
    reorderAddItemBg: "#73994A",
    reorderAddItem: "#fff",
    orderHistoryItemCardBackgroundColor: "#FFF",
    orderHistoryItemCardPriceColor: "#B31900",
    orderHistoryHeaderTitleColor: "#2A2C25",
    orderHistoryDetailsOrderNumberTextColor: "#B31900",
    orderHistoryCardLayoutBackgroundColor: "#FFF",
    orderHistoryFooterBackgroundColor: "#FFF",
    orderHistoryHeaderBgColor: "#FFF",
    menuListSkeletonHeaderContainerBackground: "#F8F8F8",
    menuListSkeletonHeaderBackground: "#FFF",
    menuListSkeletonCategoryNavigationBgColor: "#F8F8F8",
    menuListSkeletonTopTabActiveBottomBorderColor: "#73994A",
    menuDetailsHeaderTitleColor: "#404040",
    selectedOrderTypeBorderColor: "#73994A",
    selectedOrderTypeTextColor: "#73994A",
    mobileCalendarTextColor: "#73994A",
    gcBalanceRefreshBorderTextColor: "#73994A",
    gcBalanceRefreshBackdropColor: "rgba(0, 0, 0, 0.6)",
    reservationLocationModalDeskHeaderBg: "#FFF",
    reservationLocationModalMobHeaderBg: "#FFF",
    reservationLocationListBg: "#FFF",
    reservationLocationListBgMobile: "#FFF",
    pdLocationListBg: "#FFF",
    pdLocationListBgMobile: "#FFF",
    reservationsSpecialRequestSwitch: "#97BC67",
    reservationBg: "#F6F6F6",
    reservationStaticTextBg: "#fff",
    reservationTabsBg: "#73994A",
    reservationDropDownIconColor: "#73994A",
    reservationPickerHoverColor: "#73994A",
    reservationNoOfGuestsSelectedBg: "#73994A",
    reservationNoOfGuestsNotSelectedBg: "white",
    reservationsTimePickerBg: "white",
    reservationActionButtonsBg: "white",
    reservationInactiveSelectTime: "#D8DCE0",
    confirmationModalBorderRadius: 0,
    cancelConfirmationModalBorderRadius: 0,
    reservationUserInitials: "#73994A",
    preferredLocationCloseButtonBg: "#F3F4EA",
    preferredLocationCloseButtonHover: "#A8AD00",
    preferredLocationModalContentColor: "#FFFFFF",
    preferredLocationCloseButtonIconColor: "#040101",
    reservationHoveredText: "#FFF",
    reservationNotHoveredText: "#606060",
    reservationsCardsBodyBg: "#F6F6F6",
    reservationSpecialRequests: "#FFFFFF",
    reservationsTopTabsBg: "#73994A",
    reservationsTopTabsLabel: "#fff",
    reservationsTopTabsLabelFocused: "#73994A",

    /** Colors: Private Dining Start */
    minimalHeaderSignInBtn: "#73994A",
    makeRequestPageBg: "#F9F7F0",
    requestFormTabActiveItem: "#73994A",
    requestFormTabDisableItem: "#B4C0A7",
    splRequestToggleTrackColor: "#73994A",
    pdPurposeDropDownOptionHover: "#F9F7F0",
    pdTimeDropDownOptionHover: "#73994A",
    pdPartySizeRangeOptionHover: "#73994A",
    pdmenuPrefOptionHover: "#F9F7F0",
    pdFooterPrivacyNotice: "#73994A",
    pdContactDetailsEdit: "#73994A",
    pdReviewDetailsEventInfoDivider: "#D8D8D8",
    pdConfirmationMobileBg: "#F6F6F6",
    pdRequestFormInputBg: "#FFFFFF",
    pdRequestFormInputBorder: "#DDD",
    pdFooterBg: "#FFFFFF",
    pdActionSheetBody: "#FFFFFF",
    pdMobilePageBg: "#F6F6F6",
    eventPurposeSelectorColor: "#70695C",
    eventPurposeSelectorHoverColor: "#70695C",
    pdContactsPhoneTypeDivider: "#F3F3F3",
    pdLandingDropdownActive: "#73994A",
    pdLandingDropdownInActive: "#FFFFFF",
    pdFormAsteriskColor: "#606060",
    pdLandingMenuTabDesktopBg: "#FFFFFF",
    pdLandingMenuTabMobileBg: "#F9F7F0",
    pdLandingNoLocationContainer: "#F6F6F6",
    pdLandingMenuTabBg: "#FFFFFF",
    pdLandingLocationInfoMobileBg: "#F9F7F0",

    /** Colors: Private Dining End */
    reservationDOBTooltipBgColor: "#e3e3e3",
    reservationDOBTooltipTextColor: "#000",

    /** My Account */
    myAccountSubTextColor: "#606060",
    myAccountScreenBackroundColor: "#F6F6F6",
    myAccountScreenMobileBackgroundColor: "#F6F6F6",
    myAccountScreenWebBackgroundColor: "#fff",
    myAccountScreenUserInfoTextColor: "#606060",
    myAccountCardShadow: "rgba(0, 0, 0, 0.2)",
    myAccountCardBackground: "#FFFFFF",
    myAccountCartAmountTextBorderColor: "#FFFFFF",
    myAccountCartAmountTextColor: "#FFFFFF",
    myAccountBgImageOverlay: "#F3F4EA",
    myAccountBgColor: "#F9F7F0",
    myAccountCardBackgroundActive: "#F7F8E8",
    myAccountChangeFieldModalBg: "white",
    myAccountEditProfileScrollViewBg: "white",
    myAccountAddGiftCardsPopover: "#54301A",
    myAccountDOBYearBgColor: "transparent",
    myAccountDOBMonthBgColor: "transparent",
    myAccountDOBTextColor: "#73994A",
    myAccountCalendarCtaBorderRadius: 0,
    myAccountGiftCardLargeBorderRadius: 0,
    editProfileFullBottomButtonBackgroundColor: "white",
    orderHistoryFullBottomButtonBackgroundColor: "white",
    orderHistoryDetailsHeaderModalBackgroundColor: "white",
    myAccountMenuItemActiveTextColor: "#73994A",
    myAccountMenuItemInActiveTextColor: "#70695C",

    /** My Account */
    eClubHoverActiveColor: "#F3F4EA",
    eClubHoverActiveTextColor: "#70695C",
    eClubHoverInactiveTextColor: "#70695C",
    eClub_background_color: "#FFFFFF",
    eClub_confirmation_background_color: "#F3F4EA",
    eClubPopOverBackgroundColor: "#FFFFFF",
    EclubUnsubscribeBackgroundColor: "#F6F6F6",
    EClubUnsubscribeEmailValidationTextColor: "#f00",
    smartRecommendationModalCloseIconColor: "#737373",
    noReservationBorder: "transparent",
    networkIndicatorColor: "black",
    desktopTopTabsBG: "transparent",
    menuSearchModalCloseIconColor: "black",
    menuSearchInputBorder: "primary.100",
    menuSearchResultContainerBG: "#fff",
    pdRequestFormBG: "#fff",
    modalHeaderColor: "#fff",
    modalHeaderTextColor: "#404040",
    pdInputDataTextColor: "#000",
    joinEclubPreferredLocationLocationHeadingTextColor: "#808080",
    EClubInputErrorColor: "#DF4505",
    reservationSelectTimeTextColor: "#000",
    menuListingContainerBG: "#fff",
    locationListBgColor: "#fff",
    locationsSearchPageLocationListItemBgColorMobile: "#fff",
    joinEclubContainerBgColor: "#FFFFFF",
    editProfile_modalHeaderBackgroundColor: "#FFFFFF",
    editProfile_modalBodyBackgroundColor: "#F6F6F6",
    confirmationModalCTABackgroundColor: "#73994A",
    myAccountCardMobileBackgroundColor: "transparent",
    giftCardLargeBody_BackgroundColor: "#FAFAFA",
    giftCardLargeBody_webModalBackgroundColor: "#F6F6F6",
    giftCardLargeHeader_BackgroundColor: "#FAFAFA",
    webOrderHistoryBackgroundColor: "#FFFFFF",
    orderHistoryDetailsBottomButton_BackgroundColor: "#FFFFFF",
    paymentOptionsAddEditGCModalHeaderBackgroundColor: "#FFFFFF",
    paymentOptionsAddEditCCModalHeaderBackgroundColor: "#FFFFFF",
    securityBannerTextColor: "#606060",
    addCreditDebitCardTooltipTextColor: "#FFFFFF",
    orderHistoryModalHeaderTextColor: "#70695C",
    orderHistoryDetailsModalBackgroundColor: "#FFFFFF",
    joinEclubPreferredLocationButtonBorderColor: "#E7E7E7",
    joinEclubDOBTextColor: "#73994A",
    joinEclubPreferredLocationLocationNameTextColor: "#303030",
    joinEclubPreferredLocationLocationAddressTextColor: "#606060",
    EclubFormInputPlaceholderTextColor: "#989182",
    myAccountSkipConfirmationCTA: "#73994A",
    paymentOptions_giftCard_balanceAmountColor: "#70695C",
    menuItemcardVerticalImageBorderRadius: "xl",
    pd_landing_eventGuideWrapperBgColor: "#f6f6f6",
    reservationShareIconText: "#73994A",
    globalMessageBannerPadding: 1,
    errorDialogModalBorderRadius: 8,
    itemIsForBgColor: "#F9F7F0",
    locationListItemOrderText: "white",
    locationListItemOrderBg: "secondary.300",
    locationListItemOrderHoverBg: "secondary.300",
    locationListItemOrderPadding: 3,
    EclubDOBBottomBorderColor: "#D6D6D6",
    orderDetailsCartItemPrice: "#70695C",
    mobilePayCheckoutHeadingSectionBgColor: "#F9F7F0"
  },
  components: {
    Pressable: {
      variants: {
        // My Account starts
        myAccount_edit_fields_sheet_title_container: {
          bg: "white",
          width: "100%"
        },
        myAccount_order_history_order_details_modal_header_close_icon: {
          position: "absolute",
          right: 5,
          my: "auto"
        },
        myAccount_infoList_changeOperation_container: {
          px: 4,
          mb: 3,
          alignItems: "center",
          flexDirection: "row",
          shadow: 17,
          py: 5,
          backgroundColor: {
            base: "myAccountCardBackground",
            md: "#F6F6F6"
          },
          borderRadius: 0
        },
        myAccount_paymentOptions_addGC_actionSheet_Add: {
          my: 1,
          borderRadius: 0,
          _web: {
            my: 0
          },
          flex: 1,
          ml: 2,
          backgroundColor: "secondary.300",
          border: 1.5,
          borderColor: "secondary.300"
        },
        // My Account ends

        /* RESERVATION */
        reservationLocationSelectionBtn: {
          borderRadius: 0,
          px: 6,
          backgroundColor: "secondary.300",
          alignItems: "center",
          justifyContent: "center"
        },
        reservationConfBackHomeBtn: {
          borderRadius: 0,
          alignItems: "center",
          justifyContent: "center",
          mb: 30,
          mx: 5,
          px: 5,
          mt: 5,
          borderWidth: 1,
          height: 12,
          borderColor: "secondary.300"
        },
        reservationSelectGuestBtn: {
          borderColor: "reservationBorderColor",
          borderWidth: 1,
          py: 3,
          px: 5,
          mx: 1.5,
          borderRadius: 0,
          _ios: {
            radiusValue: 6
          },
          _android: {
            radiusValue: 6
          }
        },
        reservationPickerBtn: {
          flex: 1,
          py: 2,
          _web: {
            py: 4,
            px: 4
          },
          _ios: {
            alignItems: "center"
          },
          _android: {
            alignItems: "center"
          },
          mx: 1.5,
          borderRadius: 0,
          justifyContent: "center"
        },
        reservationAvailableTimeSlotBtn: {
          borderColor: "reservationBorderColor",
          borderRadius: 0,
          mx: 2
        },

        /* RESERVATION */
        jwcPreOrderBtn: {
          px: 5,
          py: 4,
          bg: {
            base: "#A2402A",
            lg: "white"
          },
          borderRadius: {
            base: 8,
            lg: 12
          },
          _web: {
            my: 2
          },
          mx: 2
        },
        qualityStoryBtnCta: {
          px: 5,
          py: 4,
          bg: {
            base: "#ffffff",
            lg: "#ffffff"
          },
          borderRadius: {
            base: 8,
            lg: 12
          },
          _web: {
            my: 2
          },
          mx: 2
        },
        categoryActiveBorder: {
          borderBottomWidth: 3
        },
        suggestedSearchPill: {
          mt: 2,
          mb: 2,
          mr: 3,
          py: 2,
          px: 4,
          alignItems: "center",
          justifyContent: "center",
          borderWidth: 1,
          bg: "#FFFFFF",
          borderColor: "suggestionsBorderColor",
          borderRadius: 0
        },
        //Order Tracking
        orderTrackingCurbsideCheckPrimary: {
          bg: "payNowButtonBg",
          borderColor: "curbsideCheckInSecondary",
          borderWidth: 1,
          px: 5,
          py: 3,
          borderRadius: "md",
          alignItems: "center",
          justifyContent: "center"
        },
        orderTrackingCurbsideCheckSecondary: {
          bg: "#FFFFFF",
          borderColor: "curbsideCheckInSecondary",
          px: 5,
          py: 3,
          borderWidth: 1,
          borderRadius: "md",
          alignItems: "center",
          justifyContent: "center"
        },
        //Restaurant Details Start
        restaurantDetails_RestWaitlist_JoinWaitlistButton: function restaurantDetails_RestWaitlist_JoinWaitlistButton(_ref) {
          var disabled = _ref.disabled;
          return {
            borderColor: disabled ? "#BCBCBC" : "restaurantDetailsJoinWaitlistButtonTextColor",
            alignItems: "center",
            justifyContent: "center",
            borderWidth: 1,
            _ios: {
              py: 2
            },
            _android: {
              py: 2
            },
            bg: disabled ? "#BCBCBC" : "restaurantDetailsJoinWaitlistButtonTextColor",
            minWidth: {
              base: "70%",
              lg: "261px"
            },
            _web: {
              minH: "44px"
            }
          };
        },
        restaurantDetails_OrderButtonSection_OrderNowButton: function restaurantDetails_OrderButtonSection_OrderNowButton(_ref2) {
          var disabled = _ref2.disabled;
          return {
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "secondary.300",
            opacity: disabled ? 0.4 : 1,
            borderWidth: 1,
            width: "100%",
            disabled: disabled,
            _web: {
              minH: "44px",
              padding: 2
            },
            borderColor: "secondary.300"
          };
        },
        restaurantDetails_RestTimings_WeekDayIconButton: function restaurantDetails_RestTimings_WeekDayIconButton(_ref3) {
          var selectedDay = _ref3.selectedDay;
          return {
            borderRadius: 100,
            backgroundColor: selectedDay ? "restaurantDetailsSelectedWeekDayColor" : "restaurantDetailsNotSelectedWeekDayColor",
            width: 38,
            height: 38,
            borderColor: "weekDayBorderColor",
            borderWidth: 1,
            alignItems: "center",
            justifyContent: "center"
          };
        },
        restaurantDetails_ActionButtons_ApplyNowButton: function restaurantDetails_ActionButtons_ApplyNowButton() {
          return {
            _ios: {
              my: "7px"
            },
            _android: {
              my: "7px"
            },
            alignItems: "center",
            justifyContent: "center",
            paddingY: 4,
            _web: {
              minH: "44px",
              padding: 2
            },
            borderWidth: 1,
            // width: "100%",
            backgroundColor: "secondary.300",
            borderColor: "secondary.300"
          };
        },
        restaurantDetails_ActionButtons_ViewMenuButton: function restaurantDetails_ActionButtons_ViewMenuButton(_ref4) {
          var disabled = _ref4.disabled;
          return {
            _ios: {
              my: "7px"
            },
            _android: {
              my: "7px"
            },
            alignItems: "center",
            justifyContent: "center",
            opacity: disabled ? 0.4 : 1,
            paddingY: 4,
            _web: {
              minH: "44px",
              padding: 2
            },
            backgroundColor: "secondary.300",
            borderWidth: 1,
            // width: "100%",
            borderColor: "secondary.300"
          };
        },
        restaurantDetails_RestaurantInfo_FavoriteButton: function restaurantDetails_RestaurantInfo_FavoriteButton() {
          return {
            bg: "white",
            w: "10",
            h: "10",
            shadow: 11,
            m: "auto",
            rounded: "full",
            position: "absolute",
            top: 2,
            right: 2
          };
        },
        restaurantDetails_RestInfo_ShareButton_Icon: {
          alignItems: "center",
          flexDirection: "row"
        },
        //Restaurant Details End
        locationListItemAddress: {
          pointerEvents: "none"
        },
        borderRadiusValue: function borderRadiusValue(_ref5) {
          var radiusValue = _ref5.radiusValue,
              topRadiusValue = _ref5.topRadiusValue,
              bottomRadiusValue = _ref5.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },
        viewCartBtnBorderRadius: {
          borderRadius: 0
        },
        homeScreen_order_button: function homeScreen_order_button() {
          return {
            shadow: 9,
            backgroundColor: "secondary.300",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 0,
            borderWidth: 1,
            borderColor: "#73994A",
            width: "90%"
          };
        },

        /** Pressable: Private Dining Start */
        privateDiningLocationSelectionBtn: {
          borderRadius: 0,
          px: 6,
          backgroundColor: "secondary.300",
          alignItems: "center",
          justifyContent: "center"
        },
        privateDiningModalCancelCTA: {
          px: 4,
          py: 2,
          borderWidth: 1,
          borderColor: "#73994A",
          borderRadius: 0,
          alignItems: "center",
          justifyContent: "center",
          w: "100%"
        },
        privateDiningModalConfirmCTA: {
          bg: "#73994A",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 0,
          w: "100%",
          px: 4,
          py: 2,
          borderWidth: 1,
          borderColor: "#73994A"
        },
        pd_landing_menuTabs_Item: function pd_landing_menuTabs_Item(_ref6) {
          var isActive = _ref6.isActive;
          return {
            bgColor: isActive ? "#73994A" : "transparent",
            px: isActive ? 6 : 0,
            py: isActive ? 1.5 : 0,
            borderRadius: 0
          };
        },
        pd_landing_noLocation_selectCTA: {
          bgColor: "primary.100",
          mt: {
            base: 8,
            md: 12
          },
          py: 3.5,
          px: 24,
          width: {
            base: "100%",
            sm: "auto"
          }
        },
        pd_landing_eventGuideCTA: {
          width: {
            base: "100%",
            lg: "273px"
          },
          borderColor: "#73994A",
          borderWidth: 1,
          borderRadius: 0
        },

        /** Pressable: Private Dining End */
        eClubStickySignUpDesktopPressable: {
          bg: "secondary.300",
          px: 4,
          py: 2,
          borderRadius: 0,
          w: "100%",
          h: "100%",
          justifyContent: "center"
        },
        eClubStickyCancelDesktopPressable: {
          borderWidth: 1,
          borderColor: "secondary.300",
          px: 4,
          py: 2,
          borderRadius: 0,
          w: "100%",
          right: 4,
          h: "100%",
          justifyContent: "center"
        },
        eClubConfirmationSignUpMobilePressable: {
          bg: "secondary.300",
          mt: 10,
          width: "100%",
          alignItems: "center",
          borderRadius: 0,
          py: 3,
          mb: 5
        },
        eClubStickySignUpMobilePressable: {
          bg: "secondary.300",
          px: 4,
          py: 2,
          borderRadius: 0,
          flex: 1,
          h: "100%",
          justifyContent: "center"
        },
        eClubStickyCancelMobilePressable: {
          borderWidth: 1,
          borderColor: "secondary.300",
          px: 4,
          py: 2,
          borderRadius: 0,
          flex: 1,
          mr: 3,
          h: "100%",
          justifyContent: "center"
        },
        editFieldsConfirmationModalCTAPressable: {
          borderRadius: 0,
          py: 3,
          px: 4
        },
        myAccount_editFieldsConfirmationModalCancelCTAPressable: {},
        editFieldsSuccessModalCTAPressable: {
          borderRadius: 0,
          py: 3,
          px: 4
        },
        myAccount_paymentOptions_addCard_Pressable: {
          mt: 8,
          bg: "#73994A",
          px: 5,
          _ios: {
            width: {
              base: "90%",
              md: "65%",
              lg: "50%"
            }
          },
          _android: {
            width: {
              base: "90%",
              md: "65%",
              lg: "50%"
            }
          }
        },
        addEditCreditCard_add_pressable: {
          width: "100%",
          backgroundColor: "secondary.300"
        },
        myAccount_menuListItem_pressable: function myAccount_menuListItem_pressable(_ref7) {
          var isActive = _ref7.isActive;
          return {
            borderRadius: 0,
            alignItems: "center",
            padding: 4,
            backgroundColor: isActive ? "myAccountCardBackgroundActive" : "myAccountCardBackground",
            flexDirection: "row",
            _web: {
              backgroundColor: {
                base: "white",
                md: isActive ? "myAccountCardBackgroundActive" : "myAccountCardBackground"
              }
            }
          };
        },
        myAccount_paymentOptions_checkBalanceCTA: {
          marginY: 1,
          border: 1.5,
          borderColor: "#73994A",
          borderRadius: 0,
          _web: {
            my: 0
          },
          flex: 1,
          mr: 2
        }
      }
    },
    Button: {
      baseStyle: {
        _focusVisible: {
          style: {
            boxShadow: "none"
          }
        },
        borderRadius: "0px"
      },
      variants: {
        solid: {
          bg: "primary.100",
          _pressed: {
            bg: "primary.200"
          },
          _hover: {
            bg: "#5A783A"
          }
        },
        ghost: {
          _pressed: {
            bg: "transparent"
          },
          _hover: {
            bg: "background.100"
          }
        },
        camAccessBtn: {
          bg: "#5A783A",
          paddingY: 18,
          marginTop: 27,
          marginX: 5,
          borderWidth: 1,
          w: "100%",
          _text: {
            fontSize: 18,
            lineHeight: 6,
            fontWeight: 400,
            color: "white",
            textTransform: "uppercase"
          }
        },
        socialLoginBtn: {
          bg: "transparent",
          mb: 4,
          border: 1,
          borderColor: "rgb(53,88,156)",
          _text: {
            fontWeight: 400,
            color: "rgb(53,88,156)"
          },
          _hover: {
            bg: "white"
          }
        },
        loginPopUpBtn: {
          height: 12,
          _web: {
            height: null
          },
          _text: {
            color: "white",
            fontWeight: 400
          },
          bg: "primary.100",
          _pressed: {
            bg: "primary.200"
          },
          _hover: {
            bg: "#5A783A"
          }
        },
        addMoreItemsButton: {
          _ios: {
            width: "100%",
            py: 4
          },
          _android: {
            width: "100%",
            py: 4
          },
          _web: {
            width: "100%",
            py: 2
          }
        },
        link: {
          _text: {
            textTransform: "uppercase",
            color: "white",
            fontWeight: "600",
            fontStyle: "normal",
            fontSize: "md",
            lineHeight: 6,
            _web: {
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            textAlign: "center",
            fontFamily: "heading"
          },
          _pressed: {
            bg: "transparent"
          }
        },
        outline: {
          _hover: {
            bg: "#E5EEDC"
          },
          _pressed: {
            bg: "#E5EEDC"
          }
        },
        HomeScreenCTAreserveNow: function HomeScreenCTAreserveNow(_ref8) {
          var borderRadiusValue = _ref8.borderRadiusValue;
          return {
            marginBottom: 5,
            borderRadius: 0,
            _text: {
              color: "#FFFFFF"
            },
            bg: "#73994A"
          };
        },
        HomeScreenCTAjwl: function HomeScreenCTAjwl(_ref9) {
          var borderRadiusValue = _ref9.borderRadiusValue;
          return {
            marginBottom: 5,
            marginTop: 0,
            borderRadius: 0
          };
        },
        HomescreenOrderOnlineCta: function HomescreenOrderOnlineCta(_ref10) {
          var borderRadiusValue = _ref10.borderRadiusValue;
          return {
            borderRadius: 0,
            borderWidth: 1,
            borderColor: "#73994A"
          };
        },
        orderOnlineBtn: function orderOnlineBtn() {
          return {
            padding: 0,
            _text: {
              color: "white",
              fontFamily: "body",
              fontWeight: 400,
              _web: {
                fontSize: "xs"
              },
              textTransform: "uppercase",
              margin: 2
            },
            bg: "locationListBtn",
            _hover: {
              bg: "locationListBtn"
            },
            _pressed: {
              bg: "locationListBtn"
            }
          };
        },
        orderOnlineBtnExternalLink: function orderOnlineBtnExternalLink() {
          return {
            padding: 0,
            _text: {
              color: "white",
              fontFamily: "body",
              fontWeight: 400,
              _web: {
                fontSize: "xs"
              },
              textTransform: "uppercase",
              margin: 2
            },
            border: 1,
            borderColor: "secondary.300",
            bg: "secondary.300",
            _hover: {
              bg: "secondary.300"
            },
            _pressed: {
              bg: "secondary.300"
            }
          };
        },
        changeLocationLink: {
          _text: {
            textTransform: "uppercase",
            _web: {
              fontSize: "xs"
            },
            fontWeight: "400",
            color: "#989182",
            fontStyle: "normal",
            lineHeight: 6,
            letterSpacing: "-0.3px",
            textAlign: "center",
            fontFamily: "heading"
          },
          _pressed: {
            bg: "transparent"
          },
          _hover: {
            _text: {
              underline: true
            }
          }
        },
        refreshIcon: {
          _ios: {
            borderWidth: 1
          },
          _android: {
            borderWidth: 1
          },
          _web: {
            borderWidth: "1px"
          },
          backgroundColor: "white",
          borderColor: "#A2402A",
          _text: {
            fontSize: "xs",
            lineHeight: 4,
            textTransform: "uppercase",
            color: "secondary.300",
            fontWeight: 400
          }
        },
        cartItemActionButton: {
          _text: {
            color: "cartItemActionBtn",
            textTransform: "uppercase",
            lineHeight: 5,
            fontWeight: 500,
            _ios: {
              fontSize: "13",
              fontWeight: "400"
            },
            _android: {
              fontSize: "13",
              fontWeight: "400"
            },
            _web: {
              fontSize: "13px"
            }
          }
        },
        cartItemRemoveBtn: {
          _ios: {
            borderWidth: 1
          },
          _android: {
            borderWidth: 1
          },
          _web: {
            borderWidth: "1px"
          },
          backgroundColor: "secondary.300",
          borderColor: "secondary.300",
          _text: {
            fontSize: "xs",
            lineHeight: 4,
            textTransform: "uppercase",
            color: "white",
            fontWeight: 400
          }
        },
        menuButton: function menuButton(_ref11) {
          var isActive = _ref11.isActive,
              isMobile = _ref11.isMobile,
              isLongText = _ref11.isLongText;
          return {
            px: {
              base: 2,
              md: 9
            },
            bg: isActive ? "menuButtonBackgroundColor" : "transparent",
            ml: isLongText && isMobile && 5,
            width: !isMobile && (isLongText ? "100%" : 32),
            height: {
              base: 8,
              md: 9
            },
            _web: {
              borderRadius: "0px",
              width: !isMobile && (isLongText ? "100%" : "117px")
            },
            borderRadius: 0,
            rounded: 0,
            _text: {
              color: isActive ? "white" : "menuButtonBackgroundColor",
              fontWeight: "600",
              fontSize: isMobile ? "xs" : "sm",
              _web: {
                lineHeight: isMobile ? "14.63px" : "24px",
                fontSize: {
                  base: "14px",
                  md: "14px"
                }
              },
              lineHeight: isMobile ? 4 : 6,
              textTransform: "uppercase",
              fontFamily: "heading"
            }
          };
        },
        pillButton: function pillButton(_ref12) {
          var isActive = _ref12.isActive;
          return {
            bg: isActive ? "secondary.100" : "transparent",
            _web: {
              borderRadius: "20px",
              height: "24px"
            },
            borderRadius: 5,
            height: 6
          };
        },
        exploreMenuButton: function exploreMenuButton() {
          return {
            bg: "white",
            border: 1,
            borderColor: "primary.100",
            _text: {
              color: "primary.100"
            }
          };
        },
        orderSettingsDateTimeChoiceSolidButton: function orderSettingsDateTimeChoiceSolidButton() {
          return {
            bg: "orderSettingsDateTimeChoiceColor"
          };
        },
        addToCartSolidButton: function addToCartSolidButton(_ref13) {
          var isUnavailable = _ref13.isUnavailable;
          return {
            bg: isUnavailable ? "#E5E5E5" : "primary.100",
            _pressed: {
              bg: isUnavailable ? "#E5E5E5" : "primary.100"
            },
            _hover: {
              bg: isUnavailable ? "#E5E5E5" : "primary.100"
            },
            _text: {
              fontWeight: "700"
            }
          };
        },
        addBtnPadding: function addBtnPadding() {
          return {
            _web: {
              paddingBottom: "8px"
            },
            paddingBottom: 2
          };
        },
        confirmationGradientButton: function confirmationGradientButton() {
          return {
            borderRadius: 0
          };
        },
        waitlistOrder: {
          backgroundColor: "white",
          borderColor: "#73994A",
          borderWidth: 1
        },
        menuSearchModalCloseButtonContainer: function menuSearchModalCloseButtonContainer() {
          return {
            _web: {
              marginRight: {
                base: "20px",
                md: "40px",
                lg: "110px"
              },
              marginTop: "26px",
              height: "48px",
              width: "48px",
              borderRadius: "8px"
            }
          };
        },
        //Restaurant Details Start
        restaurantDetails_RestInfo_GetDirectionsButton: function restaurantDetails_RestInfo_GetDirectionsButton() {
          return {
            variant: "outline",
            borderRadius: 8,
            alignItems: "center",
            justifyContent: "center",
            borderColor: "amenitiesActionButtonsColor",
            alignSelf: "flex-end",
            borderWidth: 1,
            bg: "white",
            _hover: {
              bg: "white"
            },
            _focus: {
              bg: "white"
            },
            _focusVisible: {
              bg: "white"
            },
            py: 2.5,
            px: 2
          };
        },
        //Restaurant Details End
        preorderDineIn: {
          backgroundColor: "#00A9A1"
        },
        // LS tokens
        locationListItemButton: {
          _text: {
            fontFamily: "s52",
            fontWeight: 600,
            fontSize: "18px"
          }
        },
        viewMenuBtn: {
          borderRadius: 0,
          padding: 0,
          borderWidth: 1,
          borderColor: "secondary.300",
          _text: {
            color: "secondary.300",
            marginY: "11px",
            marginX: 6,
            fontSize: "18px",
            fontWeight: 600,
            letterSpacing: -0.3,
            fontFamily: "S52-Regular",
            lineHeight: 4
          }
        },
        defaultBannerBtn: function defaultBannerBtn() {
          return {
            _web: {
              minW: 134,
              px: 4,
              py: 2
            },
            _ios: {
              px: 2,
              py: 2,
              mt: 0.5
            },
            _android: {
              px: 2,
              py: 2,
              mt: 0.5
            },
            px: 4,
            py: 2,
            borderWidth: 1,
            borderColor: "primary.200",
            bg: "primary.100"
          };
        },
        viewMenuBtnExternalLink: function viewMenuBtnExternalLink(_ref14) {
          var isLocationSearch = _ref14.isLocationSearch,
              fromAllLocations = _ref14.fromAllLocations;
          return {
            borderRadius: 0,
            padding: 0,
            borderWidth: 1,
            borderColor: "secondary.300",
            _text: {
              color: "secondary.300",
              marginY: "11px",
              marginX: 6,
              fontSize: "18px",
              fontWeight: 600,
              letterSpacing: -0.3,
              fontFamily: "S52-Regular",
              lineHeight: 4
            },
            bg: isLocationSearch && fromAllLocations ? "transparent" : "secondary.300",
            _hover: {
              bgColor: "secondary.300",
              _text: {
                color: "white"
              }
            },
            _pressed: {
              bgColor: "secondary.300"
            }
          };
        },
        locationListItemButtonBorderRadius: 0,
        locationsInfographicLoginButton: function locationsInfographicLoginButton() {
          return {
            pr: 12,
            pl: 12,
            py: 3,
            backgroundColor: "secondary.300",
            _web: {
              borderRadius: 6
            },
            _text: {
              color: "locationInfographicModalActionButtonTextColor",
              fontSize: 20,
              fontWeight: 400,
              textTransform: "uppercase",
              textAlign: "center",
              lineHeight: 6,
              borderRadius: 0
            }
          };
        },
        borderRadiusValue: function borderRadiusValue(_ref15) {
          var radiusValue = _ref15.radiusValue,
              topRadiusValue = _ref15.topRadiusValue,
              bottomRadiusValue = _ref15.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },
        viewNutritionalVariant: {
          py: 1,
          mb: 2
        },
        confirmBtnBorderRadius: {
          borderRadius: 0
        },
        homeScreen_reserve_button: function homeScreen_reserve_button() {
          return {
            borderColor: "secondary.300",
            borderWidth: 1,
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 0,
            marginBottom: 5,
            width: "90%",
            bg: "#73994A",
            _pressed: {
              bg: "bodyBg"
            },
            _text: {
              _ios: {
                fontSize: 18
              },
              _android: {
                fontSize: 18
              },
              _web: {
                fontSize: 18
              },
              color: "#fff",
              fontWeight: 400,
              lineHeight: 7,
              paddingTop: Platform.OS === "ios" ? 1 : 0,
              marginY: 0.5
            }
          };
        },
        joinWaitlist_Header_LoginButton: function joinWaitlist_Header_LoginButton() {
          return {
            _text: {
              fontSize: 14,
              color: "primary.100",
              fontWeight: 400
            },
            borderColor: "primary.100",
            borderRadius: 0,
            px: "17px",
            py: "10px",
            _web: {
              px: {
                base: "10px",
                lg: "17px"
              },
              py: {
                base: "6px",
                lg: "10px"
              }
            },
            _focus: {
              backgroundColor: "white"
            },
            bg: "transparent",
            borderWidth: 1
          };
        },

        /** Button: Private Dining Start */
        pd_Header_LoginButton: function pd_Header_LoginButton() {
          return {
            _text: {
              fontSize: 14,
              color: "#73994A",
              fontWeight: 400,
              textTransform: "uppercase"
            },
            px: "17px",
            py: "10px"
          };
        },
        pd_request_eventDetails_confirmCTA: function pd_request_eventDetails_confirmCTA() {
          return {
            borderRadius: 0,
            backgroundColor: "#73994A",
            padding: 0,
            marginTop: 4,
            marginX: 5,
            marginBottom: 3,
            h: 12,
            _text: {
              color: "white",
              letterSpacing: -0.5,
              fontWeight: "400",
              fontSize: 18,
              marginTop: 3,
              marginBottom: 3,
              lineHeight: 6,
              textAlign: "center",
              textTransform: "uppercase"
            },
            _pressed: {
              opacity: 0.8
            }
          };
        },
        pd_requestForm_Footer_cancalCTA: function pd_requestForm_Footer_cancalCTA() {
          return {
            bg: "none",
            border: 2,
            borderRadius: 0,
            borderColor: "#73994A",
            _text: {
              fontSize: 16,
              color: "#73994A"
            },
            _hover: {
              bg: "none"
            }
          };
        },
        pd_requestForm_Footer_ContinueCTA: function pd_requestForm_Footer_ContinueCTA() {
          return {
            px: 12,
            _text: {
              fontWeight: 400,
              fontSize: 16,
              color: "white"
            },
            bg: "#73994A",
            borderRadius: 0
          };
        },
        pd_confirmation_backToHomeCTA: {
          bg: "none",
          border: 2,
          borderRadius: 0,
          borderColor: "#73994A",
          px: 12,
          mt: {
            md: 5
          },
          _text: {
            fontSize: 16,
            color: "#73994A",
            fontFamily: "Barlow-Medium"
          },
          _hover: {
            bg: "none"
          }
        },
        pd_landing_stickyFooter_pdReqCTA: {
          py: 2.5,
          width: {
            base: "100%",
            md: "469px"
          },
          height: 12,
          bgColor: "#73994A"
        },
        confirmAndAddToCartButton: {
          _ios: {
            borderRadius: 0
          },
          _android: {
            borderRadius: 0
          },
          bg: "primary.100",
          _pressed: {
            bg: "primary.200"
          },
          _hover: {
            bg: "#5A783A"
          }
        },

        /** Button: Private Dining End */

        /** My Account */
        myAccount_paymentOptions_gc_bs_deleteCTA: {
          width: "100%",
          mb: 5,
          borderWidth: 1,
          borderColor: "secondary.300",
          _hover: {
            backgroundColor: "background.300"
          },
          _focus: {
            backgroundColor: "background.300"
          },
          py: 5,
          _text: {
            fontSize: "md",
            fontWeight: 400,
            lineHeight: 5,
            textTransform: "uppercase",
            color: "secondary.300"
          },
          _web: {
            width: {
              base: "100%",
              md: "30%"
            },
            py: {
              base: 5,
              md: 2.5
            },
            mb: {
              base: 5,
              md: 0
            }
          }
        },
        EClubUnsubscribeSubmitButton: {
          alignSelf: {
            md: "flex-start"
          },
          _text: {
            color: "white",
            fontWeight: 300
          },
          bg: "primary.100",
          _pressed: {
            bg: "primary.200"
          },
          _hover: {
            bg: "#5A783A"
          }
        },
        ErrorDialogOKButton: {
          _ios: {
            borderRadius: 0
          },
          _android: {
            borderRadius: 0
          },
          bg: "primary.100",
          _pressed: {
            bg: "primary.200"
          },
          _hover: {
            bg: "#5A783A"
          }
        },
        editProfileFullBottomButton: {},
        orderHistoryReorderFullBottomButton: {},
        noPrefLocationScreen_selectCTA_Button: {
          width: "300px",
          py: 3.5,
          mt: 10,
          bg: "secondary.300",
          borderRadius: 0,
          mx: "auto"
        },
        orderHistory_emptyScreenCTA_button: {
          width: {
            base: "200px",
            md: "256px"
          },
          py: {
            base: 2.5,
            md: 3.5
          },
          mt: {
            base: 10,
            md: 10
          },
          bg: "secondary.300"
        },
        addEditCreditCard_delete_button: {
          flex: 1,
          mr: 2,
          _hover: {
            backgroundColor: "background.300"
          },
          _focus: {
            backgroundColor: "background.300"
          },
          py: 5,
          _text: {
            fontSize: "md",
            fontWeight: 400,
            lineHeight: 5,
            textTransform: "uppercase",
            color: "secondary.300"
          },
          bg: "transparent",
          borderColor: "secondary.300",
          borderWidth: 1
        },
        addEditCreditCard_update_button: {
          flex: 1,
          ml: 2,
          py: 5,
          _text: {
            fontSize: 16,
            lineHeight: 6,
            letterSpacing: -0.5,
            fontWeight: 400,
            textAlign: "center",
            color: "addCardFooterButtonText"
          },
          bg: "secondary.300"
        },
        myAccount_paymentOptions_deleteGiftCard_confirmationCTAStyles: {
          _text: {
            py: 1
          }
        },
        myAccount_paymentOptions_deleteCreditCard_confirmationCTAStyles: {},
        myAccount_paymentOptions_giftCardDetails_refreshCTA: {
          mb: 5,
          paddingX: 2,
          width: "60%",
          borderColor: "gcBalanceRefreshBorderTextColor",
          mr: 1,
          _web: {
            width: {
              base: "45%",
              md: "30%"
            }
          },
          _text: {
            color: "gcBalanceRefreshBorderTextColor",
            fontWeight: 400
          },
          bg: "#FFFFFF"
        },
        previousOrderItemAddCta: {
          borderRadius: 0,
          bg: "white",
          borderColor: "reOrderAddBtnBorder",
          borderWidth: 1
        }
      }
    },
    Tooltip: {
      baseStyle: {
        borderRadius: 8,
        padding: 3,
        _text: {
          fontSize: 12,
          fontWeight: 500
        }
      }
    },
    Accordion: {
      baseStyle: {
        borderWidth: 0,
        borderColor: "transparent",
        borderRadius: 0
      },
      variants: {
        skuSelectorAccordion: function skuSelectorAccordion(_ref16) {
          var isMandatory = _ref16.isMandatory;
          return {
            borderRadius: {
              md: isMandatory && "xl"
            }
          };
        },
        menuItemAccordion: function menuItemAccordion() {
          return {
            borderRadius: {
              md: "0"
            }
          };
        }
      }
    },
    ModalHeader: {
      variants: {
        errorDialogModalHeader: {
          roundedTop: 8
        }
      }
    },
    ModalBody: {
      variants: {
        smartRecommendationModalModalBody: {
          _ios: {
            width: "100%"
          },
          _android: {
            width: "100%"
          }
        },
        myAccount_paymentOptions_deleteGiftCard_modalBodyStyles: {
          bg: {
            base: "#F8F7F6",
            md: "#FFFFFF"
          },
          borderRadius: 0,
          p: {
            base: 6,
            md: 10
          },
          pt: 10
        },
        myAccount_paymentOptions_giftCardsLimitReached_modalBodyStyles: {
          alignItems: "center",
          justifyContent: "center",
          p: 6,
          borderRadius: 0,
          bg: {
            base: "#F8F7F6",
            md: "#FFFFFF"
          },
          pt: 10,
          _web: {
            pt: 6
          }
        }
      }
    },
    ModalContent: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref17) {
          var radiusValue = _ref17.radiusValue,
              topRadiusValue = _ref17.topRadiusValue,
              bottomRadiusValue = _ref17.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },
        pd_cancelModal: {
          alignItems: "center",
          justifyContent: "center",
          maxWidth: "335px",
          py: 8,
          px: 6,
          borderRadius: 0
        },
        editFieldsConfirmationModal: {
          borderRadius: 0,
          p: 12
        },
        editFieldsSuccessModal: {
          borderRadius: 0,
          p: 12,
          maxWidth: {
            md: "588"
          }
        },
        myAccount_paymentOptions_deleteGiftCard_modalContentStyles: {
          p: 0,
          borderRadius: 0
        },
        myAccount_paymentOptions_giftCardLimitReached_modalContentStyles: {
          width: {
            md: "370px"
          },
          p: 0,
          borderRadius: 0
        }
      }
    },
    AccordionSummary: {
      baseStyle: {
        borderTopWidth: 0,
        borderTopColor: "transparent",
        p: 0,
        _hover: {
          bg: "transparent"
        },
        _expanded: {
          bg: "transparent",
          borderBottomColor: "transparent",
          _text: {
            color: "white"
          }
        },
        _disabled: {
          bg: "transparent"
        }
      },
      variants: {
        skuSelectorSummary: function skuSelectorSummary(_ref18) {
          var isMandatory = _ref18.isMandatory;
          return {
            borderTopRadius: {
              md: isMandatory && "xl"
            }
          };
        }
      }
    },
    AccordionDetails: {
      variants: {
        skuSelectorDetails: function skuSelectorDetails(_ref19) {
          var isMandatory = _ref19.isMandatory;
          return {
            borderBottomRadius: {
              md: isMandatory && "xl"
            }
          };
        },
        menuItemDetails: function menuItemDetails(_ref20) {
          var isDefaultExpanded = _ref20.isDefaultExpanded;
          return {
            borderBottomRadius: {
              md: isDefaultExpanded && "0"
            }
          };
        }
      }
    },
    Stack: {
      variants: {
        skuSelectorItem: {
          borderRadius: 0
        },
        //Restaurant Details Start
        restaurantDetails_CurrentStatusAndWaitlist_AvailabilityStack: {
          alignItems: {
            lg: "flex"
          },
          _ios: {
            marginTop: 3
          },
          _android: {
            marginTop: 3
          },
          direction: {
            base: "row",
            lg: "column"
          },
          justifyContent: "space-between",
          space: "md"
        },
        restaurantDetails_CurrentStatusAndWaitlist_WaitTimeStack: {
          _ios: {
            marginRight: 4
          },
          _android: {
            marginRight: 4
          },
          direction: {
            base: "column",
            lg: "row"
          },
          alignItems: "center",
          space: {
            lg: "sm"
          }
        },
        restaurantDetails_RestInfo_AddressLink_Stack: {
          direction: {
            base: "column",
            lg: "row"
          }
        },
        //Restaurant Details End
        EClubUnsubscribeFormContainer: {
          direction: {
            base: "column",
            md: "row"
          },
          space: {
            base: 4,
            md: 8
          },
          maxW: "500"
        },

        /** Stack: Private Dining Start */
        pd_landing_stickyFooter_container: {
          direction: {
            base: "column-reverse",
            lg: "row"
          },
          bgColor: "#FFFFFF",
          alignItems: "center",
          justifyContent: "space-between",
          py: {
            base: 3,
            md: 7
          },
          px: {
            base: 5,
            md: 32
          },
          shadow: {
            base: 14,
            md: 0
          }
        }
        /** Stack: Private Dining End */

      }
    },
    Divider: {
      variants: {
        restaurantDetails_RestInfo_Divider: {
          mx: 5
        },
        jwcFooterBlockDivider: {
          height: 4,
          backgroundColor: "#8A8585",
          orientation: "vertical",
          mx: 3.5,
          w: 0.4
        }
      }
    },
    Text: {
      variants: {
        myAccount_button_editConfirmation_text: {
          fontWeight: 400
        },
        myAccount_button_cta_weight: 400,
        createAccountSelectPrefLocationText: {
          color: "secondary.300",
          lineHeight: 6,
          fontSize: 18,
          fontWeight: 300,
          ml: 1,
          mr: {
            base: 8,
            md: 8
          }
        },
        // My Account
        myAccountLocationCardHeader: {
          fontSize: {
            base: 14,
            md: 16
          },
          lineHeight: 5,
          fontWeight: 400,
          color: "#73994A"
        },
        myAccountLocationCardAddress: {
          lineHeight: 5,
          fontSize: 14,
          fontWeight: 200
        },
        myAccountLocationCardPhoneNumber: {
          lineHeight: 5,
          fontSize: 14,
          fontWeight: 200
        },
        myAccountChangeLocationChangeText: {
          color: "#73994a",
          fontSize: {
            base: "2xs",
            md: "sm"
          },
          fontWeight: 400,
          _ios: {
            fontSize: 12
          },
          _android: {
            fontSize: 12
          },
          _web: {
            textTransform: "uppercase"
          }
        },
        myAccountDOBPrevText: function myAccountDOBPrevText(_ref21) {
          var prevMonthButtonDisabled = _ref21.prevMonthButtonDisabled;
          return {
            mr: "auto",
            fontSize: 12,
            color: prevMonthButtonDisabled ? "transparent" : "#73994a",
            textTransform: "capitalize"
          };
        },
        myAccountDOBNextText: function myAccountDOBNextText(_ref22) {
          var nextMonthButtonDisabled = _ref22.nextMonthButtonDisabled;
          return {
            ml: "auto",
            fontSize: 12,
            color: nextMonthButtonDisabled ? "transparent" : "#73994a",
            textTransform: "capitalize"
          };
        },
        myAccountContainerTitle: {
          fontSize: 20,
          fontWeight: 500,
          textTransform: "uppercase",
          color: "#73994A",
          lineHeight: 6,
          letterSpacing: "-0.3"
        },
        myAccount_MenuListItem_cardText_title: {
          fontSize: 12,
          lineHeight: 4,
          fontWeight: 300
        },
        myAccount_MenuListItem_cardText_subTitle: {
          marginTop: 1,
          fontSize: 14,
          lineHeight: 4,
          noOfLines: 1
        },
        myAccount_MenuListItem_cardText_subText: {
          marginTop: 1,
          fontSize: 14,
          lineHeight: 4,
          color: "myAccountSubTextColor",
          noOfLines: 1
        },
        myAccount_MenuListItem_cardText_subTitle2: {
          fontSize: 12,
          lineHeight: 4,
          fontWeight: 300,
          color: "myAccountSubTextColor"
        },
        myAccount_ChangeField_title: {
          paddingLeft: 5,
          paddingTop: 4,
          paddingBottom: 3,
          fontSize: 20,
          lineHeight: 6
        },
        myAccount_ChangeEmail_headerTitle: {
          mt: 6,
          mb: 5,
          textAlign: "center",
          fontSize: 20,
          lineHeight: 6,
          color: "#2A2C25"
        },
        myAccount_profileInfo_infoCard_title: {
          color: "#000",
          fontSize: 20,
          fontWeight: 400
        },
        myAccount_profileInfo_infoCard_subtext: {
          color: "#606060",
          fontSize: 14,
          fontWeight: 200,
          mt: 1
        },
        myAccount_profileInfo_infoCard_info: {
          fontSize: 10,
          lineHeight: 3,
          color: "editProfileInfoLabelColor"
        },
        myAccount_profileInfo_infoCard_terms: {
          fontSize: 11,
          lineHeight: 5,
          letterSpacing: -0.2,
          color: "themeGrey"
        },
        myAccount_profileInfo_infoCard_terms2: {
          fontSize: 11,
          lineHeight: 5,
          letterSpacing: -0.2,
          color: "backLinkColor"
        },
        myAccount_profileInfo_infoList_emailLabel: {
          color: "#808080",
          fontSize: 14,
          mb: 1
        },
        myAccount_profileInfo_infoList_maskedEmail: {
          color: "themeGrey",
          fontSize: 16,
          fontWeight: 400
        },
        myAccount_profileInfo_infoList_emailChange: {
          fontSize: 12,
          color: "secondary.300"
        },
        myAccount_profileInfo_infoList_changeOperation: {
          color: {
            base: "themeGrey",
            md: "#73994a"
          },
          letterSpacing: -0.3,
          fontSize: 16,
          fontWeight: 400
        },
        myAccount_orderHistoryItem_orderNumber: {
          fontSize: 14,
          letterSpacing: -0.3,
          fontWeight: "400",
          lineHeight: 4,
          color: "#303030"
        },
        myAccount_orderHistoryItem_orderPrice: {
          fontSize: 14,
          letterSpacing: -0.3,
          fontWeight: "400",
          lineHeight: 4,
          color: "secondary200Mobile"
        },
        myAccount_orderHistoryItem_pickpDate: {
          _web: {
            fontSize: {
              base: "12px",
              md: "13px"
            },
            fontWeight: 200,
            color: {
              base: "#606060",
              md: "#303030"
            }
          },
          fontSize: 14,
          letterSpacing: -0.3,
          fontWeight: "400",
          lineHeight: 4
        },
        myAccount_orderHistoryItem_orderTitle: {
          fontSize: 14,
          fontWeight: "200",
          lineHeight: 4,
          noOfLines: 2
        },
        myAccount_edit_fileds_sheet_title: {
          textAlign: "center",
          fontSize: 20,
          lineHeight: 6
        },
        myAccount_preferred_loc_title: {
          fontSize: 20,
          color: "#000",
          fontWeight: 400,
          mb: 6
        },
        myAccount_preferred_loc_card_title: {
          fontSize: 12,
          color: "#737373",
          fontWeight: 200,
          mb: 2
        },
        myAccount_paymentOptions_title: {
          fontSize: 20,
          fontWeight: 500,
          letterSpacing: "-0.3",
          marginLeft: 5,
          marginTop: 6,
          marginBottom: 3,
          color: "#70695C"
        },
        myAccount_paymentOptions_tapOnCard: {
          textAlign: "center",
          fontSize: 14,
          lineHeight: 5,
          color: "#70695C",
          fontWeight: 300
        },
        myAccount_paymentOptions_noSavedCards_message: {
          mt: 32,
          color: "grey300",
          fontSize: 16,
          fontWeight: 400,
          textAlign: "center",
          lineHeight: 5,
          _web: {
            mt: {
              base: 32,
              md: 8
            },
            textAlign: {
              base: "center",
              md: "left"
            },
            paddingLeft: {
              base: 0,
              md: 5
            }
          }
        },
        myAccount_paymentOptions_noSavedGiftCards_message: {
          color: "#8E8E8E",
          mt: 3,
          fontSize: 16,
          fontWeight: 300,
          textAlign: "center",
          lineHeight: 5,
          mb: 2
        },
        myAccount_paymentOptions_noSavedCreditCards_message: {
          color: "#8E8E8E",
          fontSize: 16,
          fontWeight: 300,
          textAlign: "center",
          lineHeight: 5,
          mt: 3,
          mb: 2
        },
        myAccount_paymentOptions_giftCards_addNew: {
          fontSize: 12,
          color: "secondary.300"
        },
        myAccount_paymentOptions_giftCards_addLimitMessage: {
          fontSize: 16,
          fontWeight: 300,
          lineHeight: 5,
          textAlign: "center",
          color: "#70695C"
        },
        myAccount_paymentOptions_giftCards_AddCTAText: {
          color: "profileAddCardButtonText",
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300
        },
        myAccount_paymentOptions_gc_maskedNumber: {
          fontSize: 11,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gc_number: {
          fontSize: 12,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gc_availableBalText: {
          fontSize: 8,
          pb: 0,
          color: "mobilePaymentsCardTextColor",
          _ios: {
            pb: 1
          }
        },
        myAccount_paymentOptions_gc_availableBal: {
          fontSize: 12,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gc_label: {
          fontSize: 8,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gc_bottomSheet_titleLabel: {
          pl: 7,
          textAlign: "center",
          fontSize: 20,
          lineHeight: 6,
          flex: 1
        },
        myAccount_order_history_order_details_modal_header_title: {
          fontSize: 20,
          color: "#2A2C25",
          fontWeight: 300
        },
        myAccount_order_history_title: {
          fontSize: 20,
          color: "#000",
          fontWeight: 400
        },
        myAccount_card_details_error_text: {
          color: "red.400",
          fontWeight: 400,
          fontSize: ["xs"],
          mt: 2
        },
        myAccount_consent_area_text: {
          marginLeft: 4,
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300,
          color: "addCardCheckboxTextColor",
          marginRight: 4,
          maxWidth: 72,
          accessible: false,
          _web: {
            maxWidth: "100%"
          }
        },
        myAccount_consent_area_default_card_text: {
          marginLeft: 4,
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300,
          color: "addCardCheckboxTextColor"
        },
        myAccount_add_gift_card_action_sheet_check_balance_text: {
          marginTop: 3.5,
          marginBottom: 3.5,
          fontSize: 16,
          lineHeight: 5,
          textAlign: "center",
          color: "#73994A",
          _web: {
            mt: {
              base: 5,
              md: 4
            },
            mb: {
              base: 5,
              md: 4
            }
          },
          fontWeight: 300
        },
        myAccount_add_gift_card_action_sheet_available_balance_text: {
          fontWeight: 300,
          color: "themeGrey",
          py: 2,
          textAlign: "center",
          mt: 5
        },
        myAccount_add_gift_card_action_sheet_error_message: {
          mb: 3,
          fontWeight: 300,
          fontSize: 12,
          color: "addCardModalValidWarningTextColor",
          lineHeight: 4,
          mt: 1
        },
        myAccount_ad_gift_card_action_sheet_save_for_future_use_text: {
          pt: 1,
          marginLeft: 4,
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300,
          color: "saveCardCheckbox"
        },
        myAccount_paymentOptions_gcl_number: {
          fontSize: 24,
          color: "mobilePaymentsCardTextColor",
          lineHeight: 8
        },
        myAccount_paymentOptions_gcl_AvailableBal_label: {
          fontSize: 17,
          lineHeight: 7,
          pb: 0,
          _ios: {
            pb: 1
          },
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gcl_bal: {
          fontSize: 24,
          color: "mobilePaymentsCardTextColor",
          lineHeight: 8
        },
        myAccount_paymentOptions_gcl_label: {
          fontSize: 15,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_AddGC_AS_AddText: {
          marginTop: 3.5,
          marginBottom: 3.5,
          fontSize: 16,
          lineHeight: 5,
          textAlign: "center",
          color: "saveCardAddButtonTextColor",
          _web: {
            mt: {
              base: 5,
              md: 4
            },
            mb: {
              base: 5,
              md: 4
            }
          },
          fontWeight: 300
        },
        myAccount_paymentOptions_showCC_BS_title: {
          textAlign: "center",
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          fontSize: 20,
          lineHeight: 6,
          _web: {
            flex: 1
          }
        },
        myAccount_updateQuestions_selectedText: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: "400",
          color: "securityQuestionTextColor"
        },
        myAccount_updateQuestions_asterisk: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: "400",
          color: "secondary.300"
        },
        myAccount_updateQuestions_options: {
          fontSize: 14,
          color: "grey300",
          lineHeight: 4,
          fontWeight: 400
        },
        empty_screen_description: {
          _ios: {
            color: "themeGrey"
          },
          _android: {
            color: "themeGrey"
          },
          fontSize: {
            base: "14px",
            md: "16px"
          },
          fontWeight: {
            base: 300
          },
          textAlign: "center",
          color: "reorderInfoTextColor"
        },
        empty_screen_order_togo_btn_text: {
          _ios: {
            paddingY: 1
          },
          _android: {
            paddingY: 1
          },
          _web: {
            fontWeight: "500"
          },
          color: "white"
        },
        order_history_details_text: {
          ml: 1,
          mr: 2,
          lineHeight: 6,
          fontSize: 16,
          fontWeight: 400,
          color: "#989182",
          _android: {
            flex: 1
          },
          _ios: {
            flex: 1
          }
        },
        order_history_details_order_from_text: {
          fontWeight: 200,
          fontSize: 11,
          lineHeight: 3,
          letterSpacing: 0.31,
          color: "orderHistoryOrderFrom"
        },
        order_history_details_restaurant_name_text: {
          fontWeight: 400,
          fontSize: 12,
          lineHeight: 4,
          letterSpacing: -0.6,
          mt: 1
        },
        order_history_details_restaurant_address_text: {
          fontSize: 12,
          lineHeight: 4,
          fontWeight: 300,
          color: "orderHistoryDetailsAddress"
        },
        order_history_details_pickup_time_text: {
          fontWeight: 200,
          fontSize: 11,
          lineHeight: 3,
          letterSpacing: 0.31,
          color: "orderHistoryOrderFrom",
          mb: 1
        },
        order_history_details_pickup_time_desc: {
          mt: 0,
          fontSize: 13,
          lineHeight: 4,
          fontWeight: 400,
          color: "orderHistoryDetailsAddress"
        },
        order_history_details_your_order_text: {
          mt: 2,
          ml: 5,
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          mb: 2
        },
        myAccount_userInfoCard_name: {
          lineHeight: 6,
          fontSize: 20,
          noOfLines: 3
        },
        myAccount_userInfoCard_email: {
          color: "myAccountScreenUserInfoTextColor",
          fontSize: 13,
          fontWeight: 300,
          lineHeight: 4
        },
        myAccount_userInfoCard_mobileNumber: {
          color: "myAccountScreenUserInfoTextColor",
          fontSize: 13,
          fontWeight: 300,
          lineHeight: 4,
          paddingTop: 0.5
        },
        myAccount_userInfoCard_editLabel: {
          color: "secondary.300",
          fontSize: 12,
          lineHeight: 4
        },
        myAccount_fallBackPictureText: {
          fontSize: 26,
          color: "secondary200Mobile"
        },
        myAccount_editFieldsConfirmationModalBodyText: {
          fontWeight: 300,
          fontSize: 18
        },
        // My Account ends

        /* RESERVATION */
        reservationListHeaderUpcoming: {
          fontSize: 18,
          fontWeight: 800,
          pb: 4
        },
        reservationCancelSuccessHeader: {
          fontSize: 20,
          fontWeight: 500,
          textAlign: "center",
          color: "#70695C"
        },
        reservationPoliteDressText: {
          fontSize: 14,
          fontWeight: 300,
          pt: 2
        },
        reservationMakeNewReservationCTA: {
          fontWeight: 500,
          fontSize: 20,
          color: "primary.100",
          textAlign: "center"
        },
        reservationCancelSuccessBody: {
          fontSize: 16,
          fontWeight: 200,
          lineHeight: 5,
          textAlign: "center",
          color: "#70695C"
        },
        joinWaitlist_Header_Logout: function joinWaitlist_Header_Logout() {
          return {
            textAlign: "end",
            textTransform: "uppercase",
            fontSize: 16,
            mt: 1,
            color: "primary.100"
          };
        },
        joinWaitlist_Header_MyAcc: function joinWaitlist_Header_MyAcc() {
          return {
            textAlign: "end",
            textTransform: "uppercase",
            fontSize: 16,
            mt: 1,
            color: "primary.100"
          };
        },
        joinWaitlist_Header_MyAcc_Mobile: function joinWaitlist_Header_MyAcc_Mobile() {
          return {
            fontSize: 8,
            mt: 1,
            color: "primary.100"
          };
        },
        reservtionPredferedLocationCardAddress: {
          fontWeight: "300",
          fontSize: 12,
          lineHeight: 4
        },
        reservationConfirmationDateTimeSizeText: {
          fontWeight: 500,
          lineHeight: 5,
          fontSize: 14
        },
        reservationConfirmationRestaurantName: {
          fontSize: {
            base: 14,
            md: 16
          },
          lineHeight: 5,
          fontWeight: 400,
          flexWrap: "wrap"
        },
        reservationConfirmationLocationAddress: {
          fontSize: {
            base: 12,
            md: 14
          },
          fontWeight: 200,
          lineHeight: 5,
          flexWrap: "wrap"
        },
        reservationConfirmationDirectionsText: {
          fontWeight: 500
        },
        reservationListCardDirections: {
          fontWeight: 700,
          lineHeight: 12,
          color: "primary.100",
          fontSize: 12
        },
        reservationListCardLocationText: {
          fontWeight: 400,
          fontSize: 11,
          color: "#989182",
          lineHeight: 5
        },
        reservationListCardRestName: {
          fontWeight: 500,
          fontSize: 12,
          color: "#70695C",
          lineHeight: 5
        },
        reservationListCardRestAddress: {
          fontSize: 12,
          fontWeight: 400,
          color: "#989182",
          lineHeight: 5
        },
        reservationsSelectFromAvailableSlotsTitle: {
          fontWeight: 600
        },
        reservationsReviewReservationsText: {
          fontWeight: 600
        },
        reservationsChangeLocationChangeText: {
          color: "primary.100",
          textTransform: "uppercase",
          fontSize: {
            base: "2xs",
            md: "sm"
          },
          fontWeight: 400
        },
        reservationThankyouConfirmationText: {
          fontSize: 18,
          fontWeight: 600,
          pb: 2,
          color: "primary.100",
          textAlign: "center"
        },
        reservationThankyouConfirmationSubText: {
          fontSize: 16,
          fontWeight: 600,
          textAlign: "center"
        },
        reservationSelectGuestText: {
          fontSize: 14,
          fontWeight: 400
        },
        reservationLocationCardHeader: {
          fontSize: {
            base: 14,
            md: 16
          },
          lineHeight: 5,
          fontWeight: 400
        },
        reservationLocationCardAddress: {
          lineHeight: 5,
          fontSize: 14,
          fontWeight: 200
        },
        reservationLocationModalHeaderText: {
          color: "#282C25",
          fontSize: 20,
          fontWeight: 300,
          textAlign: "center"
        },
        reservationFilterStateHeading: {
          fontSize: 20,
          color: "#2A2C25",
          fontWeight: 600,
          ml: {
            base: 0,
            md: 4
          },
          mt: {
            base: 4,
            md: 0
          },
          textTransform: "capitalize"
        },
        reservationTabsText: function reservationTabsText(_ref23) {
          var isActive = _ref23.isActive;
          return {
            textAlign: "center",
            color: isActive ? "#000" : "#FFF",
            fontSize: {
              base: 18,
              md: 20
            },
            mt: 2
          };
        },
        reservationDetailsHeaderText: {
          px: 5,
          fontSize: 20,
          fontWeight: 400,
          lineHeight: 5,
          color: "#70695C"
        },
        reservationPickerTopLabelText: {
          pb: 2,
          noOfLines: 1,
          fontSize: 12,
          color: "#707070",
          _web: {
            pb: 0,
            mb: {
              base: 1,
              md: 0
            }
          }
        },
        reservationPickerLabelText: {
          pt: 2,
          noOfLines: 1,
          fontSize: 12,
          _web: {
            pt: 0,
            mt: 1,
            width: "min-content",
            borderBottomWidth: 1
          }
        },
        reservationAddDetailsHeading: {
          px: 5,
          fontSize: 20,
          fontWeight: 400,
          lineHeight: 5,
          color: "grey300"
        },

        /* RESERVATION */
        advanceOrderMessageText: {
          fontWeight: 400,
          color: "#FF0000",
          fontSize: [12, 12, 14, 14, 14]
        },
        noCheckHeaderText: {
          fontFamily: "body",
          fontWeight: 500,
          fontSize: 22,
          lineHeight: 26,
          color: "#303030"
        },
        errorDialogBoxTitle: {
          fontSize: "lg",
          fontWeight: 400
        },
        OnboardingScreenTitleTextColor: {
          color: "#222828",
          fontWeight: "500"
        },
        OrderInfoBannerCartIconText: {
          _web: {
            pt: 1
          }
        },
        LoginHeaderText: {
          _web: {
            pt: 1
          }
        },
        checkoutTopLabelText: {
          _web: {
            pt: 1
          }
        },
        CheckOutHeaderText: {
          ml: 1
        },
        //checkDetails Start
        cdHeaderText: {
          fontSize: 16,
          lineHeight: 5,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        cdCheckItemsText: {
          fontSize: 16,
          lineHeight: 5,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        RecommendedPairingText: {
          color: "#989182"
        },
        cdBillingTileText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        cdTableDetailTileText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        successDialogTitleText: {
          lineHeight: 4
        },
        successDialogDescText: {
          _ios: {
            lineHeight: 4
          },
          _android: {
            lineHeight: 4
          }
        },
        orderConfirmationMobileNumberText: {
          lineHeight: 3,
          fontSize: {
            base: 15,
            lg: 14
          }
        },
        //checkDetails End
        // checkSummaryStart
        paymentCompleteText: {
          fontSize: 18,
          fontWeight: 400,
          lineHeight: 6,
          color: "#73994A"
        },
        checkSummaryTitle: {
          fontSize: 16,
          color: "#73994A",
          fontWeight: 600,
          fontFamily: "headingSecondary",
          lineHeight: 18
        },
        checkSummaryBodyText: {
          fontSize: 14,
          fontWeight: 400,
          lineHeight: 16,
          color: "#70695C"
        },
        checkSummaryEmailText: {
          fontSize: 14,
          fontWeight: 600,
          lineHeight: 16,
          color: "#70695C"
        },
        checkSummarySurveyText: {
          color: "secondary200Mobile",
          fontWeight: 500,
          lineHeight: 16,
          fontSize: 14
        },
        checkSummaryPriceText: {
          fontSize: 14,
          fontWeight: 400,
          lineHeight: 16,
          color: "#70695C"
        },
        totalPriceText: {
          fontSize: 16,
          fontWeight: 500,
          lineHeight: 20,
          color: "#70695C",
          fontFamily: "headingSecondary"
        },
        preAppliedDeductionPrice: {
          fontSize: 16,
          fontWeight: 600,
          lineHeight: 18,
          color: "#70695C",
          textAlign: "right"
        },
        // checkSummaryEnds
        paymentTileTitle: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          color: "#303030"
        },
        paymentTilePrice: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          color: "#73994a"
        },
        viewCheckText: {
          color: "#782434",
          fontWeight: 400,
          fontSize: 15,
          lineHeight: 5,
          textTransform: "uppercase"
        },
        paymentMethodsText: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 500,
          color: "#303030"
        },
        emailReceiptText: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 500,
          color: "#303030"
        },
        snackBarText: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 400,
          color: "#303030"
        },
        snackBarPrice: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 400,
          color: "secondary.300"
        },
        addGratuityText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300,
          color: "#303030"
        },
        camAccessText: {
          color: "#737373",
          lineHeight: 6,
          fontSize: 14
        },
        camAccessLinkText: {
          textDecoration: "underline",
          color: "primary.100"
        },
        gratuityTipNumbers: {
          fontSize: 15,
          fontFamily: "S52-Regular",
          color: "themeGrey",
          lineHeight: 3
        },
        stepsToMobilePayHeader: {
          fontFamily: "headingSecondary",
          fontSize: 28,
          color: "#303030",
          textTransform: "uppercase",
          ml: 5
        },
        mobilePayStepsHeading: {
          fontFamily: "body",
          fontWeight: 500,
          fontSize: 16,
          mt: 4,
          ml: 5,
          color: "#782434",
          _web: {
            letterSpacing: "-0.29px"
          },
          letterSpacing: "-0.29"
        },
        mobilePayStepsBody: {
          fontFamily: "body",
          fontWeight: 200,
          fontSize: 11,
          color: "#303030"
        },
        mobilePayVisitLink: {
          display: "block",
          position: "absolute",
          fontSize: 12,
          lineHeight: 12,
          opacity: "0.4",
          color: "#1B1B1B",
          bottom: "42%",
          left: {
            base: "36%",
            sm: "36%",
            md: "42%",
            lg: "45%"
          },
          textAlign: "center"
        },
        remoteCheckinNoteText: {
          _android: {
            lineHeight: 5
          },
          _ios: {
            lineHeight: 5
          },
          mt: 3,
          _web: {
            fontSize: "14px"
          },
          fontSize: "sm",
          fontWeight: 300,
          textAlign: "center"
        },
        //JWC STARTS
        jwcLeaveTheLineCancelBtn: {
          fontSize: 16,
          fontWeight: 400,
          color: "primary.100"
        },
        jwcLeaveTheLineContinueBtn: {
          fontSize: 16,
          fontWeight: 400
        },
        jwcLeaveTheLineModalTitle: {
          fontSize: 16,
          color: "#303030",
          fontFamily: "headingSecondary",
          textTransform: "uppercase"
        },
        jwcLeaveTheLineModalBody: {
          fontWeight: 300,
          fontSize: {
            base: 18,
            lg: 14
          },
          lineHeight: {
            base: 25,
            lg: 18
          },
          color: {
            base: "#606060",
            lg: "#020001"
          }
        },
        jwcEstWaitTimePrefix: {
          textAlign: "center",
          fontSize: 14,
          fontWeight: 300,
          lineHeight: 6,
          color: "#54301A"
        },
        jwcEstWaitTime: {
          lineHeight: 10,
          fontWeight: 400,
          textAlign: "center",
          fontSize: 32,
          color: "#54301A"
        },
        jwcRestDetails: {
          color: "#80603D",
          lineHeight: 4,
          fontSize: 12,
          fontWeight: 300
        },
        jwcRestName: {
          color: "#80603D",
          fontSize: 15,
          fontWeight: 400
        },
        jwcHowItWorksText: {
          fontSize: 14,
          fontWeight: 300,
          color: "white",
          textAlign: "center"
        },
        jwcOrderWhileYouWaitText: {
          textAlign: "center",
          color: {
            base: "white",
            lg: "#A2402A"
          },
          fontSize: 16,
          fontWeight: 400
        },
        qualityStoryCtaText: {
          textAlign: "center",
          color: {
            base: "#73994a",
            lg: "#73994a"
          },
          fontSize: 16,
          fontWeight: 400
        },
        jwcOrderAheadText: {
          fontSize: {
            base: 22,
            lg: 28
          },
          fontWeight: 600,
          color: "white",
          lineHeight: 32,
          textAlign: "center"
        },
        qualityStoryDescText: {
          fontSize: {
            base: 21,
            lg: 28
          },
          fontWeight: 600,
          color: "white",
          lineHeight: 32,
          textAlign: "center"
        },
        jwcHeaderDirectionsText: {
          color: "#A2402A",
          fontSize: 14
        },
        jwcHeaderLocationName: {
          color: "#303030",
          fontSize: 16,
          fontWeight: 300
        },
        jwcViewPdfMenu: {
          color: "#303030",
          fontSize: 14,
          fontWeight: 300
        },
        jwcLeaveTheLine: {
          color: "#303030",
          fontSize: 14,
          fontWeight: 300
        },
        jwcWaitTimeVary: {
          textAlign: "center",
          fontWeight: 300,
          fontSize: 18,
          color: " #2A2C25",
          lineHeight: 24
        },
        jwcPartySizeNumber: {
          fontWeight: 400,
          fontSize: 17,
          color: "#54301A"
        },
        jwcPartySize: {
          fontWeight: 300,
          fontSize: 17,
          color: "#54301A"
        },
        jwcTitle: {
          textAlign: "center",
          fontSize: 24,
          fontWeight: 500,
          color: "#54301A",
          mt: 6
        },
        jwcTitleText: {
          textAlign: "center",
          fontSize: 24,
          fontWeight: 500,
          color: "#54301A",
          mb: 4,
          mx: 1,
          lineHeight: 7,
          _ios: {
            mx: 2
          },
          _android: {
            mx: 2
          }
        },
        waitListFooterText: {
          marginTop: 2,
          fontSize: 14,
          fontWeight: 300,
          maxWidth: 74,
          textAlign: "center"
        },
        refreshIconText: {
          textTransform: "uppercase",
          fontSize: 12,
          color: "#A2402A",
          lineHeight: 14
        },
        waitlistCheckbackSoonTitle: {
          color: "#54301A",
          fontWeight: 300,
          fontSize: 20,
          lineHeight: 20
        },
        waitlistCheckbackSoonBody: {
          color: "#606060",
          pt: 4,
          fontWeight: 300,
          fontSize: 16,
          lineHeight: 20
        },
        leaveTheLineText: {
          fontWeight: 300,
          fontSize: 14,
          lineHeight: 16
        },
        leaveTheLineLinkText: {
          fontWeight: 300,
          fontSize: 14,
          lineHeight: 16
        },
        leaveWaitlistErrorModal: {
          fontWeight: 300,
          fontSize: 18,
          lineHeight: 25,
          _web: {
            letterSpacing: "-1px"
          },
          letterSpacing: "-1",
          color: "#606060"
        },
        waitlistErrorTitle: {
          fontWeight: 500,
          fontSize: 24,
          lineHeight: 24,
          _web: {
            letterSpacing: "-1px"
          },
          letterSpacing: "-1",
          color: "#2A2C25"
        },
        waitlistErrorBody: {
          fontWeight: 300,
          fontSize: 20,
          lineHeight: 28,
          _web: {
            letterSpacing: "-1px"
          },
          letterSpacing: "-1",
          color: "#606060",
          mt: 2,
          textAlign: "center",
          maxWidth: 253
        },
        waitTimeText: {
          checkinSuccessNoteTitleText: {
            color: "#FFFFFF",
            pt: 3,
            fontSize: 22,
            lineHeight: 42,
            _web: {
              letterSpacing: "-0.5px"
            },
            letterSpacing: "-0.5"
          },
          checkinSuccessNoteBodyText: {
            color: "#FFFFFF",
            pt: 1,
            maxWidth: 173,
            textAlign: "center",
            fontWeight: 300,
            fontSize: 14,
            lineHeight: 16,
            _web: {
              letterSpacing: "-0.5px"
            },
            letterSpacing: "-0.5"
          },
          fontWeight: 400,
          fontSize: 14,
          lineHeight: 16,
          mb: 2
        },
        waitTimeMins: {
          fontWeight: 400,
          fontSize: 32,
          lineHeight: 36
        },
        remoteCheckinWaitTimeThankYou: {
          fontSize: 24,
          fontWeight: 600,
          _web: {
            letterSpacing: "-0.3px"
          },
          letterSpacing: "-0.3"
        },
        remoteCheckinWaitTimePartySize: {
          fontSize: 14,
          fontWeight: 300,
          lineHeight: 14
        },
        remoteCheckinWaitTimeNote: {
          fontSize: 14,
          fontWeight: 100,
          lineHeight: 4
        },
        remoteCheckinRefreshBtn: {
          color: "remoteCheckinRefreshBtnColor",
          fontSize: 12,
          fontWeight: 600,
          marginY: 11,
          marginX: 5
        },
        confirmAndAddToCart: {
          textTransform: "uppercase",
          color: "white",
          fontWeight: 600
        },
        startingAtPrice: {
          color: "black",
          fontSize: 16,
          fontWeight: 500
        },
        startingAtText: {
          color: "black",
          fontSize: 16,
          fontWeight: 500
        },
        menuItemInfoPrice: {
          fontWeight: 300
        },
        categoryText: function categoryText(_ref24) {
          var isActive = _ref24.isActive;
          return {
            fontSize: {
              base: "sm",
              md: "sm"
            },
            fontWeight: isActive ? "600" : "400"
          };
        },
        noThanksText: {
          fontFamily: "heading",
          fontSize: "xl",
          textDecoration: "underline",
          textDecorationColor: "white",
          textAlign: "center",
          color: "white",
          _web: {
            fontSize: "28px",
            mt: 5
          },
          _ios: {
            mt: 0,
            fontSize: "16px",
            lineHeight: 8,
            letterSpacing: "-0.37",
            fontWeight: "400"
          },
          _android: {
            mt: 0,
            fontSize: "16px",
            lineHeight: 8,
            letterSpacing: "-0.37",
            fontWeight: "400"
          }
        },
        youMayLikeText: {
          fontFamily: "headingSecondary",
          fontSize: "3xl"
        },
        orderTypeText: {
          fontSize: "sm",
          fontWeight: "300"
        },
        nutritinalInfo: {
          _web: {
            fontSize: "18px"
          },
          fontWeight: 400
        },
        globalBannerCareer: function globalBannerCareer() {
          return {
            textTransform: "uppercase",
            fontWeight: 200,
            color: "#70695c",
            fontSize: {
              base: "10px",
              md: "10px",
              lg: "13px"
            },
            right: 0
          };
        },
        menuItemNameWeight: function menuItemNameWeight(_ref25) {
          var isFromSmartRecsOrFrequentlyOrdered = _ref25.isFromSmartRecsOrFrequentlyOrdered;
          return {
            fontWeight: 300,
            fontSize: [14, 14, 14, isFromSmartRecsOrFrequentlyOrdered ? 14 : 20]
          };
        },
        listDescriptionText: function listDescriptionText() {
          return {
            _web: {
              fontSize: 14,
              fontWeight: 300,
              fontFamily: "heading"
            }
          };
        },
        categoryFontSize: function categoryFontSize() {
          return {
            _web: {
              fontSize: {
                base: "36px",
                md: "60px"
              }
            },
            _ios: {
              fontSize: [26, 26, 36]
            },
            _android: {
              fontSize: [26, 26, 36]
            },
            fontWeight: 600,
            fontFamily: "S52-Regular"
          };
        },
        subCategoryFontSize: function subCategoryFontSize() {
          return {
            // TODO: desktop UI
            _web: {
              fontSize: {
                base: "26px",
                md: "46px"
              }
            },
            _ios: {
              fontSize: [18, 18, 28]
            },
            _android: {
              fontSize: [18, 18, 28]
            },
            fontWeight: 600,
            fontFamily: "S52-Regular"
          };
        },
        subSubCategoryFontSize: function subSubCategoryFontSize() {
          return {
            // TODO: desktop UI
            _web: {
              fontSize: {
                base: "16px",
                md: "28px"
              }
            },
            _ios: {
              fontSize: [16, 16, 24]
            },
            _android: {
              fontSize: [16, 16, 24]
            },
            color: "#70695C",
            fontWeight: 600
          };
        },
        locationText: {
          color: "#989182",
          fontSize: "sm",
          fontFamily: "body"
        },
        phoneNumberText: {
          color: "#989182",
          fontSize: "sm",
          fontFamily: "body"
        },
        btnText: {
          color: "#989182",
          fontFamily: "heading"
        },
        headerText: {
          color: "primary.100",
          fontSize: 32,
          fontWeight: 300
        },
        cartItemCancelText: {
          fontSize: 13,
          lineHeight: 4,
          textTransform: "uppercase",
          color: "secondary.300",
          fontWeight: 500
        },
        checkoutText: {
          fontSize: "xl",
          lineHeight: 6,
          fontWeight: 400,
          color: "white",
          textTransform: "uppercase"
        },
        addMoreItemsText: {
          fontSize: "md",
          fontWeight: 600,
          lineHeight: 5,
          textTransform: "uppercase",
          color: "secondary.300"
        },
        checkoutPriceText: {
          fontSize: 22,
          lineHeight: 5,
          fontWeight: 400,
          color: "white"
        },
        menuItemDetailsPropertyAccordionHeading: function menuItemDetailsPropertyAccordionHeading(_ref26) {
          var isMandatory = _ref26.isMandatory;
          return {
            _web: {
              // TODO: desktop font size | styles
              fontSize: {
                base: "md",
                md: "2xl"
              },
              letterSpacing: "-0.3px"
            },
            _android: {
              letterSpacing: 1
            },
            _ios: {
              letterSpacing: 1
            },
            lineHeight: {
              base: 7,
              md: 10
            },
            fontWeight: 500,
            color: isMandatory ? "white" : "menuDetailAccordionTextColor",
            fontFamily: "headingSecondary",
            textTransform: "capitalize"
          };
        },
        skuMenuItemDetailsPropertyAccordionHeading: function skuMenuItemDetailsPropertyAccordionHeading(_ref27) {
          var isMandatory = _ref27.isMandatory;
          return {
            _web: {
              // TODO: desktop font size | styles
              fontSize: {
                base: "md",
                md: "2xl"
              },
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            lineHeight: {
              base: 7,
              md: 10
            },
            fontWeight: 500,
            color: isMandatory ? "white" : "menuDetailAccordionTextColor",
            fontFamily: "headingSecondary",
            textTransform: "capitalize"
          };
        },
        menuItemDetailsQuestionVarient: function menuItemDetailsQuestionVarient(_ref28) {
          var isMobile = _ref28.isMobile;
          return {
            _web: {
              fontSize: {
                base: "2xl",
                md: "md"
              },
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            lineHeight: {
              base: 7,
              md: 5
            },
            fontWeight: {
              base: 300,
              md: 500
            },
            color: "themeTextColor",
            textTransform: isMobile && "uppercase",
            fontFamily: isMobile ? "headingSecondary" : "body"
          };
        },
        menuItemDetailsIsRequiredMark: function menuItemDetailsIsRequiredMark() {
          return {
            fontSize: {
              base: "xs",
              md: "md"
            },
            _web: {
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            fontWeight: 300,
            color: "white",
            lineHeight: {
              base: 4,
              md: 5
            },
            alignSelf: "center"
          };
        },
        menuItemDetailsPropertyAccordionRightText: function menuItemDetailsPropertyAccordionRightText() {
          return {
            fontSize: {
              base: "xs",
              md: "sm"
            },
            lineHeight: 5,
            color: "white",
            _web: {
              letterSpacing: "-0.3 px"
            },
            letterSpacing: "-0.3"
          };
        },
        menuDetailPropertyAccordionDescription: function menuDetailPropertyAccordionDescription(_ref29) {
          var isDefaultExpanded = _ref29.isDefaultExpanded;
          return {
            fontSize: {
              base: "xs",
              md: "md"
            },
            lineHeight: {
              base: 4,
              md: 5
            },
            fontWeight: 400,
            _web: {
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            color: isDefaultExpanded ? "white" : "#989182"
          };
        },
        menuDetailErrorText: function menuDetailErrorText() {
          return {
            fontSize: "xs",
            color: "white",
            fontWeight: 400,
            lineHeight: 4
          };
        },
        mobilePayHeaderBtnText: function mobilePayHeaderBtnText() {
          return {
            fontSize: {
              base: 14,
              md: 18
            },
            fontWeight: 400,
            color: "secondary.300"
          };
        },
        confirmPickupDetailsChangeBtnText: function confirmPickupDetailsChangeBtnText() {
          return {
            fontSize: 14,
            fontWeight: 700,
            color: "orderConfirmationTextColor"
          };
        },
        confirmPickupDetailsText: function confirmPickupDetailsText() {
          return {
            color: "orderConfirmationTextColor",
            fontWeight: 400,
            lineHeight: 4,
            fontSize: 12,
            _web: {
              letterSpacing: "2px"
            },
            letterSpacing: 1
          };
        },
        menuItemInfoName: function menuItemInfoName() {
          return {
            mb: 2,
            _web: {
              fontSize: ["xl", "xl", "24px"]
            },
            fontSize: ["xl", "xl", 10],
            fontWeight: 300
          };
        },
        menuItemInfoPriceStartingAt: function menuItemInfoPriceStartingAt() {
          return {
            _web: {
              fontSize: {
                base: "13px",
                md: "18px"
              }
            },
            fontSize: {
              base: 3,
              md: 4
            },
            fontWeight: 400
          };
        },
        orderSettingsText: function orderSettingsText() {
          return {
            fontWeight: "600",
            fontSize: "sm"
          };
        },
        backToMenu: {
          fontFamily: "headingSecondary",
          fontSize: "xl",
          lineHeight: 6
        },
        emptyCartText: {
          fontSize: "lg",
          fontWeight: 300,
          lineHeight: 6
        },
        addToCardButtonPriceText: function addToCardButtonPriceText() {
          return {
            color: "white",
            fontSize: {
              base: "sm",
              md: "xl"
            },
            _web: {
              fontSize: {
                base: "14px",
                md: "24px"
              }
            },
            fontWeight: 400,
            fontFamily: "heading"
          };
        },
        addToCardButtonText: function addToCardButtonText() {
          return {
            color: "white",
            fontSize: {
              base: "sm",
              md: "xl"
            },
            _web: {
              fontSize: {
                base: "14px",
                md: "24px"
              }
            },
            fontWeight: 400,
            fontFamily: "heading"
          };
        },
        allLocationsSelectHeading: {
          fontSize: 28,
          fontWeight: 600,
          color: "#989182"
        },
        allLocationsSelectText: {
          fontSize: {
            base: 16,
            md: 20
          },
          fontWeight: 600,
          color: "#989182"
        },
        allLocationsText: function allLocationsText(_ref30) {
          var isLocationSearchPage = _ref30.isLocationSearchPage;
          return {
            fontSize: 20,
            color: isLocationSearchPage ? "#2A2C25" : "#739849",
            fontWeight: 600
          };
        },
        allLocationsLengthText: {
          fontSize: 16,
          color: "#606060",
          fontWeight: 300
        },
        addBtnText: function addBtnText(_ref31) {
          var addButtonText = _ref31.addButtonText;
          return {
            color: "white",
            textTransform: "uppercase",
            fontSize: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? 10 : 18,
            overflowWrap: "break-word",
            maxWidth: {
              base: "70px",
              md: "110px"
            },
            textAlign: "center",
            marginBottom: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? "2px" : 0,
            _ios: {
              maxWidth: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? "100%" : "70px"
            },
            _android: {
              maxWidth: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? "100%" : "70px"
            }
          };
        },
        menuItemPrice: {
          fontSize: {
            base: 12,
            lg: 16
          },
          fontWeight: 500,
          pr: 1
        },
        menuItemCalorieText: {
          fontSize: [12, 12, 16],
          fontWeight: 300,
          pl: 1
        },
        confirmPickupDetailsHeaderText: {
          textTransform: "uppercase",
          fontSize: 16,
          color: "#72994C",
          fontWeight: 600,
          fontFamily: "headingSecondary"
        },
        confirmPickupDetailsRestaurant: {
          fontSize: 14,
          color: "#989182",
          fontWeight: 600
        },
        menuListTextCTA: {
          fontWeight: 300,
          fontSize: [10, 10, 14, 16, 16]
        },
        cartHeaderLocationName: {
          color: "primary.100",
          fontWeight: 600
        },
        cartItemMenuName: function cartItemMenuName(_ref32) {
          var inOrderDetails = _ref32.inOrderDetails;
          return {
            color: inOrderDetails ? "#70695C" : "menuItemNameColor",
            fontWeight: 500,
            fontSize: 17
          };
        },
        cartItemPrice: function cartItemPrice() {
          return {
            fontSize: "sm"
          };
        },
        cartMessageText: function cartMessageText() {
          return {
            fontWeight: 300,
            fontSize: "xs"
          };
        },
        checkoutNoOfItems: function checkoutNoOfItems() {
          return {
            fontSize: "xs",
            pt: 2,
            _web: {
              pt: "6px"
            }
          };
        },
        cartHeaderOrderType: {
          fontWeight: 400,
          color: "#989182"
        },
        cartItemRemoveText: {
          fontSize: 13,
          lineHeight: 4,
          textTransform: "uppercase",
          color: "white",
          fontWeight: 500
        },
        reorderAddButtonText: {
          fontSize: 18,
          fontWeight: 600,
          color: "reOrderAddBtnBorder"
        },
        pdfMenuButtonText: {
          my: 1,
          _web: {
            mt: 0
          }
        },
        locationListRestaurantName: function locationListRestaurantName(_ref33) {
          var isFromLocationSearch = _ref33.isFromLocationSearch;
          return {
            fontWeight: isFromLocationSearch ? 600 : 400,
            fontSize: isFromLocationSearch ? "24px" : "sm",
            lineHeight: 18,
            textAlign: "left",
            color: "#989182",
            fontFamily: isFromLocationSearch ? "S52-Regular" : "Barlow-Medium"
          };
        },
        locationListRestaurantDetails: function locationListRestaurantDetails(_ref34) {
          var isFromLocationSearch = _ref34.isFromLocationSearch;
          return {
            fontSize: {
              base: "xs",
              md: "sm"
            },
            _web: {
              width: isFromLocationSearch ? "100%" : "70%",
              lineHeight: "18px"
            },
            fontWeight: 300,
            lineHeight: 14
          };
        },
        locationListResturantAddressSecondLine: {
          marginTop: 1,
          marginBottom: 0.5
        },
        confirmationPickupRestName: {
          fontSize: {
            base: 12,
            lg: 16
          },
          lineHeight: 3
        },
        confirmationPickupRestNameTitle: {
          fontSize: {
            base: 12,
            lg: 16
          },
          lineHeight: 3
        },
        confirmationPickupResAdd1: {
          lineHeight: 4,
          marginBottom: 1,
          fontSize: {
            base: 15,
            lg: 14
          }
        },
        confirmationPickupResAdd2: {
          lineHeight: 4,
          fontSize: {
            base: 15,
            lg: 14
          }
        },
        confirmationSurveyHeader: function confirmationSurveyHeader() {
          return {
            color: "confirmationPrimary",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationSurveyText: function confirmationSurveyText() {
          return {
            color: "confirmationThemeDark",
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        // @ts-ignore
        confirmationEclubHeader: function confirmationEclubHeader() {
          return {
            color: "confirmationPrimary",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationEclubEmail: function confirmationEclubEmail() {
          return {
            color: "confirmationThemeDark"
          };
        },
        confirmationEclubChangeEmail: function confirmationEclubChangeEmail() {
          return {
            color: "confirmationPrimary",
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        confirmationEclubCheckboxText: function confirmationEclubCheckboxText() {
          return {
            color: "confirmationThemeDark"
          };
        },
        confirmationAccountHeader: function confirmationAccountHeader() {
          return {
            color: "#70695c",
            fontSize: {
              base: 16,
              lg: 20
            },
            fontWeight: "600",
            fontFamily: "heading"
          };
        },
        confirmationAccountEmail: function confirmationAccountEmail() {
          return {
            color: "confirmationThemeDark",
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        confirmationPickupMyOrderHeader: function confirmationPickupMyOrderHeader() {
          return {
            color: "confirmationPrimary",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationPickupDetailsHeader: function confirmationPickupDetailsHeader() {
          return {
            color: "confirmationPrimary",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationPickupDetailsSubTitle: function confirmationPickupDetailsSubTitle() {
          return {
            color: "confirmationAccentDark",
            fontSize: {
              base: 12,
              lg: 13
            }
          };
        },
        confirmationThankYouTitle: function confirmationThankYouTitle() {
          return {
            color: "#70695c",
            _ios: {
              color: "#73994A",
              fontSize: 18,
              textTransform: "capitalize"
            },
            _android: {
              color: "#73994A",
              fontSize: 18,
              textTransform: "capitalize"
            },
            fontSize: {
              base: 24,
              lg: 42
            },
            letterSpacing: {
              base: "-0.5px",
              lg: "-2px"
            },
            fontWeight: "600",
            fontFamily: "heading",
            _web: {
              fontFamily: "heading"
            }
          };
        },
        confirmationThankYouMailText: function confirmationThankYouMailText() {
          return {
            color: "#494949",
            fontSize: {
              base: 18,
              lg: 22
            },
            fontWeight: "300",
            fontFamily: "S52-Light",
            letterSpacing: "-0.5px"
          };
        },
        confirmationThankYouMail: function confirmationThankYouMail() {
          return {
            color: "#282C25",
            fontSize: {
              base: 18,
              lg: 22
            },
            fontWeight: "500",
            fontFamily: "S52-Bold",
            letterSpacing: "-0.5px"
          };
        },
        confirmationThankYouDetailTitle: function confirmationThankYouDetailTitle() {
          return {
            color: "#494949",
            fontSize: {
              base: 18
            },
            fontFamily: "S52-Light",
            letterSpacing: {
              base: "-0.5px",
              lg: "-2px"
            }
          };
        },
        confirmationHowToText: function confirmationHowToText() {
          return {
            fontSize: {
              base: 12,
              lg: 14
            },
            color: "#494949"
          };
        },
        confirmationMarketingTitle: function confirmationMarketingTitle() {
          return {
            color: "confirmationPrimary",
            fontWeight: 400,
            fontSize: {
              base: 12,
              lg: 14
            }
          };
        },
        confirmationMarketingSubtitle: function confirmationMarketingSubtitle() {
          return {
            color: "confirmationAccent",
            fontWeight: "300",
            fontSize: 12
          };
        },
        confirmationOrderDetailsTitle: function confirmationOrderDetailsTitle() {
          return {
            color: "confirmationPrimary"
          };
        },
        confirmationOrderTotalItem: function confirmationOrderTotalItem(_ref35) {
          var fromOrderHistory = _ref35.fromOrderHistory;
          return {
            fontFamily: fromOrderHistory ? "Barlow-Regular" : "S52-Light",
            fontSize: {
              base: fromOrderHistory ? 16 : 19,
              lg: fromOrderHistory ? 18 : 22
            },
            letterSpacing: "-0.5px",
            color: fromOrderHistory ? "#989182" : "#000000"
          };
        },
        confirmationOrderTotalLabel: function confirmationOrderTotalLabel(_ref36) {
          var fromOrderHistory = _ref36.fromOrderHistory;
          return {
            fontFamily: fromOrderHistory ? "Barlow-Regular" : "S52-Bold",
            fontSize: {
              base: fromOrderHistory ? 18 : 23,
              lg: fromOrderHistory ? 22 : 27
            },
            letterSpacing: {
              base: "-0.5px",
              lg: "-1px"
            },
            color: fromOrderHistory ? "#70695C" : "black",
            fontWeight: 600
          };
        },
        confirmationOrderTotal: function confirmationOrderTotal(_ref37) {
          var fromOrderHistory = _ref37.fromOrderHistory;
          return {
            fontFamily: fromOrderHistory ? "Barlow-Regular" : "S52-Bold",
            fontSize: {
              base: fromOrderHistory ? 18 : 23,
              lg: fromOrderHistory ? 22 : 27
            },
            letterSpacing: {
              base: "-0.5px",
              lg: "-1px"
            },
            color: fromOrderHistory ? "#70695C" : "#303030",
            fontWeight: 600
          };
        },
        confirmationPaymentDetailsTitle: function confirmationPaymentDetailsTitle(_ref38) {
          var fromOrderHistory = _ref38.fromOrderHistory;
          return {
            fontFamily: fromOrderHistory ? "Barlow-Medium" : "S52-Regular",
            fontSize: {
              base: fromOrderHistory ? 14 : 21,
              lg: fromOrderHistory ? 16 : 24
            },
            letterSpacing: "-0.5px",
            color: fromOrderHistory ? "#70695C" : "confirmationPrimary"
          };
        },
        confirmationOrderNumber: function confirmationOrderNumber() {
          return {
            fontSize: {
              base: 18,
              lg: 20
            },
            fontFamily: "S52-Regular",
            letterSpacing: "-0.5px"
          };
        },
        confirmationSpecialInstructionTitle: function confirmationSpecialInstructionTitle() {
          return {
            fontFamily: "S52-Bold",
            fontSize: {
              base: 18,
              lg: 22
            },
            letterSpacing: "-0.5px"
          };
        },
        confirmationSpecialInstructionSubTitle: function confirmationSpecialInstructionSubTitle() {
          return {
            fontFamily: "S52-Light",
            fontSize: {
              base: 18,
              lg: 22
            },
            letterSpacing: "-0.5px"
          };
        },
        confirmationCardChargeInfo: function confirmationCardChargeInfo() {
          return {
            fontFamily: "S52-Light",
            fontSize: {
              base: 18,
              lg: 22
            },
            letterSpacing: "-0.5px"
          };
        },
        confirmationChangesHeader: function confirmationChangesHeader() {
          return {
            color: "confirmationPrimary",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        cartItemMenuPropertyName: function cartItemMenuPropertyName(_ref39) {
          var inOrderDetails = _ref39.inOrderDetails;
          return {
            color: inOrderDetails ? "#70695C" : "#989182"
          };
        },
        confirmationSvgCenteredText: function confirmationSvgCenteredText() {
          return {
            pb: {
              base: "1px",
              lg: "2px"
            }
          };
        },
        //OC AddressAndTime variants start
        confirmationPickupRestaurantTitle: function confirmationPickupRestaurantTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationPickupDateTimeTitle: function confirmationPickupDateTimeTitle() {
          return {
            fontWeight: "300",
            _ios: {
              py: 0
            },
            _android: {
              py: 0
            },
            fontSize: {
              base: 15,
              lg: 14
            }
          };
        },
        confirmationPickupDateTimeValue: function confirmationPickupDateTimeValue() {
          return {
            fontSize: {
              base: 15,
              lg: 16
            },
            letterSpacing: -0.4,
            fontWeight: "400",
            color: "pickupRestaurantName",
            marginBottom: 1
          };
        },
        confirmationPickupPersonDetails: function confirmationPickupPersonDetails() {
          return {
            fontSize: {
              base: 14,
              lg: 16
            },
            textTransform: "capitalize",
            lineHeight: 4,
            fontWeight: "400",
            letterSpacing: -0.3
          };
        },
        confirmationDeliveryAddressTitle: function confirmationDeliveryAddressTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationDeliveryRestaurantTitle: function confirmationDeliveryRestaurantTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationDeliveryDateTimeTitle: function confirmationDeliveryDateTimeTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationDeliveryGuestsTitle: function confirmationDeliveryGuestsTitle() {
          return {
            fontWeight: "300"
          };
        },
        //OC AddressAndTime variants end
        orderTrackingCallHelpText: {
          fontSize: "sm",
          fontWeight: 400,
          lineHeight: 5
        },
        orderStatusTrackingTitle: function orderStatusTrackingTitle() {
          return {
            color: "primary.100",
            fontWeight: 400,
            fontSize: "xl",
            lineHeight: 6
          };
        },
        orderStatusTitle: function orderStatusTitle() {
          return {
            fontSize: "sm",
            fontWeight: 400,
            lineHeight: 6,
            color: "orderStatusText"
          };
        },
        orderStatusSubText: function orderStatusSubText() {
          return {
            fontSize: "xs",
            fontWeight: 300,
            lineHeight: 3,
            color: "orderStatusText"
          };
        },
        orderStatusTime: function orderStatusTime() {
          return {
            fontSize: "xs",
            fontWeight: 400,
            lineHeight: 3,
            color: "orderStatusText"
          };
        },
        orderStatusPayNowButtonText: function orderStatusPayNowButtonText() {
          return {
            fontSize: "lg",
            lineHeight: 6,
            fontWeight: 400,
            color: "white"
          };
        },
        orderStatusCurbsideCheckInButtonPrimary: function orderStatusCurbsideCheckInButtonPrimary() {
          return {
            fontSize: "lg",
            lineHeight: 6,
            fontWeight: 400,
            color: "curbsideCheckInPrimary"
          };
        },
        orderStatusCurbsideCheckInButtonSecondary: function orderStatusCurbsideCheckInButtonSecondary() {
          return {
            fontSize: "lg",
            lineHeight: 6,
            fontWeight: 400,
            color: "curbsideCheckInSecondary"
          };
        },
        orderStatusDeatilsTitle: function orderStatusDeatilsTitle() {
          return {
            fontSize: "lg",
            lineHeight: 6,
            fontWeight: 400,
            color: "#4D2C42",
            marginBottom: 3.5
          };
        },
        otCurbsideVehicleDetailsTitle: function otCurbsideVehicleDetailsTitle() {
          return {
            fontSize: "xs",
            lineHeight: 3,
            fontWeight: 300,
            color: "#606060",
            marginBottom: 1
          };
        },
        otCurbsideVehicleDetails: function otCurbsideVehicleDetails() {
          return {
            fontSize: "sm",
            lineHeight: 4,
            fontWeight: 400,
            textTransform: "capitalize"
          };
        },
        refreshButtonText: function refreshButtonText() {
          return {
            fontSize: "xs",
            fontWeight: 400,
            color: "refreshButtonColor"
          };
        },
        autoRefreshText: function autoRefreshText() {
          return {
            fontSize: "xs",
            fontWeight: 400,
            color: "refreshButtonColor"
          };
        },
        orderTrackingLocationTimeSectionText: {
          ml: 2,
          fontSize: "sm",
          lineHeight: 6,
          fontWeight: 400
        },
        waitlistLocationName: {
          fontSize: 14,
          fontWeight: 400,
          color: "#303030"
        },
        waitlistLocationShare: {
          fontSize: 12,
          fontWeight: 400,
          color: "#B31900",
          textTransform: "uppercase"
        },
        waitlistBannerText: {
          fontSize: 14,
          fontWeight: 300,
          color: "white",
          pl: 8
        },
        waitlistTableHeaderText: {
          fontSize: {
            base: 10,
            md: 12,
            lg: 14
          },
          color: "#303030",
          fontWeight: 400,
          py: 4,
          textAlign: "center"
        },
        waitlistTableText: {
          fontSize: {
            base: 12,
            md: 12,
            lg: 14
          },
          color: "#303030",
          fontWeight: 300,
          py: 4,
          textAlign: "center"
        },
        waitlistTableNotUserName: {
          style: {
            color: "#fff0",
            textShadowColor: "rgba(0,0,0,1)",
            textShadowOffset: {
              width: 0,
              height: 0
            },
            textShadowRadius: 10
          }
        },
        refreshWaitlist: {
          fontWeight: 300
        },
        waitlistDisclaimer: {
          fontWeight: 300
        },
        waitlistOrder: {
          color: "#73994A",
          textTransform: "uppercase",
          fontWeight: 500,
          fontSize: 12
        },
        waitlistFooterHowItWorks: {
          fontWeight: 400,
          color: "secondary.300",
          fontSize: 14
        },
        myLocationsLoginText: {
          fontWeight: 700,
          fontSize: 18,
          color: "secondary.300",
          textTransform: "uppercase"
        },
        orderStatusTimeMessage: function orderStatusTimeMessage() {
          return {
            marginTop: 2,
            fontSize: "xs",
            fontWeight: 400,
            lineHeight: 3,
            color: "orderStatusText"
          };
        },
        checkText: function checkText() {
          return {
            fontSize: "xs",
            fontWeight: 300,
            color: "checkText"
          };
        },
        checkAmount: function checkAmount() {
          return {
            fontSize: "xs",
            fontWeight: 400,
            color: "checkText"
          };
        },
        curbsideCheckInAvailableText: function curbsideCheckInAvailableText() {
          return {
            fontSize: "sm",
            lineHeight: 5,
            fontWeight: 300,
            textAlign: "center",
            color: "curbsideCheckInAvailable"
          };
        },
        // new
        deliveryErrorText: function deliveryErrorText() {
          return {
            fontSize: {
              base: "xs",
              md: "sm"
            },
            color: "#721C24",
            fontWeight: 300,
            lineHeight: 4
          };
        },
        menuItemInfoCalorie: function menuItemInfoCalorie() {
          return {
            _web: {
              fontSize: {
                base: "14px",
                md: "14px"
              }
            },
            fontSize: {
              base: 3,
              md: 3
            },
            fontWeight: "400"
          };
        },
        skuSelectorItemPriceText: function skuSelectorItemPriceText() {
          return {
            fontWeight: 500,
            fontSize: {
              base: 14,
              md: 16
            }
          };
        },
        skuSelectorItemName: function skuSelectorItemName() {
          return {
            fontWeight: 400,
            fontSize: {
              base: 14,
              md: 18
            }
          };
        },
        mobileAuthHeaderText: function mobileAuthHeaderText() {
          return {
            fontWeight: 300,
            fontSize: 24,
            color: "#505050"
          };
        },
        mobileOrderDetailsHeader: function mobileOrderDetailsHeader() {
          return {
            fontWeight: 400,
            fontSize: 18
          };
        },
        mobileOrderDetailsStatic: function mobileOrderDetailsStatic() {
          return {
            fontWeight: 300,
            fontSize: 12
          };
        },
        mobileOrderDetailsInput: function mobileOrderDetailsInput() {
          return {
            fontWeight: 400,
            fontSize: 16
          };
        },
        temperatureSelectLabel: function temperatureSelectLabel() {
          return {
            color: "#B0B0B0",
            fontSize: "lg",
            fontFamily: "headingSecondary"
          };
        },
        sectionHeaderText: function sectionHeaderText() {
          return {
            color: "#303030",
            fontWeight: 600
          };
        },
        subSectionHeaderText: function subSectionHeaderText() {
          return {
            color: "#303030",
            fontWeight: 600
          };
        },
        notificationsPopupText: function notificationsPopupText() {
          return {
            color: "#303030",
            fontWeight: 600
          };
        },

        /* Restaurant Details Start */
        //Restaurant Info
        restaurantDetails_RestInfo_AddToFavoritesText: function restaurantDetails_RestInfo_AddToFavoritesText() {
          return {
            alignItems: "center",
            color: "restaurantInfoAddToFavouritiesTextColor",
            fontSize: {
              base: "14px",
              lg: "16px"
            },
            ml: "3",
            h: "20px",
            //font specific styles
            pt: "1px"
          };
        },
        restaurantDetails_RestInfo_TitleText: function restaurantDetails_RestInfo_TitleText() {
          return {
            fontWeight: "600",
            fontFamily: "S52-Bold",
            color: "restDetailsRestInfoTitleColor",
            mb: {
              base: "2",
              lg: "0"
            },
            textTransform: "uppercase",
            fontSize: {
              base: "24px",
              lg: "42px"
            },
            textAlign: {
              base: "center",
              lg: "normal"
            }
          };
        },
        restaurantDetails_RestInfo_OpensText: function restaurantDetails_RestInfo_OpensText() {
          return {
            fontWeight: "500",
            fontSize: {
              base: "xs",
              lg: "sm"
            },
            color: "restDetailsRestInfoTitleColor"
          };
        },
        restaurantDetails_RestInfo_DateText: function restaurantDetails_RestInfo_DateText() {
          return {
            fontWeight: "500",
            fontSize: {
              base: "xs",
              lg: "sm"
            },
            color: "restDetailsRestInfoTitleColor",
            textTransform: "uppercase"
          };
        },
        restaurantDetails_RestInfo_AddressText: function restaurantDetails_RestInfo_AddressText() {
          return {
            fontWeight: 300,
            lineHeight: 6,
            px: 4,
            fontSize: {
              base: 14,
              lg: 16
            },
            _web: {
              lineHeight: {
                base: 5,
                lg: 7
              },
              my: 4,
              px: 0,
              style: {
                "text-underline-offset": "3px"
              }
            },
            textAlign: {
              base: "center",
              lg: "flex-start"
            },
            w: "100%",
            _ios: {
              flex: 1
            },
            _android: {
              flex: 1
            },
            textDecoration: "underline",
            textDecorationColor: "primary.100",
            color: "primary.100"
          };
        },
        restaurantDetails_RestInfo_PhoneNumberText: function restaurantDetails_RestInfo_PhoneNumberText(_ref40) {
          var customMarginHorizontal = _ref40.customMarginHorizontal;
          return {
            _ios: {
              mx: customMarginHorizontal || 0
            },
            _android: {
              mx: customMarginHorizontal || 0
            },
            marginLeft: 1,
            fontWeight: 300,
            fontSize: {
              base: 14,
              lg: 18
            },
            color: "primary.100"
          };
        },
        restaurantDetails_RestInfo_DistanceText: function restaurantDetails_RestInfo_DistanceText() {
          return {
            fontWeight: "300",
            fontSize: "14px",
            color: "#C16436"
          };
        },
        restaurantDetails_RestInfo_GetDirectionsText: function restaurantDetails_RestInfo_GetDirectionsText() {
          return {
            color: "amenitiesActionButtonsColor",
            fontSize: {
              base: "14px",
              lg: "16px"
            }
          };
        },
        //Restaurant Waitlist
        restaurantDetails_RestWaitlist_WaitlistAvailabilityDescText: function restaurantDetails_RestWaitlist_WaitlistAvailabilityDescText() {
          return {
            mb: "6",
            fontSize: {
              base: 14,
              lg: 16
            },
            fontWeight: 300,
            px: 6,
            maxW: {
              lg: "350",
              xl: "400"
            },
            textAlign: "center",
            mx: "auto",
            color: {
              base: "#404040",
              lg: "#303030"
            }
          };
        },
        restaurantDetails_RestWaitlist_WaitlistAvailabilityRestName: function restaurantDetails_RestWaitlist_WaitlistAvailabilityRestName() {
          return {
            color: "#404040"
          };
        },
        restaurantDetails_RestWaitlist_WaitlistAvailabilityPartySize: function restaurantDetails_RestWaitlist_WaitlistAvailabilityPartySize() {
          return {
            fontWeight: "300",
            fontSize: 14,
            color: "#404040"
          };
        },
        //Restaurant CurrentStatus and Waitlist
        restaurantDetails_RestWaitlist_CurrentStatusText: function restaurantDetails_RestWaitlist_CurrentStatusText() {
          return {
            fontWeight: "300",
            color: "#606060",
            fontSize: {
              base: "14",
              lg: "16"
            }
          };
        },
        restaurantDetails_RestWaitlist_AvailabilityText: function restaurantDetails_RestWaitlist_AvailabilityText() {
          return {
            _ios: {
              marginLeft: 4
            },
            _android: {
              marginLeft: 4
            },
            fontSize: "14px",
            fontWeight: "300",
            color: "restaurantWaitlistTextColor",
            maxWidth: {
              base: 40,
              lg: "none"
            },
            lineHeight: 6
          };
        },
        restaurantDetails_RestWaitlist_JoinWaitlistText: function restaurantDetails_RestWaitlist_JoinWaitlistText(_ref41) {
          var disabled = _ref41.disabled;
          return {
            color: "white",
            fontSize: "20px",
            fontFamily: "S52-Regular",
            fontWeight: "400",
            _android: {
              py: 2.5,
              px: 2,
              textTransform: "uppercase"
            },
            _ios: {
              py: 2.5,
              px: 2,
              textTransform: "uppercase"
            },
            _web: {
              py: 2.5,
              px: 2,
              textTransform: "uppercase"
            }
          };
        },
        restaurantDetails_RestWaitlist_EstWaitTimeText: function restaurantDetails_RestWaitlist_EstWaitTimeText() {
          return {
            _android: {
              marginTop: 2.5
            },
            _ios: {
              marginTop: 2.5
            },
            lineHeight: 3,
            fontWeight: "300",
            color: "restaurantWaitlistTextColor",
            fontSize: "11",
            textAlign: "center",
            maxWidth: 40,
            _web: {
              maxWidth: 32,
              fontSize: "12px",
              marginTop: {
                base: 2,
                lg: 0
              }
            }
          };
        },
        //Restaurant Timings
        restaurantDetails_RestTimings_TitleText: function restaurantDetails_RestTimings_TitleText() {
          return {
            fontFamily: "S52-Bold",
            fontSize: {
              base: 24,
              lg: 24
            },
            color: "restaurantHoursTextColor"
          };
        },
        restaurantDetails_RestTimings_SpecialDayTitleText: function restaurantDetails_RestTimings_SpecialDayTitleText() {
          return {
            marginBottom: 3,
            color: "restaurantSpecialDayHeadingTextColor",
            fontSize: "16px",
            textAlign: "center",
            px: "3"
          };
        },
        restaurantDetails_RestTimings_SpecialDayDescText: function restaurantDetails_RestTimings_SpecialDayDescText() {
          return {
            fontSize: "14px",
            fontWeight: "300",
            lineHeight: 20,
            color: "restaurantSpecialDayBodyTextColor",
            textAlign: "center"
          };
        },
        restaurantDetails_RestTimings_WeekDayIconText: function restaurantDetails_RestTimings_WeekDayIconText() {
          return {
            lineHeight: 5,
            fontSize: "12px",
            textTransform: "capitalize",
            _ios: {
              paddingTop: 0.5,
              paddingLeft: 0.5
            }
          };
        },
        restaurantDetails_RestTimings_FullDayTitleText: function restaurantDetails_RestTimings_FullDayTitleText() {
          return {
            fontSize: {
              base: "14",
              lg: "16"
            },
            lineHeight: 4,
            color: "restaurantTimingsHeadingTextColor",
            maxWidth: "50%",
            textTransform: "capitalize",
            pr: 1
          };
        },
        restaurantDetails_RestTimings_HoursTitleText: function restaurantDetails_RestTimings_HoursTitleText() {
          return {
            fontSize: {
              base: "14",
              lg: "16"
            },
            lineHeight: 4,
            color: "restaurantTimingsHeadingTextColor",
            maxWidth: "50%",
            pl: 1
          };
        },
        restaurantDetails_RestTimings_FullDayItemText: function restaurantDetails_RestTimings_FullDayItemText() {
          return {
            color: "restaurantTimingsTextColor",
            fontSize: {
              base: "14",
              lg: "16"
            },
            fontWeight: "300",
            maxWidth: "50%",
            pr: 1
          };
        },
        restaurantDetails_RestTimings_HoursItemText: function restaurantDetails_RestTimings_HoursItemText() {
          return {
            color: "restaurantTimingsTextColor",
            fontSize: {
              base: "14",
              lg: "16"
            },
            fontWeight: "300",
            maxWidth: "50%",
            pl: 1
          };
        },
        restaurantDetails_RestTimings_MessageText: function restaurantDetails_RestTimings_MessageText() {
          return {
            color: "restaurantTimingsTextColor",
            fontSize: {
              base: "13",
              lg: "14"
            },
            fontWeight: "100",
            _ios: {
              lineHeight: 5,
              fontSize: 12
            },
            _android: {
              lineHeight: 5,
              fontSize: 12
            }
          };
        },
        restaurantDetails_RestTimings_SpecialHoursText: function restaurantDetails_RestTimings_SpecialHoursText() {
          return {
            fontWeight: 300,
            fontSize: 12,
            color: "#404040",
            fontStyle: "italic"
          };
        },
        //Restaurant About
        restaurantDetails_RestAbout_TitleText: function restaurantDetails_RestAbout_TitleText() {
          return {
            fontFamily: "S52-Bold",
            color: "restaurantAboutSectionHeadingTextColor",
            marginBottom: 4,
            fontSize: 24,
            lineHeight: 6,
            display: {
              base: "flex",
              lg: "none"
            }
          };
        },
        restaurantDetails_RestAbout_DescText: function restaurantDetails_RestAbout_DescText() {
          return {
            color: "restaurantAboutSectionBodyTextColor",
            paddingBottom: 4,
            fontSize: {
              base: 14,
              lg: 16
            },
            fontWeight: "200",
            lineHeight: 5
          };
        },
        //Restaurant Action Buttons
        restaurantDetails_ActionButtons_CTAButtonLabelText: function restaurantDetails_ActionButtons_CTAButtonLabelText() {
          return {
            fontSize: "20px",
            fontFamily: "S52-Regular",
            color: "orderFromHereButtonTextColor",
            textAlign: "center",
            textTransform: "uppercase",
            _web: {
              textTransform: "uppercase"
            }
          };
        },
        //Restaurant Amenities
        restaurantDetails_Amenities_TitleText: function restaurantDetails_Amenities_TitleText() {
          return {
            fontFamily: "S52-Bold",
            paddingBottom: 4,
            fontSize: {
              base: "24px",
              lg: "24px"
            },
            color: "amenitiesHeadingColor",
            display: {
              base: "flex"
            }
          };
        },
        restaurantDetails_Amenities_IconName: {
          fontWeight: 300,
          fontSize: {
            base: "14",
            lg: "16"
          },
          color: {
            base: "#303030",
            lg: "#494949"
          }
        },
        restaurantDetails_Amenities_Description: {
          fontSize: {
            base: 12,
            lg: 14
          },
          fontWeight: "300",
          color: "#606060"
        },
        restaurantDetails_Amenities_Title: {
          fontSize: {
            base: 14,
            lg: 16
          },
          mb: 1,
          color: "#303030"
        },
        //Restaurant Holiday Msg
        restaurantDetails_HolidayMsg_Text: {
          textAlign: "center",
          fontSize: {
            base: "14px"
          },
          color: "#8F2B6D",
          fontWeight: "400",
          maxW: {
            base: "250px",
            md: "350",
            lg: "100%"
          },
          mx: "auto",
          lineHeight: 5
        },
        restDetails_TextMapper_Title: function restDetails_TextMapper_Title() {
          return {
            fontWeight: 400,
            fontSize: 28,
            mb: 4,
            color: "white",
            textAlign: "left"
          };
        },
        restDetails_TextMapper_Description: function restDetails_TextMapper_Description() {
          return {
            fontWeight: 300,
            fontSize: 18,
            color: "white",
            textAlign: "left"
          };
        },
        //Restaurant Order Button
        restaurantDetails_OrderButton_LabelText: function restaurantDetails_OrderButton_LabelText() {
          return {
            _android: {
              paddingY: 5,
              textTransform: "uppercase"
            },
            _ios: {
              paddingY: 5,
              textTransform: "uppercase"
            },
            fontSize: "20px",
            fontFamily: "S52-Regular",
            color: "orderFromHereButtonTextColor",
            textAlign: "center",
            textTransform: {
              base: "uppercase",
              lg: "uppercase"
            }
          };
        },
        restaurantDetails_RestTimings_WeekDay: function restaurantDetails_RestTimings_WeekDay() {
          return {
            color: {
              base: "#303030",
              lg: "restaurantTimingWeekDayTextColor"
            },
            fontSize: {
              base: "12",
              lg: "12"
            },
            position: "absolute"
          };
        },
        locationTitleHeader: function locationTitleHeader() {
          return {
            fontWeight: 500,
            fontSize: 20,
            color: "preferredLocationHeaderTextColor"
          };
        },
        waitlist_leave_the_line_text: function waitlist_leave_the_line_text() {
          return {
            fontSize: 16,
            fontWeight: 300,
            color: "#606060"
          };
        },
        waitlist_leave_the_line_link: function waitlist_leave_the_line_link() {
          return {
            fontSize: 16,
            fontWeight: 400,
            color: "#A2402A"
          };
        },
        reservationConfirmationText: {
          fontWeight: 200
        },
        //LocationSearch Start
        locationSearchHeading: function locationSearchHeading() {
          return {
            fontWeight: 600,
            fontSize: 20,
            fontFamily: "heading",
            color: "locationSearchTitle"
          };
        },
        recentLocationsText: function recentLocationsText() {
          return {
            fontSize: {
              base: 17,
              md: 20
            },
            fontWeight: 500,
            lineHeight: 5
          };
        },
        orderSettingsQuantityText: function orderSettingsQuantityText() {
          return {
            fontSize: "md",
            py: 2,
            px: 5
          };
        },
        sliderTitleText: function sliderTitleText() {
          return {
            fontSize: {
              base: 14
            },
            fontWeight: {
              base: 500
            }
          };
        },
        reorderButtonText: function reorderButtonText() {
          return {
            fontWeight: 500
          };
        },
        desktopBreadcrumbVariant: function desktopBreadcrumbVariant() {
          return {
            fontSize: "sm",
            fontWeight: "500",
            lineHeight: 4,
            letterSpacing: "xs",
            textTransform: "uppercase",
            p: "0",
            m: "0",
            color: "themeTextColor"
          };
        },
        desktopLastBreadcrumbVariant: function desktopLastBreadcrumbVariant() {
          return {
            fontSize: "sm",
            fontWeight: "500",
            lineHeight: 4,
            letterSpacing: "xs",
            textTransform: "uppercase",
            p: "0",
            m: "0",
            color: "themeTextColor"
          };
        },
        numberOfCartItems: function numberOfCartItems() {
          return {
            fontWeight: 500
          };
        },
        restTimingsSplMsg: function restTimingsSplMsg() {
          return {
            fontWeight: 300
          };
        },
        currentlyUnavailableText: function currentlyUnavailableText() {
          return {
            color: "primary.100",
            fontWeight: {
              base: 500
            }
          };
        },
        menuCartHeaderTexLineHeightForApp: {
          lineHeight: 5
        },
        legalDisclaimerText: {
          lineHeight: 5
        },
        scrollingNavigationCarouselItemText: function scrollingNavigationCarouselItemText(_ref42) {
          var isActive = _ref42.isActive;
          return {
            fontWeight: isActive ? 400 : 300
          };
        },
        menuDetailDesciptionMobile: function menuDetailDesciptionMobile() {
          return {
            fontFamily: "Barlow-Regular",
            color: "#989182",
            fontSize: 14
          };
        },
        increaseTextSize: function increaseTextSize(_ref43) {
          var styleSize = _ref43.styleSize;
          return {
            fontSize: styleSize
          };
        },
        nutritionalInfoBottomSheetAllergenInfo: function nutritionalInfoBottomSheetAllergenInfo() {
          return {
            color: "themeGrey",
            fontWeight: "200",
            fontSize: "xs"
          };
        },
        nutritionalInfoBottomSheetQuestion: function nutritionalInfoBottomSheetQuestion() {
          return {
            fontWeight: "300",
            color: "themeGrey",
            fontSize: "sm"
          };
        },
        myReservationCardBottomControlsText: function myReservationCardBottomControlsText() {
          return {};
        },
        quantityText: function quantityText() {
          return {
            fontSize: {
              base: "xs",
              md: "lg"
            },
            fontWeight: 300,
            lineHeight: {
              base: 4,
              md: 5
            },
            letterSpacing: -0.3
          };
        },
        reservationListCardCtaText: function reservationListCardCtaText() {
          return {
            pl: 2,
            fontSize: 14,
            fontWeight: 500,
            color: "#70695C",
            lineHeight: 5
          };
        },
        reservationInfoValue: function reservationInfoValue() {
          return {
            fontWeight: 500,
            fontSize: 12,
            color: "#70695C",
            lineHeight: 5
          };
        },
        reservationInfoKey: function reservationInfoKey() {
          return {
            fontWeight: 400,
            fontSize: 11,
            color: "#989182",
            lineHeight: 5
          };
        },

        /** Text: Private Dining Start */
        privateDiningLocationModalHeaderText: {
          color: "#282C25",
          fontSize: 20,
          fontWeight: 300,
          textAlign: "center"
        },
        privateDiningFilterStateHeading: {
          fontSize: 20,
          color: "#2A2C25",
          fontWeight: 600,
          ml: {
            base: 0,
            md: 4
          },
          mt: {
            base: 4,
            md: 0
          },
          textTransform: "capitalize"
        },
        pd_requestFlow_form_title: function pd_requestFlow_form_title() {
          return {
            pt: {
              base: 5,
              md: 6
            },
            pb: {
              base: 4,
              md: 6
            },
            fontSize: {
              base: 16,
              md: 22
            },
            lineHeight: 6,
            textAlign: "center",
            color: "#70695C"
          };
        },
        pd_requestFlow_form_tabIndex: {
          m: "auto",
          color: "#FFFFFF",
          fontSize: {
            base: "xs",
            md: "md"
          }
        },
        pd_requestFlow_form_tabTitle: function pd_requestFlow_form_tabTitle(_ref44) {
          var isActive = _ref44.isActive,
              isCompleted = _ref44.isCompleted;
          return {
            fontWeight: isActive ? 400 : 200,
            fontSize: {
              base: "sm",
              md: "md"
            },
            color: isActive || isCompleted ? "#282C25" : "#808080"
          };
        },
        pd_request_eventDetails_locationTitle: {
          fontSize: {
            base: "sm",
            md: "md"
          },
          fontWeight: 500,
          mb: 1.5,
          color: "#70695C"
        },
        pd_request_eventDetails_locationAddress: {
          fontSize: {
            base: "xs",
            md: "sm"
          },
          fontWeight: 200,
          lineHeight: 4,
          color: "#989182"
        },
        pd_request_eventDetails_locationPhoneNum: {
          fontSize: {
            base: "xs",
            md: "sm"
          },
          fontWeight: 200,
          color: "#989182"
        },
        pd_request_eventDetails_locationChange: {
          fontSize: 12,
          fontWeight: 300,
          color: "#73994A"
        },
        pd_request_eventDetails_InputTitle: {
          fontSize: "sm",
          fontWeight: 200,
          lineHeight: 4,
          mb: 2,
          color: "#70695C"
        },
        pd_request_eventDetails_noOfGuest_subMessage: {
          fontSize: "sm",
          fontWeight: 200,
          lineHeight: 4,
          color: "#70695C",
          mt: 2
        },
        pd_request_eventDetails_splRequestTitle: {
          fontSize: 16,
          fontWeight: 300,
          lineHeight: 4,
          mr: 3,
          color: "#70695C"
        },
        pd_request_contactDetails_InputTitle: {
          color: "#70695C",
          fontSize: 14,
          mb: 2,
          fontFamily: "Barlow-Regular"
        },
        pd_request_contactDetails_InputTitl_Optional_text: {
          color: "#989182",
          fontSize: 14,
          mb: 2,
          fontFamily: "Barlow-Regular"
        },
        pd_review_details_diresctions_text: {
          fontWeight: 500,
          fontSize: 14
        },
        pd_request_contactDetails_dobTitle: {
          color: "#70695C",
          fontSize: {
            base: 14,
            md: 16
          },
          mr: 2,
          fontFamily: "Barlow-Regular"
        },
        pd_request_contactDetails_dobTooltip: {
          maxWidth: 176,
          color: "#FFFFFF",
          fontSize: 12,
          fontFamily: "Barlow-Regular"
        },
        pd_request_eventDetails_dineInDate_tooltip: {
          maxWidth: 176,
          color: "#FFFFFF",
          fontSize: 12,
          fontFamily: "Barlow-Regular"
        },
        pd_contactDetails_userInfoName: {
          color: "#70695C",
          fontFamily: "Barlow-Bold",
          fontWeight: 500,
          fontSize: {
            base: 14,
            md: 16
          },
          mb: 2
        },
        pd_contactDetails_userInfoExtras: {
          color: "#989182",
          fontFamily: "Barlow-Regular",
          fontSize: {
            base: 12,
            md: 14
          },
          _ios: {
            lineHeight: 14
          },
          _android: {
            lineHeight: 14
          },
          _web: {
            lineHeight: 12
          }
        },
        pd_reviewDetails_title: {
          color: "#989182",
          fontFamily: "Barlow-Regular",
          fontSize: 12
        },
        pd_reveiwDetails_restName: {
          color: "#70695C",
          fontFamily: "Barlow-Bold",
          fontSize: {
            base: 14,
            md: 16
          },
          mb: 1
        },
        pd_reviewDetails_restAddress: {
          color: "#989182",
          fontFamily: "Barlow-Regular",
          fontSize: {
            base: 12,
            md: 14
          }
        },
        pd_reviewDetails_restPhoneNum: {
          color: "#989182",
          fontFamily: "Barlow-Regular",
          fontSize: {
            base: 12,
            md: 14
          }
        },
        pd_reviewDetails_eventInfoTitle: {
          color: "#989182",
          fontFamily: "Barlow-Regular",
          fontSize: 12,
          _web: {
            lineHeight: 12
          },
          mb: 2
        },
        pd_reviewDetails_eventInfoData: {
          color: "#70695C",
          fontFamily: "Barlow-Bold",
          fontSize: {
            base: 14,
            md: 16
          },
          _web: {
            lineHeight: 12
          }
        },
        pd_reviewDetailsSplReqTitle: {
          color: "#70695C",
          fontSize: 14,
          fontWeight: 500,
          lineHeight: 15,
          fontFamily: "Barlow-Medium",
          mb: 2
        },
        pd_reviewDetailsSplReqData: {
          color: "#989182",
          fontSize: 14,
          fontFamily: "Barlow-Regular",
          fontWeight: 400
        },
        pd_confirmation_title: {
          color: "#73994A",
          fontSize: 16,
          maxW: {
            md: "354px"
          },
          textAlign: "center",
          fontWeight: 600
        },
        pd_confirmation_emailText: {
          color: "#505050",
          fontFamily: "Barlow-Regular",
          fontSize: 14
        },
        pd_confirmation_email: {
          color: "#303030",
          textAlign: "center",
          fontSize: 14,
          mt: 1
        },
        pd_confirmation_salesMessage: {
          color: "#505050",
          fontFamily: "Barlow-Regular",
          fontSize: 14,
          maxW: {
            md: "387px"
          },
          textAlign: "center"
        },
        pd_confirmation_restPhoneNum: {
          color: "#73994A",
          fontSize: 14,
          fontFamily: "Barlow-Medium",
          fontWeight: 400
        },
        pd_cancelModalMessage: {
          fontSize: 16,
          lineHeight: 5,
          textAlign: "center",
          color: "#70695C",
          fontFamily: "Barlow-Regular"
        },
        pd_cancelModalCancelCTAText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          textAlign: "center",
          color: "#73994A",
          fontFamily: "Barlow-Regular"
        },
        pd_cancelModalCancelConfirmText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          textAlign: "center",
          color: "#FFFFFF",
          fontFamily: "Barlow-Regular"
        },
        pd_request_eventDetails_dineInDate_subMessage: {
          fontSize: "xs",
          fontWeight: 200,
          lineHeight: 4,
          color: "#989182",
          fontFamily: "Barlow-Regular",
          mr: 2
        },
        pd_landing_stickyContainer_label: {
          fontSize: {
            base: "xs",
            md: "md"
          },
          fontWeight: 300,
          color: "#838383",
          lineHeight: 5,
          textAlign: {
            base: "center",
            md: "start"
          },
          mt: {
            base: 1,
            lg: 0
          },
          maxWidth: {
            base: 80,
            md: "360px"
          },
          wordBreak: "break-word"
        },
        pd_landing_makeAReq_ctaText: {
          color: "#FFFFFF",
          textTransform: "uppercase",
          fontSize: {
            base: "sm",
            md: "xl"
          },
          lineHeight: 6
        },
        pd_landing_menuTabs_itemLabel: function pd_landing_menuTabs_itemLabel(_ref45) {
          var isActive = _ref45.isActive;
          return {
            textTransform: "uppercase",
            color: isActive ? "#FFFFFF" : "#838383",
            fontSize: 16,
            fontWeight: 500,
            lineHeight: 6
          };
        },
        pd_landing_dropdown_activeLable: function pd_landing_dropdown_activeLable(_ref46) {
          var isActive = _ref46.isActive;
          return {
            fontSize: "md",
            fontWeight: 500,
            lineHeight: 6,
            color: isActive ? "#838383" : "#FFFFFF",
            textTransform: "uppercase"
          };
        },
        pd_landing_home_subText: {
          color: "themeGrey",
          fontWeight: 300
        },
        pd_landing_home_activeText: {
          color: "primary.100",
          textTransform: "uppercase",
          fontSize: {
            base: 22,
            md: 45
          },
          fontWeight: 500
        },
        pd_landing_locationHeaderName: {
          pb: 1,
          fontSize: 16,
          fontWeight: 300,
          color: "#838383",
          textTransform: "capitalize"
        },
        pd_landing_locationHeaderChangeLoc: {
          fontSize: 16,
          color: "#73994A",
          fontWeight: 600,
          textTransform: "capitalize"
        },
        pd_landing_eventGuideCTA_text: {
          fontWeight: 400,
          color: "#73994A",
          fontSize: 16
        },
        pd_landing_floorPlanLink_text: {
          textAlign: "center",
          mt: 3,
          fontSize: 14,
          fontWeight: 300,
          color: "#73994A"
        },
        pd_landing_floorPlan_viewGalleryLink: {
          color: "#73994A",
          fontSize: {
            base: 14,
            lg: 20
          },
          fontWeight: 500
        },

        /** Text: Private Dining End */
        eClub_newsTextHeading: {
          textAlign: "center",
          fontWeight: 500,
          color: "#70695C",
          fontSize: 24,
          width: "70%",
          lineHeight: 8
        },
        eClub_newsTextSubHeading: {
          textAlign: "center",
          fontWeight: 600,
          color: "#70695C",
          fontSize: 14,
          width: "70%",
          lineHeight: 8,
          letterSpacing: "-0.3"
        },
        eClub_smsText: {
          fontWeight: 200,
          color: "#70695C",
          fontSize: 14
        },
        eClub_smsTextFooterText: {
          textAlign: "center",
          fontWeight: 200,
          color: "#70695C",
          fontSize: {
            base: "xs",
            md: "sm"
          },
          lineHeight: 4,
          w: {
            base: "100%",
            md: "70%"
          }
        },
        eClub_smsTextFooterLegalNoticeText: {
          textAlign: "center",
          fontWeight: 200,
          color: "#70695C",
          fontSize: {
            base: "xs",
            md: "sm"
          },
          lineHeight: 4,
          w: {
            base: "100%",
            md: "70%"
          }
        },
        eClub_TnCs_Text: {
          marginBottom: 3,
          fontWeight: 200,
          fontSize: 14,
          lineHeight: 4
        },
        eClub_TnCs_privacy_policy_text: {
          fontWeight: 200,
          color: "primary.100",
          fontSize: 14,
          lineHeight: 4,
          underline: true
        },
        eClubStickyCancelPressableText: {
          textTransform: "uppercase",
          color: "secondary.300",
          textAlign: "center",
          fontSize: 16
        },
        eclub_selected_restaurant_name: {
          fontWeight: 400
        },
        eclub_changeLocationCTAText: {
          fontWeight: 400
        },
        reservationSeatingOptionText: {},
        myAccount_mobileHeader_text: {
          color: "#2A2C25",
          fontSize: 18,
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "normal"
        },
        order_history_details_order_number_text: {
          color: "secondary200Mobile"
        },
        passwordFooter_passiveText: {
          fontSize: 12,
          color: "mobileResetPasswordText",
          fontWeight: 400,
          lineHeight: 5
        },
        passwordFooter_activeText: {
          fontSize: 12,
          lineHeight: 5,
          color: "mobileAuthFooterActiveText",
          fontWeight: 400
        },
        orderHistory_reorderText: {
          color: "secondary.300",
          fontSize: 16,
          fontWeight: 400
        },
        noPrefLocationScreen_description: {
          fontSize: "16px",
          textAlign: "center",
          color: "#606060",
          fontWeight: "300"
        },
        noPrefLocationScreen_btn_text: {
          fontWeight: "400",
          color: "white",
          letterSpacing: "0.31"
        },
        joinEClubHeading: {
          fontWeight: 700,
          textAlign: "center",
          color: "#70695C",
          fontSize: {
            base: 24,
            md: 42
          },
          width: "auto",
          lineHeight: 8,
          fontFamily: "S52-Bold"
        },
        joinEClubSubHeading: {
          fontWeight: 200,
          color: "#70695C",
          fontSize: 16,
          textAlign: "center",
          mt: 4
        },
        myAccount_paymentOptions_noSavedCards_title: {
          fontSize: 18,
          fontWeight: 400
        },
        myAccount_paymentOptions_savedGiftCards_title: {
          fontSize: 14,
          color: "#70695C"
        },
        myAccount_paymentOptions_savedCreditCards_title: {
          fontSize: 14,
          color: "#70695C"
        },
        myAccount_paymentOptions_deleteGiftCard_modalBodyText: {
          fontWeight: 300,
          fontSize: 18,
          lineHeight: 6,
          letterSpacing: -1,
          textAlign: "center",
          mb: 3,
          color: "#70695C"
        },
        myAccountConfirmationHeadTitle: {
          fontSize: 20,
          fontWeight: 400,
          my: 3,
          textAlign: "center",
          letterSpacing: "-0.1",
          color: "#70695C"
        },
        myAccountConfirmationHeadSubText: {
          color: "#989182",
          fontSize: 16,
          fontWeight: 300,
          my: 2,
          textAlign: "center",
          lineHeight: 5,
          maxWidth: 337
        },
        addEditCCTitle: {
          textAlign: "center",
          fontSize: 20,
          lineHeight: 6,
          color: "#fff"
        },
        myAccount_paymentOptions_modalWrapperHeader_text: {},
        addEditCreditCard_add_pressable_text: {
          marginTop: 5,
          marginBottom: 4,
          fontSize: 16,
          lineHeight: 6,
          textAlign: "center",
          color: "addCardFooterButtonText",
          textTransform: "uppercase"
        },
        gc_refreshBalance_cta_text: {
          color: "gcBalanceRefreshBorderTextColor",
          fontWeight: 400
        },
        myAccount_orderHistoryDetailsHeader_text: {
          color: "orderHistoryModalHeaderTextColor"
        },

        /** Text: Private Dining End */
        reservationLocationSelectCTAText: {
          fontSize: 12,
          fontWeight: 400
        },
        reorderNonLoggedInText: {
          fontSize: 16,
          fontWeight: 500
        },
        reservationCheckboxText: {
          fontWeight: 300
        },
        reservationStaticLinkText: {
          fontWeight: 500,
          color: "primary.100"
        },
        sectionHeaderLongDescription: {
          fontSize: ["sm", "sm", "md"],
          color: "categoriesHeadingColor"
        },
        reservationConfirmModalBodyText: {
          fontSize: 16,
          lineHeight: 5,
          textAlign: {
            md: "center"
          }
        },
        eClubConfirmationThanksDesc: {
          display: "none"
        },
        editProfileFullBottomButtonText: {
          fontSize: 16
        },
        dateTimePickerModalTitle: {
          display: "none"
        }
      }
    },
    HStack: {
      variants: {
        // My Account
        myAccountLocationCardHStack: {
          alignItems: "center",
          px: 4,
          py: 5,
          borderRadius: 0,
          borderColor: "#DCDCDC",
          borderWidth: 1
        },
        myAccount_infoList_changeEmail_container: {
          px: 4,
          mb: 3,
          alignItems: "center",
          flexDirection: "row",
          justifyContent: "space-between",
          py: {
            base: 4,
            md: 5
          },
          backgroundColor: {
            base: "myAccountCardBackground",
            md: "#F6F6F6"
          },
          borderRadius: 0,
          _web: {
            w: {
              base: "100%",
              md: "48%"
            }
          }
        },
        // My Account

        /* RESERVATION */
        joinWaitlist_Header_Container: function joinWaitlist_Header_Container() {
          return {
            _ios: {
              height: 20
            },
            _android: {
              height: 20
            },
            justifyContent: "center",
            alignItems: "center",
            w: "100%",
            borderBottomWidth: 1,
            borderBottomColor: "#FFFFFF",
            bg: "#FFFFFF"
          };
        },
        reservationConfirmationDateTimeSizeHStack: {
          justifyContent: "flex-start",
          alignItems: "flex-start",
          mr: 1,
          flex: 1
        },
        reservationConfirmationDateTimeSizeContainer: {
          pt: 4,
          px: 3,
          justifyContent: "space-between"
        },
        reservationLookUpSuccessHStack: function reservationLookUpSuccessHStack(_ref47) {
          var isError = _ref47.isError;
          return {
            justifyContent: "center",
            space: 2,
            alignItems: "center",
            py: 2,
            my: 2,
            bg: isError ? "#DF450530" : "#F3EDDF",
            maxW: {
              md: "340px"
            },
            w: "100%",
            borderRadius: 0
          };
        },
        reservationLocationCardHStack: {
          my: 4,
          mx: 5,
          alignItems: "center",
          px: 4,
          py: 3,
          borderRadius: 0,
          shadow: 10,
          bg: "white"
        },
        reservationLocationItemHStack: {
          justifyContent: "space-between",
          alignItems: "flex-start",
          borderBottomWidth: 1,
          borderTopWidth: {
            base: 0,
            md: 1
          },
          borderLeftWidth: {
            base: 0,
            md: 1
          },
          borderRightWidth: {
            base: 0,
            md: 1
          },
          borderRadius: 0,
          borderColor: "#DEDEDE",
          py: {
            base: 6,
            md: 4
          },
          px: {
            base: 0,
            md: 4
          },
          m: {
            base: 0,
            md: 4
          }
        },
        reservationProfileCardHStack: {
          my: 4,
          _ios: {
            paddingX: 4
          },
          _android: {
            paddingX: 4
          },
          borderRadius: 0,
          shadow: 10,
          bg: {
            base: "white",
            md: "transparent"
          }
        },
        reservationProfileCardLoggedInHStack: {
          alignItems: "center",
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          _web: {
            justifyContent: "space-between",
            w: "100%",
            px: 4
          },
          my: 3,
          bg: "white"
        },

        /* RESERVATION */
        //JWC START
        jwcFooterBlock: {
          py: 2,
          bg: "white",
          borderRadius: 12,
          borderColor: "#C6C6C6",
          borderWidth: 1
        },
        jwcLocationHeaderBlock: {
          py: 5,
          px: 6,
          borderRadius: 12,
          bg: "white",
          borderColor: "transparent",
          borderWidth: 1
        },
        //JWC END
        header: {
          bg: "themeTextColor"
        },
        checkoutBtn: {
          alignItems: "center",
          justifyContent: "space-around",
          _web: {
            height: "60px"
          },
          py: 3,
          px: 5,
          rounded: 0
        },
        scheduledOrderForm: {
          alignItems: "center",
          width: "100%",
          rounded: 6,
          _ios: {
            borderWidth: 1
          },
          _android: {
            borderWidth: 1
          },
          _web: {
            borderWidth: "1px"
          },
          borderColor: "themeTextFieldBoundary",
          pl: 3,
          mb: 4
        },
        menuDetailIsUnavailable: function menuDetailIsUnavailable(_ref48) {
          var isSelected = _ref48.isSelected;
          return {
            bg: "#E5E5E5",
            borderColor: "themeSectionSeparator",
            shadow: 5,
            overflow: "hidden"
          };
        },
        listItemBox: {
          borderRadius: 0
        },
        //Restaurant Details
        restaurantDetails_Index_RestAbout_HStack: {
          mt: "10",
          space: {
            lg: "md",
            xl: "2xl"
          }
        },
        restaurantDetails_Amenities_AmenitiesIcons_HStack: {
          alignItems: "center"
        },
        restaurantDetails_CurrentStatus_Icon_HStack: {
          alignItems: "center",
          justifyContent: "center",
          _web: {
            justifyContent: {
              base: "center",
              lg: "normal"
            }
          }
        },
        restaurantDetails_RestInfo_AddToFavourites_HStack: {
          alignItems: "center",
          mb: "6"
        },
        restaurantDetails_RestInfo_StarIcon_HStack: {
          alignItems: "center"
        },
        restaurantDetails_RestTime_HStack: {
          alignItems: "center",
          mb: "4"
        },
        restaurantDetails_RestTime_HoursLegend_HStack: {
          mr: "0",
          ml: "auto",
          justifyContent: "center"
        },
        restaurantDetails_RestTimings_WeekDaysIcon_HStack: {
          mb: 9,
          space: 1,
          justifyContent: "space-between"
        },
        restaurantDetails_RestTimings_SelectedDay_HStack: {
          mb: 4,
          space: 1,
          justifyContent: "space-between"
        },
        restaurantDetails_RestTimings_List_HStack: {
          marginBottom: 3,
          justifyContent: "space-between"
        },
        restaurantDetails_Waitlist_Party_HStack: {
          justifyContent: "center",
          alignItems: "center",
          mb: {
            base: 5
          }
        },
        restaurantDetails_Waitlist_Button_HStack: {
          justifyContent: "center"
        },
        //Order Tracking
        orderTrackingPayNowButtonHStack: {
          bgColor: "payNowButtonBg",
          px: 5,
          py: 3,
          borderRadius: "md",
          alignItems: "center",
          justifyContent: "space-between"
        },
        orderTrackingCallHelpHStack: {
          py: 4,
          px: 5,
          _web: {
            minHeight: "68px",
            bottom: 0
          },
          bgColor: "background.100",
          borderTopColor: "borderColorCallSection",
          borderTopWidth: 1,
          alignItems: "center",
          justifyContent: "space-between",
          mt: "auto"
        },
        borderRadiusValue: function borderRadiusValue(_ref49) {
          var radiusValue = _ref49.radiusValue,
              topRadiusValue = _ref49.topRadiusValue,
              bottomRadiusValue = _ref49.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },
        menuDetailArrowPosition: {
          mt: 1.5
        },
        menuDetailPropertyAccordionDescriptionTile: {
          mt: {
            base: 1.5,
            md: 1
          }
        },

        /* HStack: Private Dining Start */
        pd_Header_Container: function pd_Header_Container() {
          return {
            _ios: {
              height: 20
            },
            _android: {
              height: 20
            },
            justifyContent: "center",
            alignItems: "center",
            w: "100%",
            borderBottomWidth: 1,
            borderBottomColor: "#D6D6D6"
          };
        },
        privateDiningLocationItemHStack: {
          justifyContent: "space-between",
          alignItems: "flex-start",
          borderBottomWidth: 1,
          borderTopWidth: {
            base: 0,
            md: 1
          },
          borderLeftWidth: {
            base: 0,
            md: 1
          },
          borderRightWidth: {
            base: 0,
            md: 1
          },
          borderRadius: 0,
          borderColor: "#DEDEDE",
          py: {
            base: 6,
            md: 4
          },
          px: {
            base: 0,
            md: 4
          },
          m: {
            base: 0,
            md: 4
          }
        },
        pd_request_eventDetails_inputContainer: function pd_request_eventDetails_inputContainer(_ref50) {
          var errorMessage = _ref50.errorMessage,
              isActive = _ref50.isActive;
          return {
            py: 4,
            px: 3,
            alignItems: "center",
            borderWidth: 1,
            borderRadius: 0,
            borderColor: errorMessage ? "#D30000" : isActive ? "#73994A" : "#DDDDDD",
            bgColor: "white"
          };
        },
        pd_request_eventDetails_selectTime_container: {
          marginTop: 2,
          marginBottom: 1,
          marginX: 5,
          borderColor: "#DEDEDE",
          borderWidth: 1,
          paddingY: 4,
          alignItems: "center",
          justifyContent: "space-between",
          borderRadius: 0
        },
        pd_request_contactDetails_userInfo: {
          borderWidth: 1,
          borderRadius: 0,
          borderColor: "#DDD",
          p: 4,
          bg: "white"
        },
        pd_landing_menuTabs_container: {
          alignItems: "center",
          justifyContent: "space-between",
          bg: "#FFFFFF",
          flex: 1
        },
        pd_landing_menuDropdown_summary: function pd_landing_menuDropdown_summary(_ref51) {
          var isExpanded = _ref51.isExpanded;
          return {
            p: 5,
            flexGrow: 1,
            alignItems: "center",
            justifyContent: "space-between",
            borderBottomColor: isExpanded ? "#E0DED8" : "transparent",
            borderBottomWidth: 1
          };
        },
        pd_landing_eventGuideCTA_body: {
          alignItems: "center",
          justifyContent: "center",
          space: {
            base: 3,
            lg: 4
          },
          py: 2.5,
          bg: "#FFFFFF"
        },
        pd_landing_floorPlanLinksSection: {
          py: {
            lg: 5
          },
          alignItems: "center",
          justifyContent: "center"
        },

        /* HStack: Private Dining End */
        eClub_smsTextHStack: {
          w: {
            base: "100%",
            md: "70%"
          },
          alignItems: "center",
          mt: 4,
          mb: 8,
          borderRadius: 10,
          borderWidth: 1,
          borderColor: "#E9E9E9",
          shadow: 10,
          bg: "white",
          zIndex: 1
        },
        orderHistoryDetails_basicDetails_HStack: {
          p: 3,
          bg: "background.100",
          alignItems: "center",
          mb: 2
        }
      }
    },
    Flex: {
      variants: {
        orderConfirmationflex: {
          _web: {
            flexDirection: {
              base: "column-reverse",
              lg: "row"
            }
          },
          alignItems: "flex-start"
        }
      }
    },
    Image: {
      variants: {
        pdRequestPageBg: {
          display: "inherit"
        },
        cartItemImage: {
          _web: {
            height: {
              base: "71px"
            },
            width: {
              base: "100px"
            }
          },
          height: 70,
          width: 100
        },
        menu_item_card_vertical_image_border_radius: 0,
        //Restaurant Details
        restaurantDetails_RestInfo_Mob_Image: {
          h: "98px",
          w: "98px",
          resizeMode: "cover",
          _web: {
            h: {
              base: "97px",
              lg: "210px"
            },
            w: {
              base: "97px",
              lg: "220px"
            }
          }
        },
        restaurantDetails_RestInfo_ImageLg: {
          h: "98px",
          w: "98px",
          resizeMode: "cover",
          _web: {
            h: {
              base: "97px",
              lg: "89px"
            },
            w: {
              base: "97px",
              lg: "94px"
            }
          }
        },
        restaurantDetails_RestInfo_FavoriteIconLg: {
          height: "16px",
          width: "16px"
        },
        restaurantDetails_RestInfo_BrandIcon: {
          borderRadius: 10
        },
        restaurantDetails_RestInfo_BrandIconLg: {
          borderRadius: 10
        },
        //Edit Waitlist
        editWaitlist_LocationHeader_Icon: {
          _web: {
            width: 4,
            height: 5
          }
        },
        rd_spl_hours_legend: {
          width: "11px",
          height: "11px",
          mr: "1"
        },
        rd_spl_hours_icon: {
          width: "11px",
          height: "11px",
          top: 0,
          right: 0,
          position: "absolute"
        },
        //location search page
        location_search_exclamation_icon: {
          display: "none"
        },
        borderRadiusValue: function borderRadiusValue(_ref52) {
          var radiusValue = _ref52.radiusValue,
              topRadiusValue = _ref52.topRadiusValue,
              bottomRadiusValue = _ref52.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },
        favorite_pin_fill_brand_icon: function favorite_pin_fill_brand_icon(_ref53) {
          var active = _ref53.active;
          return {
            height: active ? 4 : 3,
            width: active ? 4 : 3
          };
        },
        //cart overlay
        cart_overlay_pickup_date_brand_icon: {
          _web: {
            height: 5,
            width: 5
          },
          height: 20,
          width: 20,
          mr: 0
        },
        cart_overlay_pickup_time_brand_icon: {
          height: 20,
          width: 20,
          _web: {
            height: 5,
            width: 5
          },
          mr: 0
        },
        pd_select_restaurant_brand_logo: {
          height: "32px",
          width: "138px"
        }
      }
    },
    Input: {
      baseStyle: {
        rounded: 0,
        fontFamily: "Barlow-Regular"
      },
      variants: {
        menuSearchInputContainer: {
          borderRadius: 0
        },
        borderRadiusValue: function borderRadiusValue(_ref54) {
          var radiusValue = _ref54.radiusValue,
              topRadiusValue = _ref54.topRadiusValue,
              bottomRadiusValue = _ref54.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },

        /** Input: Private Dining Start */
        pd_request_eventDetails_noOfGuestinput: {
          borderRadius: 0,
          fontFamily: "Barlow-Regular"
        },
        pd_request_eventDetails_SplRequest: {
          borderRadius: 0
        },
        pd_request_contactDetails_input: {
          borderRadius: 0,
          fontFamily: "Barlow-Regular"
        },

        /** Input: Private Dining End */
        myAccountInputForm: {
          fontFamily: "Barlow-Regular"
        }
      }
    },
    VStack: {
      variants: {
        jwcWaitTimeBlock: {
          p: 3,
          px: 6,
          bg: "white",
          borderRadius: 12,
          borderColor: "#C6C6C6",
          borderWidth: 1
        },
        addToCartContainer: {
          w: {
            base: "76px",
            md: "120px"
          }
        },
        indicatorsContainer: {
          flex: 1
        },
        //Restaurant Details
        restaurantDetails_Index_RestInfo_VStack: {
          space: "xs"
        },
        restaurantDetails_Index_RestAbout_VStack: {
          mx: {
            lg: "60px"
          }
        },
        restaurantDetails_Index_RestAbout_InnerVStack: {
          flex: {
            lg: 4,
            xl: 1
          },
          space: "2xs"
        },
        restaurantDetails_Index_BrandFooter_VStack: {
          overflowX: "hidden"
        },
        restaurantDetails_ActionButtons_VStack: {
          space: "md"
        },
        restaurantDetails_RestInfo_StarIcon_VStack: {
          space: 4,
          justifyContent: "center",
          flex: 1,
          direction: "column-reverse"
        },
        //order tracking
        orderTrackingRefreshButtonVStack: {
          borderColor: "refreshButtonColor",
          borderWidth: 1,
          borderRadius: 6,
          py: 2,
          px: 1,
          space: 1.5,
          alignItems: "center",
          bg: "refreshButtonBg"
        },
        orderTrackingAutoRefreshVStack: {
          borderColor: "orderStatusSectionBorderColor",
          borderWidth: 1,
          borderRadius: 6,
          py: 2.5,
          px: 4,
          space: 1.5,
          alignItems: "center",
          bg: "refreshButtonBg"
        },
        nutritionalInfoVStack: {
          mt: {
            base: 2,
            md: 3
          },
          mb: "2",
          alignItems: "flex-start",
          width: "100%",
          _web: {
            width: {
              base: "100%",
              md: "100%",
              lg: "966px"
            }
          }
        },
        vstackBorderBottomRadius: {
          borderBottomRadius: 0
        },

        /** VStack: Private Dining Start */
        pd_requestForm_Tabs_Container: {
          bgColor: {
            base: "#F9F7F0",
            md: "#FFFFFF"
          },
          borderBottomWidth: 1,
          borderBottomColor: "#D6D6D6",
          borderTopRadius: {
            base: 0,
            md: 12
          }
        }
        /** VStack: Private Dining End */

      }
    },
    Box: {
      variants: {
        menuCardShadow: {
          shadow: 0
        },
        // My Account
        myAccountDesktop_container: {
          width: {
            md: "100%",
            lg: 980,
            xl: 1200
          },
          h: 700,
          overflow: "clip",
          rounded: 0,
          bg: "white",
          shadow: 2,
          mx: "auto",
          my: 5
        },
        myAccountDesktop_headerBox: {
          py: 6,
          px: 10,
          borderBottomWidth: 1,
          borderBottomColor: "#EDEDED"
        },
        myAccountDesktop_container_leftSection: {
          borderRightWidth: 1,
          minW: 272,
          borderRightColor: "#EDEDED",
          overflow: "auto",
          mb: 20
        },
        myAccount_editProfile_infoCard: {
          px: {
            base: 5,
            md: 8
          },
          mb: {
            base: 8,
            md: 2
          },
          paddingY: 5,
          bg: "white",
          mt: 1
        },
        myAccount_orderHistoryItem_header: {
          backgroundColor: "mobileOrderHistoryItemCardHeaderBackgroundColor",
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          padding: 3,
          paddingRight: 4,
          borderTopRadius: 0,
          overflow: "hidden"
        },
        myAccount_paymentOptions_container: {
          paddingBottom: 5,
          backgroundColor: "white",
          _android: {
            flex: 1
          },
          _ios: {
            flex: 1
          },
          _web: {
            height: "100%",
            bg: {
              base: "myAccountScreenBackroundColor",
              md: "white"
            }
          }
        },
        myAccount_check_icon_container: {
          justifyContent: "center",
          alignItems: "center",
          rounded: "full",
          bg: "white",
          border: 2,
          borderColor: "#54301A",
          w: "90px",
          h: "90px",
          mb: 12,
          mx: "auto"
        },
        myAccount_edit_field_sheet_title_wrapper: {
          bg: "white",
          rounded: 0,
          flexDirection: "row",
          justifyContent: "center",
          width: "100%"
        },
        myAccount_profile_icon_container: {
          size: 75,
          overflow: "hidden",
          borderRadius: 100,
          borderWidth: 6,
          borderColor: "ProfilePictureCircleBorderColor",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "displayImageFallbackBackground"
        },
        myAccount_paymentOptions_cardDetails_container: {
          py: 3,
          backgroundColor: "paymentOptionsHeaderColor",
          borderBottomWidth: 1,
          borderColor: "paymentOptionsBorderColor",
          _web: {
            marginX: {
              base: 0,
              md: 5
            }
          }
        },
        myAccount_paymentOptions_giftCards_AddCardButton: {
          py: 1.5,
          px: 3
        },
        myAccount_paymentOptions_gc_isRefershing: {
          position: "absolute",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          justifyContent: "center",
          alignItems: "center",
          bg: "gcBalanceRefreshBackdropColor"
        },
        myAccount_paymentOptions_gc_bottomSheet_title: {
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 5,
          pt: 0,
          px: 5,
          _web: {
            width: "100%"
          }
        },
        myAccount_paymentOptions_gc_bottomSheet_content: {
          width: "100%",
          px: 4,
          pt: 7,
          _web: {
            px: {
              base: 4,
              md: 0
            }
          }
        },
        myAccount_paymentOptions_gc_bottomSheet_gcContainer: {
          mb: 5,
          _web: {
            width: {
              base: "100%",
              md: "70%"
            },
            alignSelf: "center",
            px: {
              base: 0,
              md: 4
            }
          }
        },
        myAccount_order_history_order_details_modal_header: {
          position: "relative",
          alignItems: "center",
          justifyContent: "center",
          py: 4,
          w: "100%"
        },
        myAccount_order_history_title_wrapper: {
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          px: 5,
          pt: 5,
          mb: 2
        },
        myAccount_add_edit_credit_card_wrapper: {
          paddingX: 4,
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          _web: {
            paddingX: {
              base: 4,
              md: 9
            }
          },
          justifyContent: "space-between"
        },
        myAccount_add_gift_card_actionsheet_wrapper: {
          alignItems: "center",
          paddingLeft: 0,
          paddingTop: 0,
          bg: "#F6F6F6"
        },
        myAccount_add_gift_card_action_sheet_save_for_future_use_wrappper: {
          width: "100%",
          paddingX: 5,
          alignItems: "flex-start",
          justifyContent: "center"
        },
        myAccount_paymentOptions_gcl_isRefershing: {
          position: "absolute",
          width: "100%",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
          bg: "gcBalanceRefreshBackdropColor"
        },
        myAccount_paymentOptions_gc_bs_delete_container: {
          bg: "white",
          py: 3.5,
          alignItems: "flex-end",
          px: 6
        },
        myAccount_paymentOptions_addGC_addSheet_addContainer: {
          width: "100%",
          _android: {
            pb: 1,
            pt: 2
          },
          _ios: {
            marginTop: 6,
            pt: 2
          },
          paddingX: 5,
          alignItems: "center",
          bg: {
            base: "#F6F6F6",
            md: "white"
          },
          _web: {
            py: {
              base: 5,
              md: 3.5
            },
            paddingX: {
              base: 5,
              md: 12
            }
          },
          flexDirection: "row"
        },
        myAccount_paymentOptions_showCC_BS_titleBox: {
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 5,
          pt: 0,
          px: 5,
          _web: {
            width: "100%"
          }
        },
        myAccount_security_question_wrapper: {
          px: 5
        },
        myAccount_updatedQuestion_defaultItemContainer: {
          flexDirection: "row",
          justifyContent: "space-between",
          borderBottomColor: "securityQuestionMenuColor",
          py: 2,
          mb: 12,
          borderBottomWidth: 1
        },
        myAccount_userInfoCard_container: {
          px: 5,
          py: 5,
          flexDirection: "row",
          alignItems: "flex-start"
        },
        myAccount_editField_saveErrorMessage: {
          borderRadius: 0,
          mt: 3,
          py: 3,
          px: 5,
          mx: 5,
          border: 1,
          bg: "red.200",
          borderColor: "red.300"
        },
        myAccount_fallBackPictureBackground_Box: {
          height: "100%",
          width: "100%",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "displayImageFallbackBackground",
          _web: {
            backgroundColor: "#DCDCDC"
          }
        },
        // My Account ends

        /*RESERVATION*/
        reservationConfirmationDateTimeSizeBox: {
          flex: 1,
          alignItems: "flex-start"
        },
        reservationConfirmationBoxBorderRadius: {
          borderRadius: 0
        },
        reservationConfirmationDetailsBox: {
          borderRadius: 0,
          my: {
            base: 6,
            md: 0
          },
          py: {
            base: 5,
            md: 6
          },
          borderTopWidth: 1,
          borderColor: "#0000001a"
        },
        reservationProfileInputBox: {
          pl: {
            base: 4,
            md: 5
          },
          pr: 4,
          bg: "white",
          _web: {
            pb: 9
          },
          borderRadius: 0
        },
        reservationProfileContactDetailsBox: {
          py: 3,
          flex: 1,
          my: 3
        },
        reviewReservationsContainerBox: {
          mt: 8,
          alignItems: "center",
          px: 4,
          _web: {
            bg: {
              base: "reservationBg",
              md: "myReservationsBoxBg"
            },
            maxW: {
              md: "680px"
            },
            py: 8,
            mt: {
              base: 8,
              md: 16
            },
            px: {
              base: 5,
              md: 24
            },
            mb: {
              base: 8,
              md: 16
            }
          }
        },
        reservationDropdownRadius: 0,
        reservationLocationDropdownSelectBox: {
          borderWidth: 1,
          borderRadius: 0,
          width: {
            base: "100%",
            md: "400px"
          },
          borderColor: "#DEDEDE"
        },
        reservationLocationDropdownBox: {
          bg: "#F9F7F0",
          py: 4,
          justifyContent: "center",
          px: {
            base: 6,
            md: 16
          }
        },
        reservationAvailableTimeSlotBtnBox: {
          _web: {
            width: 24,
            py: 2
          },
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "row",
          borderRadius: 0,
          _ios: {
            width: 24,
            height: 10
          },
          _android: {
            width: 24,
            height: 10
          }
        },
        reservationAvailableTimeSlotsBox: {
          borderWidth: 1,
          _ios: {
            py: 3
          },
          _android: {
            py: 3
          },
          _web: {
            py: 4,
            px: 3
          },
          w: "100%",
          mt: 4,
          borderRadius: 0,
          bg: "white"
        },
        reservationTabsBtn: function reservationTabsBtn(_ref55) {
          var isActive = _ref55.isActive;
          return {
            minW: {
              base: "167px",
              md: "191px"
            },
            px: 1,
            h: {
              base: "38px",
              md: "42px"
            },
            bg: isActive ? "reservationBg" : "primary.100"
          };
        },

        /*RESERVATION*/
        rd_spl_hours_icon: {
          width: 11,
          height: 11,
          top: 0,
          right: 0,
          position: "absolute"
        },
        rd_spl_hours_legend: {
          width: 11,
          height: 11,
          mr: 1
        },
        indicatorBanner: {
          fontFamily: "Barlow-Medium"
        },
        jwcHowItWorksBox: {
          borderBottomWidth: 1,
          borderBottomColor: {
            base: "#A2402A",
            lg: "white"
          }
        },
        checkinSuccessNote: {
          bg: "#A9AD00",
          px: 9,
          py: 6,
          borderRadius: 12,
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        },
        onboardingScreenTextContainer: {
          top: "71%"
        },
        locationDropdownRadius: 0,
        emptyCartModalRadius: 8,
        appMessagesSuccessDialogBorderRadius: 0,
        sectionHeaderBottomSpace: function sectionHeaderBottomSpace(_ref56) {
          var hasSub = _ref56.hasSub;
          return {
            mb: {
              base: hasSub && -0.5,
              md: hasSub && -1
            }
          };
        },
        HomeScreenCTAflex: {
          flexDirection: "column-reverse"
        },
        configOptionBox: {
          borderRadius: 0
        },
        configOptionBoxWithMAPPWidth: {
          borderRadius: 0,
          _ios: {
            minWidth: 72
          },
          _android: {
            minWidth: 72
          }
        },
        sliderItemBox: {
          borderRadius: {
            base: 8
          }
        },
        brandLogoMobileDimensions: function brandLogoMobileDimensions() {
          return {
            _ios: {
              height: 12,
              width: 40
            },
            _android: {
              height: 12,
              width: 40
            },
            _web: {
              height: "50px",
              width: "166px"
            }
          };
        },
        menuDetailDesciption: function menuDetailDesciption() {
          return {
            fontFamily: "Barlow-Regular",
            color: "#989182",
            _web: {
              fontSize: {
                base: "14px",
                md: "16px"
              }
            },
            fontSize: {
              base: 3,
              md: 4
            }
          };
        },
        menuCardBodyPrice: {
          bottom: 0
        },
        temperatureSlider: function temperatureSlider() {
          return {
            bg: "E9E9E9",
            _web: {
              height: {
                base: "360px"
              },
              pb: 5
            },
            height: 400,
            pb: 10
          };
        },
        categoryActiveBorder: {
          borderBottomWidth: 3
        },
        tempDescriptionBox: function tempDescriptionBox(_ref57) {
          var isChild = _ref57.isChild;
          return {
            px: {
              base: 3,
              md: isChild ? 3 : 5
            },
            py: 5,
            borderLeftRadius: 0,
            borderRightRadius: {
              base: 0,
              md: isChild ? 0 : 0
            },
            bg: "white",
            shadow: 11,
            _web: {
              width: {
                base: "177px",
                md: isChild ? "177px" : "325px"
              }
            }
          };
        },
        selectLocationDropDownBox: {
          ml: {
            base: 0,
            md: 8
          },
          mt: {
            base: 3,
            md: 0
          },
          alignItems: "center",
          justifyContent: "center",
          borderWidth: 1,
          borderRadius: 0,
          _web: {
            width: {
              base: "100%",
              md: "335px"
            }
          },
          borderColor: {
            base: "allLocationsSelectBorderColorMobile",
            md: "allLocationsSelectBorderColorDesktop"
          }
        },
        locationCard: function locationCard(_ref58) {
          var isFromLocationSearchPage = _ref58.isFromLocationSearchPage;
          return {
            borderBottomWidth: 1,
            borderWidth: {
              base: 0,
              md: 1
            },
            borderColor: "allLocationsItemBoxBorderColor",
            borderRadius: 0,
            p: {
              base: 0,
              md: 1
            },
            mt: {
              base: 0,
              md: 4
            },
            mr: {
              base: 0,
              md: isFromLocationSearchPage ? "2%" : 8
            },
            _web: {
              minWidth: {
                base: "100%",
                md: "300px"
              }
            },
            width: isFromLocationSearchPage ? "48%" : "40%",
            bg: "#ffffff"
          };
        },
        listCard: {
          borderRadius: 8,
          position: "relative",
          pt: {
            base: 3
          },
          pb: {
            base: "14px"
          },
          px: {
            base: 3
          },
          p: {
            lg: 5
          }
        },
        headerCaretIconMobile: function headerCaretIconMobile() {
          return {
            mb: 0
          };
        },
        searchItemCardContainer: function searchItemCardContainer() {
          return {
            width: "100%",
            pr: 4,
            borderBottomWidth: 1,
            borderColor: "#EAEAEA"
          };
        },
        searchModalMenuCategoryListBox: function searchModalMenuCategoryListBox(_ref59) {
          var isMobile = _ref59.isMobile;
          return {
            borderRadius: !isMobile ? 12 : 0
          };
        },
        //Restaurant Details start
        restaurantDetails_Index_Map_Box: {
          flex: 1
        },
        restaurantDetails_Index_RestInfo_Box: {
          flex: 1,
          borderBottomColor: "#D6D6D6",
          borderBottomWidth: "1px"
        },
        restaurantDetails_Index_RestInfo_InnerBox: {
          px: 8
        },
        restaurantDetails_Index_CurrentStatus_Box: function restaurantDetails_Index_CurrentStatus_Box(_ref60) {
          var hideWaitlistSection = _ref60.hideWaitlistSection;
          return {
            px: 8,
            mb: hideWaitlistSection ? 0 : 10
          };
        },
        restaurantDetails_Index_WaitList_Box: {
          position: "relative",
          h: "auto"
        },
        restaurantDetails_Index_Divider_Box: {
          px: 6
        },
        restaurantDetails_Index_Amenities_Box: {
          pt: 4
        },
        restaurantDetails_Index_RestTime_Box: {
          flex: {
            lg: 5,
            xl: 1
          }
        },
        restaurantDetails_Index_RestTime_Mob_Box: {
          position: "relative",
          h: "auto"
        },
        restaurantDetails_Index_ActionButtons_Box: {
          flex: {
            lg: 3,
            xl: 1
          },
          pr: 2
        },
        restaurantDetails_Index_Mob_OrderButton_Box: function restaurantDetails_Index_Mob_OrderButton_Box(_ref61) {
          var isSticky = _ref61.isSticky;
          return {
            py: 4,
            px: isSticky ? 4 : 0,
            backgroundColor: "#F9F7F0"
          };
        },
        restaurantDetails_Index_Mob_RestAbout_Box: {
          h: "auto"
        },
        restaurantDetails_ActionButtons_ViewMenu_Box: function restaurantDetails_ActionButtons_ViewMenu_Box(_ref62) {
          var isMobile = _ref62.isMobile,
              singleActionButton = _ref62.singleActionButton;
          return {
            px: 4,
            _web: {
              display: "grid"
            },
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "space-between",
            style: {
              "grid-template-columns": "1fr",
              "column-gap": "10px"
            }
          };
        },
        restaurantDetails_ActionButtons_ViewMenu_InnerBox: {
          _web: {
            mb: {
              base: 3,
              lg: 4
            }
          }
        },
        restaurantDetails_Amenities_IconBox: {
          alignItems: "center",
          flexWrap: "wrap",
          flexDirection: "row"
        },
        restaurantDetails_Amenities_Box: {
          px: {
            base: 4,
            lg: 6
          }
        },
        restaurantDetails_CurrentStatus_Icon_Box: {
          mr: 4
        },
        restaurantDetails_CurrentStatus_Mob_Divider_Box: {
          mt: 4,
          alignItems: "center"
        },
        restaurantDetails_HolidayMsg_Box: {
          px: {
            base: 2,
            lg: 3
          },
          py: 3,
          bg: "#FFFFFF"
        },
        restaurantDetails_Map_Box: {
          height: "140px",
          position: "relative"
        },
        restaurantDetails_OrderButtonSection_Box: function restaurantDetails_OrderButtonSection_Box(_ref63) {
          var isInStack = _ref63.isInStack;
          return {
            px: isInStack ? 0 : 4,
            _web: {
              mb: isInStack ? {
                base: 3,
                lg: 4
              } : 0
            },
            alignItems: "center"
          };
        },
        restaurantDetails_RestAboutSection_Box: {
          px: "6",
          py: {
            base: "6",
            lg: "0"
          }
        },
        restaurantDetails_RestInfo_Outer_ImageBox: {
          position: "relative",
          bg: {
            base: "restaurantDetailsRestInfoBoxBackgroundColor",
            lg: "white"
          }
        },
        restaurantDetails_RestInfo_Mob_StarIcon_Box: {
          m: "auto"
        },
        restaurantDetails_RestInfo_Box: {
          width: "100%",
          alignItems: {
            base: "center",
            lg: "flex-start"
          },
          position: "relative"
        },
        restaurantDetails_RestInfo__Box: {
          width: "100%",
          alignItems: {
            base: "center",
            lg: "flex-start"
          },
          position: "relative"
        },
        restaurantDetails_RestInfo_PhoneNum_Box: {
          mb: {
            base: 4,
            lg: 0
          },
          flexDirection: "row",
          justifyContent: {
            base: "space-evenly",
            lg: "flex-start"
          },
          alignItems: {
            base: "center"
          }
        },
        restaurantDetails_RestInfo_PhoneNum_InnerBox: {
          alignItems: "center",
          flexDirection: "row"
        },
        restaurantDetails_RestTime_Box: {
          px: "4",
          py: {
            base: "4",
            lg: "0"
          }
        },
        restaurantDetails_RestTime_RestClosed_Box: {
          my: 5
        },
        restaurantDetails_RestInfo_ImageBox: {
          backgroundColor: "restaurantImageBorderColor",
          borderColor: "restaurantImageBorderColor",
          borderWidth: 6,
          position: "absolute",
          zIndex: 1,
          alignSelf: "center",
          shadow: 11,
          _web: {
            alignSelf: {
              base: "center",
              lg: "left"
            }
          },
          top: {
            base: "-50px",
            lg: "-150px"
          },
          overflow: "hidden"
        },
        restaurantDetails_RestInfo_ImageLgBox: {
          backgroundColor: "restaurantImageBorderColor",
          borderColor: "restaurantImageBorderColor",
          borderWidth: 6,
          shadow: 11,
          mr: 6
        },
        restaurantDetails_CurrentStatusAndWaitlist_Box: {
          py: "5",
          px: {
            base: "4",
            lg: "8"
          },
          backgroundColor: {
            base: "white",
            lg: "#F4F4F4"
          },
          borderRadius: "12"
        },
        restaurantDetails_CurrentStatus_Box: {
          pt: {
            base: "5",
            lg: "0"
          },
          px: {
            base: "4",
            lg: "0"
          },
          backgroundColor: "white"
        },
        restaurantDetails_Waitlist_Box: {
          pt: {
            base: 7,
            lg: 9
          },
          pb: {
            base: 8,
            lg: 10
          },
          bg: {
            base: "#ffffff",
            lg: "none"
          }
        },
        restaurantDetails_WaitlistAlready_Box: {
          pt: {
            base: 7,
            lg: 9
          },
          mb: {
            base: 8,
            lg: 10
          },
          bg: {
            base: "#ffffff",
            lg: "none"
          }
        },
        restaurantDetails_RestTimings_Divider: {
          marginBottom: 4
        },
        restDetails_TextMapper_Container: {
          py: 16,
          px: {
            base: "60",
            lg: "116"
          },
          bg: "#ffffff"
        },
        //Location search
        tabLocationsTopWidth: 0,
        locationSearchActiveTab: function locationSearchActiveTab(_ref64) {
          var isActive = _ref64.isActive;
          return {
            height: "4px",
            bg: isActive ? "locationSearchActiveTab" : "transparent",
            w: "100%",
            borderTopRadius: "8px"
          };
        },
        borderRadiusValue: function borderRadiusValue(_ref65) {
          var radiusValue = _ref65.radiusValue,
              topRadiusValue = _ref65.topRadiusValue,
              bottomRadiusValue = _ref65.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },
        homeScreenAlertHeadingWrapper: function homeScreenAlertHeadingWrapper(_ref66) {
          var isSmallScreen = _ref66.isSmallScreen;
          return {
            height: isSmallScreen ? 6 : 7,
            mr: 1
          };
        },
        menu_detail_divider: {
          mb: 5
        },
        boxBorderRadius: {
          borderRadius: 0
        },
        desktopBreadcrumbCaret: function desktopBreadcrumbCaret() {
          return {
            height: 2.5,
            width: 1,
            ml: 2.5,
            mr: 3,
            mb: 1,
            alignItems: "center"
          };
        },
        countLabelContainer: function countLabelContainer(_ref67) {
          var isIOS = _ref67.isIOS;
          return {
            _text: {
              color: "white",
              fontSize: 12,
              _android: {
                pb: 0.5
              }
            }
          };
        },
        categoryBox: {
          mb: {
            md: 8,
            base: 3
          }
        },
        mobileGiftCardBrandLogo: {
          height: 40,
          width: 57
        },
        smartRecommendationModalHeadingContainer: {
          flex: 1
        },

        /** Box: Private Dining Start */
        privateDiningDropdownRadius: 6,
        privateDiningLocationDropdownSelectBox: {
          borderWidth: 1,
          borderRadius: 0,
          width: {
            base: "100%",
            md: "400px"
          },
          borderColor: "#DEDEDE"
        },
        privateDiningLocationDropdownBox: {
          bg: "#F9F7F0",
          h: {
            base: "72px",
            md: "82px"
          },
          justifyContent: "center",
          px: {
            base: 6,
            md: 16
          }
        },
        pd_makeRequest_container: {
          width: {
            base: "100%",
            md: "794"
          },
          m: {
            md: "auto"
          },
          my: {
            md: 6
          },
          minH: {
            md: "543"
          },
          bg: {
            base: "#F6F6F6",
            md: "white"
          },
          borderRadius: 0,
          borderColor: "#D6D6D6",
          borderWidth: {
            base: 0,
            md: 1
          }
        },
        pd_requestFlow_form_tabActiveBorder: function pd_requestFlow_form_tabActiveBorder(_ref68) {
          var isActive = _ref68.isActive;
          return {
            mt: {
              base: 3,
              md: 4
            },
            height: 1,
            bgColor: isActive ? "requestFormTabActiveItem" : "transparent",
            w: "100%",
            borderTopRadius: 0
          };
        },
        pd_request_eventDetails_locationDetails: {
          py: {
            base: 3,
            md: 4
          },
          px: {
            base: 3,
            md: 4
          },
          borderRadius: 0,
          borderWidth: 1,
          borderColor: "#DEDEDE",
          bgColor: "white"
        },
        pd_actionSheetBorderRadius: 0,
        pd_reviewDetails_container: {
          borderWidth: 1,
          borderRadius: 0,
          borderColor: "#DDD",
          p: 4,
          bg: "white"
        },
        pd_confirmationText_Container: {
          rounded: 0,
          border: 1,
          borderColor: "#DCDCDC",
          py: 5,
          px: {
            base: 4,
            md: "56px"
          },
          bg: "white",
          alignItems: "center"
        },
        pd_reviewDetails_messageRegardingRequest: {
          display: "none"
        },
        pd_request_contactDetails_specialReq: {
          mt: 5
        },
        pd_requestFlow_form_tabBG: function pd_requestFlow_form_tabBG(_ref69) {
          var isActive = _ref69.isActive;
          return {
            bgColor: isActive ? "requestFormTabActiveItem" : "requestFormTabDisableItem"
          };
        },
        pd_landing_eventGuideContainer: {
          width: "100%",
          px: {
            base: 5,
            lg: "115px"
          },
          mb: {
            base: 10,
            lg: "80px"
          },
          mt: {
            base: 4,
            lg: "0px"
          }
        },
        pd_landing_menuDropdown: function pd_landing_menuDropdown(_ref70) {
          var isExpanded = _ref70.isExpanded;
          return {
            p: 0,
            bgColor: isExpanded ? "#FFFFFF" : "#73994A",
            _hover: {
              bg: isExpanded ? "#FFFFFF" : "#73994A"
            },
            _expanded: {
              bg: isExpanded ? "#FFFFFF" : "#73994A"
            }
          };
        },

        /** Box: Private Dining End */
        eClubSignUpBox: {
          borderRadius: 0,
          borderWidth: 1,
          borderColor: "#E7E7E7",
          bg: "white",
          mt: 10,
          px: {
            base: 4,
            md: 8
          },
          py: 8,
          w: {
            base: "100%",
            md: "60%"
          },
          alignSelf: "center"
        },
        eClubNewsBox: {
          borderRadius: 10,
          bg: "white",
          w: {
            base: "100%",
            md: "60%"
          },
          mt: 10,
          py: {
            base: 4,
            md: 10
          },
          px: 4,
          alignItems: "center",
          shadow: 10
        },
        eClubConfirmationBox: {
          bg: "white",
          px: 10,
          py: 10,
          w: "50%",
          border: 1,
          borderColor: "#D6D6D6",
          alignItems: "center"
        },
        eClub_Building_Box: {
          w: "100%",
          h: 600,
          bg: "#F6F6F6"
        },
        eClubUnsubscribeContainer: {
          bg: "white",
          rounded: "md",
          p: 5,
          my: 10,
          shadow: 2,
          mx: {
            base: 10,
            md: "auto"
          }
        },
        myAccount_editFields_actionSheet_webBox: {
          pt: 2,
          pb: 7,
          bg: "#F6F6F6"
        },
        myAccount_orderHistoryDetails_actionSheet_webBox: {
          pb: 7
        },
        addCreditCard_securityBanner_ContainerBox: {
          paddingTop: 4,
          paddingX: 5,
          paddingBottom: 4,
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: "row",
          backgroundColor: "#F9F7F0",
          borderTopWidth: 1,
          borderBottomWidth: 1,
          borderColor: "#EAEAEA",
          accessible: false,
          _web: {
            marginBottom: {
              base: 3,
              md: 6
            },
            paddingX: {
              base: 5,
              md: 9
            },
            paddingY: 3
          }
        },
        giftCardContainer_Box: function giftCardContainer_Box(_ref71) {
          var radiusValue = _ref71.radiusValue;
          return {
            _ios: {
              bg: {
                linearGradient: {
                  colors: ["mobileGiftCardGradientFirst", "mobileGiftCardGradientSecond"],
                  start: [0, 0],
                  end: [1, 0]
                }
              }
            },
            _android: {
              bg: {
                linearGradient: {
                  colors: ["mobileGiftCardGradientFirst", "mobileGiftCardGradientSecond"],
                  start: [0, 0],
                  end: [1, 0]
                }
              }
            },
            _web: {
              style: {
                background: "linear-gradient(91.85deg, #AAC191 0%, #73994A 100%)"
              }
            },
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0,
            pt: 1
          };
        },
        editProfileScreens_Box: {
          _android: {
            flex: 1
          },
          _ios: {
            flex: 1
          },
          backgroundColor: "#F6F6F6",
          _web: {
            height: "100%",
            overflowY: "auto",
            backgroundColor: "transparent"
          }
        },
        myAccount_orderHistoryItem_orderDetails_Box: {
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          paddingLeft: 3,
          paddingRight: 4,
          paddingTop: 3,
          paddingBottom: 4,
          justifyContent: "center"
        },
        orderHistoryEmptyScreen_Box: {
          flex: 1,
          justifyContent: "center",
          bg: {
            base: "mobileOrderHistoryBackgroundColor",
            md: "#FFFFFF"
          }
        },
        orderHistory_screenContainer_box: {
          _android: {
            flex: 1
          },
          _ios: {
            flex: 1
          },
          _web: {
            height: "100%"
          },
          bg: {
            base: "mobileOrderHistoryBackgroundColor",
            md: "white"
          },
          px: {
            base: 0,
            md: 6
          }
        },
        giftCardLarge_brandIcon_Box: {
          mb: 4,
          height: 59,
          width: 149,
          _web: {
            height: "90px",
            width: "140px"
          }
        },
        addGiftCard_actionSheetTitle: {
          flexDirection: "row",
          justifyContent: "center",
          width: "100%"
        },
        myAccount_editDetails_editMail: {
          mx: 4,
          px: {
            base: 0,
            md: 5
          },
          pt: 4
        },
        paymentOptions_giftCardLarge_deleteCTA: {},
        myAccount_editDetails_changeDOB: {
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          backgroundColor: "editProfileScreensBackgroundColor",
          _web: {
            pt: {
              base: 5,
              md: 0
            },
            backgroundColor: "transparent",
            height: "100%"
          }
        },
        eClubBGGradient_box: {// empty
        }
      }
    },
    View: {
      variants: {
        // My Account Starts
        myAccount_orderHistoryCard_container: {
          marginX: 2,
          marginTop: 2,
          marginBottom: 3,
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          borderRadius: 0,
          backgroundColor: "white",
          shadow: 4
        },
        myAccount_paymentOptions_giftCards_iconWarpper: {
          paddingY: 2,
          marginRight: 5
        },
        // My Account Ends
        confirmationCardLayout: function confirmationCardLayout() {
          return {
            borderRadius: 0
          };
        },
        borderRadiusValue: function borderRadiusValue(_ref72) {
          var radiusValue = _ref72.radiusValue,
              topRadiusValue = _ref72.topRadiusValue,
              bottomRadiusValue = _ref72.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },
        myAccountConfirmationViewContainer: function myAccountConfirmationViewContainer(_ref73) {
          var isMobile = _ref73.isMobile;
          return {
            bg: "#FFFFFF",
            rounded: 0,
            shadow: isMobile ? null : 2,
            my: 8,
            paddingY: 5
          };
        },
        myAccountConfirmationHeadContainer: {
          bg: "#F8F7F6",
          rounded: 0,
          padding: 7,
          mt: {
            md: 5
          },
          mx: {
            base: "auto",
            md: 67
          },
          mb: {
            base: 4,
            md: 2
          }
        }
      }
    },
    Alert: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref74) {
          var radiusValue = _ref74.radiusValue,
              topRadiusValue = _ref74.topRadiusValue,
              bottomRadiusValue = _ref74.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        }
      }
    },
    Menu: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref75) {
          var radiusValue = _ref75.radiusValue,
              topRadiusValue = _ref75.topRadiusValue,
              bottomRadiusValue = _ref75.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        }
      }
    },
    ActionsheetContent: {
      variants: {
        topRounded: {},
        myAccount_editFields_actionSheetContent: {
          padding: 0,
          bg: "white"
        },
        myAccount_orderHistoryDetails_actionSheetContent: {
          padding: 0,
          bg: "white"
        },
        payments_addGiftCard_actionSheetContent: {
          height: "max-content",
          padding: 0
        },
        myAccount_paymentOptions_giftCardDetails_actionSheetContent: {}
      }
    },
    PopoverContent: {
      variants: {
        popoverRadius: function popoverRadius(_ref76) {
          var radiusValue = _ref76.radiusValue;
          return {
            borderRadius: 0
          };
        },

        /** PopoverContent: Private Dining Start */
        pd_request_eventDetails_purposDropdown: {
          top: {
            md: 20
          },
          bg: "#ffffff",
          maxH: "235px",
          overflowY: "auto",
          borderRadius: 0,
          borderColor: "#E4E4E4"
        },
        pd_request_eventDetails_timeDropdown: {
          bg: "#ffffff",
          maxH: "235px",
          overflowY: "auto",
          borderRadius: 0,
          shadow: 10,
          borderColor: "transparent"
        },
        pd_request_eventDetails_partySizeDropdown: {
          bg: "#ffffff",
          maxH: "235px",
          overflowY: "auto",
          borderRadius: 0,
          borderColor: "#E4E4E4"
        },
        pd_request_eventDetails_menuPrefDropdown: {
          top: {
            md: 20
          },
          bg: "#ffffff",
          maxH: "235px",
          overflowY: "auto",
          borderRadius: 0,
          borderColor: "#E4E4E4"
        },
        pd_request_contactDetails_dopTooltip: {
          backgroundColor: "#706A5E",
          borderRadius: 0
        },
        pd_request_contactDetails_phoneType: {
          borderRadius: 0,
          py: 6,
          px: 4,
          bg: "white",
          top: 2,
          shadow: 13,
          border: "none"
        }
        /** PopoverContent: Private Dining End */

      }
    },
    Switch: {
      baseStyle: {
        thumbColor: "#FFFFFF",
        onTrackColor: "primary.100"
      }
    },
    Select: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref77) {
          var radiusValue = _ref77.radiusValue,
              topRadiusValue = _ref77.topRadiusValue,
              bottomRadiusValue = _ref77.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },
        paymentOptions_addEditCC_addressDetails: {
          w: "100%",
          borderRadius: 0
        }
      }
    },
    Spinner: {
      variants: {
        paymentOptions_addGiftCard_checkBalanceSpinner: {
          my: 3.5,
          _web: {
            mt: {
              base: 5,
              md: 4
            },
            mb: {
              base: 5,
              md: 4
            }
          },
          color: "#BBBBBB",
          size: "sm"
        },
        paymentOptions_addGiftCard_addCardSpinner: {
          my: 3.5,
          _web: {
            mt: {
              base: 5,
              md: 4
            },
            mb: {
              base: 5,
              md: 4
            }
          },
          color: "#FFFFFF",
          size: "sm"
        }
      }
    },
    Checkbox: {
      variants: {
        eclub_restaurantOptions: {
          alignItems: "flex-start"
        }
      }
    }
  },
  fontConfig: {
    Barlow: {
      100: {
        normal: "Barlow-Light",
        italic: "Barlow-LightItalic"
      },
      200: {
        normal: "Barlow-Light",
        italic: "Barlow-LightItalic"
      },
      300: {
        normal: "Barlow-Regular",
        italic: "Barlow-Regular"
      },
      400: {
        normal: "Barlow-Medium",
        italic: "Barlow-MediumItalic"
      },
      500: {
        normal: "Barlow-Bold",
        italic: "Barlow-BoldItalic"
      },
      600: {
        normal: "Barlow-SemiBold",
        italic: "Barlow-SemiBoldItalic"
      },
      700: {
        normal: "Barlow-ExtraBold",
        italic: "Barlow-ExtraBoldItalic"
      }
    },
    S52: {
      100: {
        normal: "S52-Regular",
        italic: "S52-Regular"
      },
      200: {
        normal: "S52-Regular",
        italic: "S52-Regular"
      },
      300: {
        normal: "S52-Regular",
        italic: "S52-Regular"
      },
      400: {
        normal: "S52-Regular",
        italic: "S52-Regular"
      },
      500: {
        normal: "S52-Regular",
        italic: "S52-Regular"
      },
      600: {
        normal: "S52-Regular",
        italic: "S52-Regular"
      },
      700: {
        normal: "S52-Regular",
        italic: "S52-Regular"
      },
      800: {
        normal: "S52-Bold",
        italic: "S52-Bold"
      }
    }
  },
  fonts: {
    heading: "Barlow",
    body: "Barlow",
    headingSecondary: "Barlow",
    youMightLikeText: "Barlow-Bold",
    s52: "S52"
  },
  config: {
    // Changing initialColorMode to 'dark'
    initialColorMode: "light"
  }
}; // extend the theme

export var theme = extendTheme(_objectSpread(_objectSpread({}, baseTheme), config));